var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-88"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-88",
    cx: 250,
    cy: 353.87,
    rx: 235.52,
    ry: 135.98,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-88"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-88",
    points: "424.52 359.2 466.7 334.83 409.38 301.77 367.2 326.14 424.52 359.2",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-88",
    d: "M91.47,444.08a9.69,9.69,0,0,1-1.55,3.62,17.12,17.12,0,0,1-5.83,5.18c-10.09,5.82-26.46,5.82-36.56,0a17.12,17.12,0,0,1-5.83-5.18,9.83,9.83,0,0,1-1.54-3.62h0c-.9-4.38,1.57-8.94,7.38-12.3,10.1-5.84,26.47-5.84,36.56,0C89.91,435.14,92.37,439.7,91.47,444.08Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-88",
    d: "M426.16,420a22.35,22.35,0,0,1-3.54,8.25c-2.85,4.3-7.3,8.34-13.3,11.81-23,13.29-60.35,13.29-83.37,0-6-3.47-10.44-7.51-13.3-11.81a22.64,22.64,0,0,1-3.52-8.25h0c-2.05-10,3.58-20.4,16.84-28.06,23-13.3,60.35-13.3,83.37,0C422.59,399.64,428.21,410.06,426.16,420Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-88",
    d: "M363.45,274.57,343,262.79a4.83,4.83,0,0,0-4.41,0l-256.28,148a1.35,1.35,0,0,0,0,2.55l20.62,12a4.81,4.81,0,0,0,4.4,0l43.37-25.09a18.77,18.77,0,0,0,1.92,1.27l33.21,19.18a32,32,0,0,0,29.44,0l64.09-37c4.76-2.75,7.49-6.85,7.49-11.24s-2.73-8.5-7.49-11.25l-30.63-17.68,114.7-66.37A1.35,1.35,0,0,0,363.45,274.57Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.48,296c-2.23,3.4-5.53,6.47-7.72,10.53-3.28,6.08-6.23,12.85-5.79,17.84l0,.51h0l-.38,7.68-.05,1-1.82-1.05L458.24,330c-1.25-7.14-2.61-16.95-.72-27.82,1.75-10,7.74-19.12,15.63-20.26C482.27,280.57,482.77,289.43,478.48,296Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.68,329.67a.35.35,0,0,0,.22-.37c-2.32-18.58,6.35-35.71,14.12-41.91a.35.35,0,0,0,.06-.5.36.36,0,0,0-.5-.06c-7.9,6.3-16.73,23.72-14.39,42.55a.36.36,0,0,0,.4.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.63,307.73c-.61,3.6-7.15,7.83-11.47,13.66-3.9,5.27-5.6,10.61-5.46,13.45h0l-2.17-1.25-1.82-1.05c-1-13.17,2.17-19.56,6.13-24.91a15.6,15.6,0,0,1,7-5.41C481.53,300.48,484.37,303.41,483.63,307.73Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.65,332.51a.35.35,0,0,0,.21-.32c.23-15.1,8.88-23.32,13.42-25.56a.35.35,0,0,0,.16-.48A.35.35,0,0,0,478,306c-5,2.48-13.59,10.78-13.82,26.19a.36.36,0,0,0,.35.36A.33.33,0,0,0,464.65,332.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--boxes--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-88"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.98 355.27 423.98 327.02 460.68 305.84 460.68 334.08 423.98 355.27",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.98 327.02 373.23 297.76 373.23 326 423.98 355.27 423.98 327.02",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.98 327.02 461.76 305.2 409.92 275.3 372.14 297.13 423.98 327.02",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.98 327.02 423.98 334.08 461.76 312.27 461.76 305.2 423.98 327.02",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.14 297.13 423.98 327.02 423.98 334.08 372.14 304.19 372.14 297.13",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,334.09v1.55l36.69-21.19V312.9Zm-50.75-27.72L424,335.64v-1.55l-50.75-29.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.06,331.32l12.54-7.24c.54-.31,1-.06,1,.56v7.42a2.15,2.15,0,0,1-1,1.69L436.06,341c-.54.31-1,.05-1-.57V333A2.16,2.16,0,0,1,436.06,331.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.06,331.32l12.54-7.24c.54-.31,1-.06,1,.56v7.42a2.15,2.15,0,0,1-1,1.69L436.06,341c-.54.31-1,.05-1-.57V333A2.16,2.16,0,0,1,436.06,331.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.86,332.16l10.93-6.31c.36-.21.65,0,.65.37v5.56a1.44,1.44,0,0,1-.65,1.13l-10.93,6.31c-.36.21-.65,0-.65-.38v-5.55A1.45,1.45,0,0,1,436.86,332.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437.17,333.62a.14.14,0,0,1-.14-.08.15.15,0,0,1,.06-.21l10.32-6a.17.17,0,0,1,.22.06.18.18,0,0,1-.06.22l-10.32,6A.12.12,0,0,1,437.17,333.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M437.17,335a.16.16,0,0,1-.14-.08.16.16,0,0,1,.06-.22l10.32-6a.18.18,0,0,1,.22.06.17.17,0,0,1-.06.22l-10.32,6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M437.17,336.35a.16.16,0,0,1-.14-.08.15.15,0,0,1,.06-.21l10.32-6a.17.17,0,0,1,.22.06.16.16,0,0,1-.06.21l-10.32,6A.12.12,0,0,1,437.17,336.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M437.17,337.72a.16.16,0,0,1-.08-.3l10.32-6a.18.18,0,0,1,.22.06.17.17,0,0,1-.06.22l-10.32,5.95A.13.13,0,0,1,437.17,337.72Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-88"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "375.15 295.38 426.1 324.76 460.86 304.68 409.92 275.3 375.15 295.38",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-88"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "426.41 322.53 426.41 294.29 463.1 273.1 463.1 301.35 426.41 322.53",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.41 294.29 375.65 265.02 375.65 293.27 426.41 322.53 426.41 294.29",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.41 294.29 464.19 272.46 412.34 242.57 374.56 264.39 426.41 294.29",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.41 294.29 426.41 301.35 464.19 279.54 464.19 272.46 426.41 294.29",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.56 264.39 426.41 294.29 426.41 301.35 374.56 271.45 374.56 264.39",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.41,301.35v1.55l36.69-21.18v-1.56Zm-50.76-27.71L426.4,302.9v-1.55l-50.76-29.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.48,298.58,451,291.34c.54-.31,1-.06,1,.57v7.41a2.16,2.16,0,0,1-1,1.69l-12.54,7.24c-.54.31-1,.06-1-.57v-7.41A2.15,2.15,0,0,1,438.48,298.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.48,298.58,451,291.34c.54-.31,1-.06,1,.57v7.41a2.16,2.16,0,0,1-1,1.69l-12.54,7.24c-.54.31-1,.06-1-.57v-7.41A2.15,2.15,0,0,1,438.48,298.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.29,299.42l10.93-6.31c.36-.21.65,0,.65.38V299a1.44,1.44,0,0,1-.65,1.13l-10.93,6.31c-.36.21-.65,0-.65-.38v-5.55A1.44,1.44,0,0,1,439.29,299.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M439.59,300.89a.17.17,0,0,1-.14-.08.17.17,0,0,1,.06-.22l10.32-6a.17.17,0,0,1,.22.06.16.16,0,0,1-.06.22l-10.32,6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M439.59,302.25a.17.17,0,0,1-.14-.08.16.16,0,0,1,.06-.21l10.32-6a.15.15,0,0,1,.22.06.15.15,0,0,1-.06.21l-10.32,6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M439.59,303.62a.17.17,0,0,1-.14-.08.17.17,0,0,1,.06-.22l10.32-6a.16.16,0,1,1,.16.28l-10.32,5.95A.11.11,0,0,1,439.59,303.62Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M439.59,305a.16.16,0,0,1-.08-.3l10.32-5.95a.16.16,0,1,1,.16.27l-10.32,6Z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293,438.39a1,1,0,0,1-.59.81l-5.16,2.67a1.45,1.45,0,0,0-.61,1.92,9.37,9.37,0,0,1,.5,1.4,2.33,2.33,0,0,0,1.68,1.62l1.3.21,2.21-1.14a1,1,0,0,0,.58-.84h0Zm-40.21,2.44c-6,2.49-8.16,7-5.59,10.74a12.3,12.3,0,0,1,5.5-4.07c7-2.89,16.47-2,21.23,2a9.84,9.84,0,0,1,1.62,1.72c1.87-2.71,1.46-5.86-1.54-8.38C269.22,438.83,259.72,437.93,252.76,440.83Zm44,8.32a1.89,1.89,0,0,1-.07.39l-1.15,3.6a2,2,0,0,1-1.86,1.34l-7.31-.22a2.91,2.91,0,0,0-1.14.25,3.69,3.69,0,0,0-1.23.8,18.55,18.55,0,0,1-1.77,1.61,1.26,1.26,0,0,0-.2,1.89l2.5,2.69a2.84,2.84,0,0,1,.63-.31h0a2.87,2.87,0,0,1,1.13-.24l7.31.21a2,2,0,0,0,1.86-1.34l1.14-3.6a1.18,1.18,0,0,0,.07-.41h0Zm-59.3-9h0a1,1,0,0,0,.3.73l.36.4a2.76,2.76,0,0,0,.61-.48,17.24,17.24,0,0,1,1.77-1.6,1.27,1.27,0,0,0,.2-1.9l-2.86-3.09a1,1,0,0,1-.3-.58Zm47.75,22.44a1,1,0,0,1-.68.87l-6.42,2.67a2.84,2.84,0,0,1-1.67.1,2.18,2.18,0,0,1-.84-.33l-4.26-2.84a3.9,3.9,0,0,0-2.57-.49c-1.37.25-2.76.44-4.15.57a2.72,2.72,0,0,0-1.39.6,2.24,2.24,0,0,0-.69.79l-1.63,3.16a2.32,2.32,0,0,1-1.18,1,2,2,0,0,1-.9.14l-8-.75a1.38,1.38,0,0,1-1.22-1.57l.41-3.08a1.75,1.75,0,0,0-1.18-1.82,30.25,30.25,0,0,1-3.32-1.2,4.33,4.33,0,0,0-2.64-.14l-.07,0-6.17,2a2.77,2.77,0,0,1-1.56,0,2.34,2.34,0,0,1-.89-.45l-4-3.39a1,1,0,0,1-.39-.7l-.09,6.64a1,1,0,0,0,.4.72l4,3.41a2.74,2.74,0,0,0,1.69.55,1.45,1.45,0,0,0,.36,0h.06a1.37,1.37,0,0,0,.34-.07l6.17-2,.07,0a4.33,4.33,0,0,1,2.64.15,28.82,28.82,0,0,0,3.31,1.2,1.73,1.73,0,0,1,.83.58l-.06,4.52a1.35,1.35,0,0,0,1.23,1.36l8,.76a2.19,2.19,0,0,0,.9-.15,2.61,2.61,0,0,0,.52-.28,2.43,2.43,0,0,0,.25-.2s0,0,0,0a1.12,1.12,0,0,0,.18-.2,2,2,0,0,0,.17-.23l0-.08,1.63-3.16a1.11,1.11,0,0,1,.17-.27c0-.06.1-.12.15-.18a2.47,2.47,0,0,1,.37-.35,2.79,2.79,0,0,1,1.4-.59c1.38-.13,2.77-.31,4.14-.57a4,4,0,0,1,2.57.49l4.27,2.84a2.28,2.28,0,0,0,.83.31h0l.21.05a3.57,3.57,0,0,0,1,0,.8.8,0,0,0,.21-.05,1.29,1.29,0,0,0,.28-.08l6.42-2.68a1.05,1.05,0,0,0,.56-.46.93.93,0,0,0,.12-.4ZM227,448.2a1.18,1.18,0,0,1-1-1.16l-.08,6.69h0a1.17,1.17,0,0,0,1,1.16l5.64.91,2.95-1.52a1.46,1.46,0,0,0,.61-1.92,9.37,9.37,0,0,1-.52-1.39,2.34,2.34,0,0,0-1.67-1.64Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,438.39a1,1,0,0,1-.59.81l-5.16,2.67a1.45,1.45,0,0,0-.61,1.92,9.37,9.37,0,0,1,.5,1.4,2.33,2.33,0,0,0,1.68,1.62l1.3.21,2.21-1.14a1,1,0,0,0,.58-.84h0Zm-40.21,2.44c-6,2.49-8.16,7-5.59,10.74a12.3,12.3,0,0,1,5.5-4.07c7-2.89,16.47-2,21.23,2a9.84,9.84,0,0,1,1.62,1.72c1.87-2.71,1.46-5.86-1.54-8.38C269.22,438.83,259.72,437.93,252.76,440.83Zm44,8.32a1.89,1.89,0,0,1-.07.39l-1.15,3.6a2,2,0,0,1-1.86,1.34l-7.31-.22a2.91,2.91,0,0,0-1.14.25,3.69,3.69,0,0,0-1.23.8,18.55,18.55,0,0,1-1.77,1.61,1.26,1.26,0,0,0-.2,1.89l2.5,2.69a2.84,2.84,0,0,1,.63-.31h0a2.87,2.87,0,0,1,1.13-.24l7.31.21a2,2,0,0,0,1.86-1.34l1.14-3.6a1.18,1.18,0,0,0,.07-.41h0Zm-59.3-9h0a1,1,0,0,0,.3.73l.36.4a2.76,2.76,0,0,0,.61-.48,17.24,17.24,0,0,1,1.77-1.6,1.27,1.27,0,0,0,.2-1.9l-2.86-3.09a1,1,0,0,1-.3-.58Zm47.75,22.44a1,1,0,0,1-.68.87l-6.42,2.67a2.84,2.84,0,0,1-1.67.1,2.18,2.18,0,0,1-.84-.33l-4.26-2.84a3.9,3.9,0,0,0-2.57-.49c-1.37.25-2.76.44-4.15.57a2.72,2.72,0,0,0-1.39.6,2.24,2.24,0,0,0-.69.79l-1.63,3.16a2.32,2.32,0,0,1-1.18,1,2,2,0,0,1-.9.14l-8-.75a1.38,1.38,0,0,1-1.22-1.57l.41-3.08a1.75,1.75,0,0,0-1.18-1.82,30.25,30.25,0,0,1-3.32-1.2,4.33,4.33,0,0,0-2.64-.14l-.07,0-6.17,2a2.77,2.77,0,0,1-1.56,0,2.34,2.34,0,0,1-.89-.45l-4-3.39a1,1,0,0,1-.39-.7l-.09,6.64a1,1,0,0,0,.4.72l4,3.41a2.74,2.74,0,0,0,1.69.55,1.45,1.45,0,0,0,.36,0h.06a1.37,1.37,0,0,0,.34-.07l6.17-2,.07,0a4.33,4.33,0,0,1,2.64.15,28.82,28.82,0,0,0,3.31,1.2,1.73,1.73,0,0,1,.83.58l-.06,4.52a1.35,1.35,0,0,0,1.23,1.36l8,.76a2.19,2.19,0,0,0,.9-.15,2.61,2.61,0,0,0,.52-.28,2.43,2.43,0,0,0,.25-.2s0,0,0,0a1.12,1.12,0,0,0,.18-.2,2,2,0,0,0,.17-.23l0-.08,1.63-3.16a1.11,1.11,0,0,1,.17-.27c0-.06.1-.12.15-.18a2.47,2.47,0,0,1,.37-.35,2.79,2.79,0,0,1,1.4-.59c1.38-.13,2.77-.31,4.14-.57a4,4,0,0,1,2.57.49l4.27,2.84a2.28,2.28,0,0,0,.83.31h0l.21.05a3.57,3.57,0,0,0,1,0,.8.8,0,0,0,.21-.05,1.29,1.29,0,0,0,.28-.08l6.42-2.68a1.05,1.05,0,0,0,.56-.46.93.93,0,0,0,.12-.4ZM227,448.2a1.18,1.18,0,0,1-1-1.16l-.08,6.69h0a1.17,1.17,0,0,0,1,1.16l5.64.91,2.95-1.52a1.46,1.46,0,0,0,.61-1.92,9.37,9.37,0,0,1-.52-1.39,2.34,2.34,0,0,0-1.67-1.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.83,460.34l-6.17,2a2.77,2.77,0,0,1-1.56,0L235,469a3.11,3.11,0,0,0,.8.13,1.45,1.45,0,0,0,.36,0h.06a1.37,1.37,0,0,0,.34-.07l6.17-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.23,463.77a2.24,2.24,0,0,0-.69.79l-1.63,3.16a2.32,2.32,0,0,1-1.18,1l-.08,6.66a2.61,2.61,0,0,0,.52-.28,2.43,2.43,0,0,0,.25-.2s0,0,0,0a1.12,1.12,0,0,0,.18-.2,2,2,0,0,0,.17-.23l0-.08,1.63-3.16a1.11,1.11,0,0,1,.17-.27l.15-.18a3.87,3.87,0,0,1,.37-.32v0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,438.4a.93.93,0,0,1-.59.8l-5.16,2.67a1.46,1.46,0,0,0-.61,1.92,9.43,9.43,0,0,1,.51,1.4,2.31,2.31,0,0,0,1.68,1.63l1.28.2,2.22-1.14a1,1,0,0,0,.59-.84h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.76,449.15a1.89,1.89,0,0,1-.07.39l-1.15,3.6a2,2,0,0,1-1.86,1.34l-7.31-.22a2.91,2.91,0,0,0-1.14.25l-.07,6.67a2.87,2.87,0,0,1,1.13-.24l7.31.21a2,2,0,0,0,1.86-1.34l1.14-3.6a1.18,1.18,0,0,0,.07-.41h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.21,462.62a1,1,0,0,1-.68.87l-6.42,2.67a2.84,2.84,0,0,1-1.67.1l-.09,6.66.21.05a3.57,3.57,0,0,0,1,0,.8.8,0,0,0,.21-.05,1.29,1.29,0,0,0,.28-.08l6.42-2.68a1.05,1.05,0,0,0,.56-.46.93.93,0,0,0,.12-.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.09,433.78l-6.24,2.05a4.33,4.33,0,0,1-2.64-.15,31,31,0,0,0-3.32-1.2,1.73,1.73,0,0,1-1.18-1.82l.41-3.08a1.38,1.38,0,0,0-1.23-1.57l-8-.75a2.28,2.28,0,0,0-2.07,1.16l-1.63,3.16a2.86,2.86,0,0,1-2.09,1.39c-1.39.13-2.78.32-4.14.57a4,4,0,0,1-2.58-.49l-4.26-2.84a2.93,2.93,0,0,0-2.5-.23l-6.43,2.67a.93.93,0,0,0-.36,1.59l2.86,3.09a1.27,1.27,0,0,1-.2,1.9,17.24,17.24,0,0,0-1.77,1.6,3.61,3.61,0,0,1-2.37,1.05l-7.3-.22a2,2,0,0,0-1.86,1.34l-1.15,3.6a1.19,1.19,0,0,0,1,1.6l6.93,1.13a2.33,2.33,0,0,1,1.68,1.63,9.32,9.32,0,0,0,.51,1.39,1.46,1.46,0,0,1-.61,1.92l-5.16,2.67a.88.88,0,0,0-.2,1.57l4,3.39a2.8,2.8,0,0,0,2.44.46l6.25-2a4.26,4.26,0,0,1,2.64.14,31,31,0,0,0,3.32,1.2,1.72,1.72,0,0,1,1.17,1.82l-.4,3.08a1.38,1.38,0,0,0,1.22,1.57l8,.75a2.31,2.31,0,0,0,2.08-1.16l1.63-3.16a2.89,2.89,0,0,1,2.08-1.39c1.4-.13,2.78-.32,4.15-.57a4,4,0,0,1,2.57.49l4.27,2.84a3,3,0,0,0,2.5.24l6.42-2.68a.93.93,0,0,0,.37-1.59L282,458.81a1.27,1.27,0,0,1,.2-1.9,17.24,17.24,0,0,0,1.77-1.6,3.68,3.68,0,0,1,2.38-1.05l7.3.22a2,2,0,0,0,1.86-1.34l1.15-3.6a1.19,1.19,0,0,0-1-1.6l-6.93-1.13a2.29,2.29,0,0,1-1.68-1.63,9.74,9.74,0,0,0-.51-1.39,1.45,1.45,0,0,1,.61-1.92l5.16-2.67a.89.89,0,0,0,.2-1.57l-4.05-3.39A2.82,2.82,0,0,0,286.09,433.78ZM274,442.83c4.76,4,3,9.59-4,12.48s-16.46,2-21.22-2-3-9.58,4-12.48S269.22,438.83,274,442.83Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.3,445a.77.77,0,0,1-.47.64l-4.11,2.13a1.15,1.15,0,0,0-.49,1.53,8.23,8.23,0,0,1,.4,1.11,1.84,1.84,0,0,0,1.34,1.3l1,.17,1.77-.92a.76.76,0,0,0,.46-.66h0Zm-32.06,1.94c-4.79,2-6.5,5.57-4.45,8.56a9.77,9.77,0,0,1,4.38-3.24c5.55-2.31,13.13-1.6,16.93,1.59a8.07,8.07,0,0,1,1.29,1.36c1.48-2.15,1.16-4.67-1.23-6.68C197.37,445.31,189.79,444.59,184.24,446.9Zm35.08,6.64a1.14,1.14,0,0,1-.06.3l-.91,2.88a1.61,1.61,0,0,1-1.48,1.06l-5.83-.17a2.4,2.4,0,0,0-.91.19,3.15,3.15,0,0,0-1,.65,16,16,0,0,1-1.4,1.28,1,1,0,0,0-.16,1.51l2,2.14a2.92,2.92,0,0,1,.5-.25h0a2.39,2.39,0,0,1,.9-.19l5.83.17a1.62,1.62,0,0,0,1.49-1.07l.91-2.87a1.25,1.25,0,0,0,.05-.32h0ZM172,446.38h0a.79.79,0,0,0,.24.57l.29.32a2.13,2.13,0,0,0,.49-.38,14.48,14.48,0,0,1,1.4-1.28,1,1,0,0,0,.16-1.51l-2.28-2.47a.87.87,0,0,1-.24-.45Zm38.07,17.89a.78.78,0,0,1-.54.7l-5.12,2.13a2.37,2.37,0,0,1-1.33.07,1.59,1.59,0,0,1-.67-.26l-3.39-2.26a3.08,3.08,0,0,0-2.06-.39c-1.08.2-2.19.35-3.3.45a2.11,2.11,0,0,0-1.11.48,1.73,1.73,0,0,0-.55.63l-1.3,2.52a1.82,1.82,0,0,1-1,.81,1.6,1.6,0,0,1-.71.11l-6.36-.6a1.1,1.1,0,0,1-1-1.25l.33-2.45a1.37,1.37,0,0,0-.94-1.45,25.67,25.67,0,0,1-2.64-1,3.46,3.46,0,0,0-2.11-.11l-.06,0-4.92,1.61a2.27,2.27,0,0,1-1.24,0,2.07,2.07,0,0,1-.71-.36L166.23,461a.77.77,0,0,1-.31-.55l-.07,5.29a.82.82,0,0,0,.32.58l3.22,2.71a2.18,2.18,0,0,0,1.35.44,1,1,0,0,0,.29,0h0a1.31,1.31,0,0,0,.27-.06l4.92-1.62.06,0a3.36,3.36,0,0,1,2.1.12,26.56,26.56,0,0,0,2.64,1,1.33,1.33,0,0,1,.66.46l-.05,3.6a1.1,1.1,0,0,0,1,1.09l6.36.6a1.77,1.77,0,0,0,.71-.12,1.44,1.44,0,0,0,.42-.23,1.49,1.49,0,0,0,.2-.15s0,0,0,0a.75.75,0,0,0,.15-.16,1.18,1.18,0,0,0,.13-.18l0-.06,1.29-2.52a1.64,1.64,0,0,1,.14-.22l.12-.14a2.57,2.57,0,0,1,.29-.28,2.35,2.35,0,0,1,1.12-.48,33.12,33.12,0,0,0,3.3-.45A3.17,3.17,0,0,1,199,470l3.41,2.27a2,2,0,0,0,.65.25h0l.17,0a2.55,2.55,0,0,0,.78,0l.17,0,.22-.07,5.12-2.14a.87.87,0,0,0,.45-.36.9.9,0,0,0,.09-.32Zm-46.39-11.5a.92.92,0,0,1-.82-.92l-.06,5.33h0a.92.92,0,0,0,.81.92l4.5.73,2.35-1.22a1.16,1.16,0,0,0,.48-1.53,7.7,7.7,0,0,1-.41-1.1,1.87,1.87,0,0,0-1.33-1.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.3,445a.77.77,0,0,1-.47.64l-4.11,2.13a1.15,1.15,0,0,0-.49,1.53,8.23,8.23,0,0,1,.4,1.11,1.84,1.84,0,0,0,1.34,1.3l1,.17,1.77-.92a.76.76,0,0,0,.46-.66h0Zm-32.06,1.94c-4.79,2-6.5,5.57-4.45,8.56a9.77,9.77,0,0,1,4.38-3.24c5.55-2.31,13.13-1.6,16.93,1.59a8.07,8.07,0,0,1,1.29,1.36c1.48-2.15,1.16-4.67-1.23-6.68C197.37,445.31,189.79,444.59,184.24,446.9Zm35.08,6.64a1.14,1.14,0,0,1-.06.3l-.91,2.88a1.61,1.61,0,0,1-1.48,1.06l-5.83-.17a2.4,2.4,0,0,0-.91.19,3.15,3.15,0,0,0-1,.65,16,16,0,0,1-1.4,1.28,1,1,0,0,0-.16,1.51l2,2.14a2.92,2.92,0,0,1,.5-.25h0a2.39,2.39,0,0,1,.9-.19l5.83.17a1.62,1.62,0,0,0,1.49-1.07l.91-2.87a1.25,1.25,0,0,0,.05-.32h0ZM172,446.38h0a.79.79,0,0,0,.24.57l.29.32a2.13,2.13,0,0,0,.49-.38,14.48,14.48,0,0,1,1.4-1.28,1,1,0,0,0,.16-1.51l-2.28-2.47a.87.87,0,0,1-.24-.45Zm38.07,17.89a.78.78,0,0,1-.54.7l-5.12,2.13a2.37,2.37,0,0,1-1.33.07,1.59,1.59,0,0,1-.67-.26l-3.39-2.26a3.08,3.08,0,0,0-2.06-.39c-1.08.2-2.19.35-3.3.45a2.11,2.11,0,0,0-1.11.48,1.73,1.73,0,0,0-.55.63l-1.3,2.52a1.82,1.82,0,0,1-1,.81,1.6,1.6,0,0,1-.71.11l-6.36-.6a1.1,1.1,0,0,1-1-1.25l.33-2.45a1.37,1.37,0,0,0-.94-1.45,25.67,25.67,0,0,1-2.64-1,3.46,3.46,0,0,0-2.11-.11l-.06,0-4.92,1.61a2.27,2.27,0,0,1-1.24,0,2.07,2.07,0,0,1-.71-.36L166.23,461a.77.77,0,0,1-.31-.55l-.07,5.29a.82.82,0,0,0,.32.58l3.22,2.71a2.18,2.18,0,0,0,1.35.44,1,1,0,0,0,.29,0h0a1.31,1.31,0,0,0,.27-.06l4.92-1.62.06,0a3.36,3.36,0,0,1,2.1.12,26.56,26.56,0,0,0,2.64,1,1.33,1.33,0,0,1,.66.46l-.05,3.6a1.1,1.1,0,0,0,1,1.09l6.36.6a1.77,1.77,0,0,0,.71-.12,1.44,1.44,0,0,0,.42-.23,1.49,1.49,0,0,0,.2-.15s0,0,0,0a.75.75,0,0,0,.15-.16,1.18,1.18,0,0,0,.13-.18l0-.06,1.29-2.52a1.64,1.64,0,0,1,.14-.22l.12-.14a2.57,2.57,0,0,1,.29-.28,2.35,2.35,0,0,1,1.12-.48,33.12,33.12,0,0,0,3.3-.45A3.17,3.17,0,0,1,199,470l3.41,2.27a2,2,0,0,0,.65.25h0l.17,0a2.55,2.55,0,0,0,.78,0l.17,0,.22-.07,5.12-2.14a.87.87,0,0,0,.45-.36.9.9,0,0,0,.09-.32Zm-46.39-11.5a.92.92,0,0,1-.82-.92l-.06,5.33h0a.92.92,0,0,0,.81.92l4.5.73,2.35-1.22a1.16,1.16,0,0,0,.48-1.53,7.7,7.7,0,0,1-.41-1.1,1.87,1.87,0,0,0-1.33-1.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32,462.46l-4.92,1.61a2.27,2.27,0,0,1-1.24,0l-.06,5.3a2.76,2.76,0,0,0,.64.1,1,1,0,0,0,.29,0h0a1.31,1.31,0,0,0,.27-.06l4.92-1.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.59,465.19a1.73,1.73,0,0,0-.55.63l-1.3,2.52a1.82,1.82,0,0,1-1,.81l-.06,5.31a1.44,1.44,0,0,0,.42-.23,1.49,1.49,0,0,0,.2-.15s0,0,0,0a.75.75,0,0,0,.15-.16,1.18,1.18,0,0,0,.13-.18l0-.06,1.29-2.52a1.64,1.64,0,0,1,.14-.22l.12-.14.29-.26v0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.3,445a.74.74,0,0,1-.47.64l-4.12,2.13a1.16,1.16,0,0,0-.48,1.53,6.71,6.71,0,0,1,.4,1.11,1.84,1.84,0,0,0,1.34,1.3l1,.17,1.76-.92a.75.75,0,0,0,.47-.66h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.32,453.54a1.14,1.14,0,0,1-.06.3l-.91,2.88a1.61,1.61,0,0,1-1.48,1.06l-5.83-.17a2.4,2.4,0,0,0-.91.19l-.06,5.32a2.39,2.39,0,0,1,.9-.19l5.83.17a1.62,1.62,0,0,0,1.49-1.07l.91-2.87a1.25,1.25,0,0,0,.05-.32h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.11,464.27a.78.78,0,0,1-.54.7l-5.12,2.13a2.37,2.37,0,0,1-1.33.07l-.07,5.31.17,0a2.55,2.55,0,0,0,.78,0l.17,0,.22-.07,5.12-2.14a.87.87,0,0,0,.45-.36.9.9,0,0,0,.09-.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.82,441.28l-5,1.63a3.46,3.46,0,0,1-2.11-.11,24.29,24.29,0,0,0-2.64-1,1.36,1.36,0,0,1-.94-1.44l.32-2.46a1.09,1.09,0,0,0-1-1.25l-6.37-.6a1.83,1.83,0,0,0-1.65.93l-1.3,2.52a2.33,2.33,0,0,1-1.66,1.11,33.32,33.32,0,0,0-3.31.45,3.18,3.18,0,0,1-2.05-.39l-3.4-2.27a2.36,2.36,0,0,0-2-.18l-5.13,2.13a.74.74,0,0,0-.29,1.26l2.29,2.47a1,1,0,0,1-.16,1.51,13.53,13.53,0,0,0-1.41,1.28,2.87,2.87,0,0,1-1.9.83l-5.82-.16a1.61,1.61,0,0,0-1.48,1.06L163,451.5a1,1,0,0,0,.77,1.28l5.53.89a1.86,1.86,0,0,1,1.33,1.3,7.94,7.94,0,0,0,.41,1.12,1.13,1.13,0,0,1-.49,1.52l-4.11,2.13a.71.71,0,0,0-.16,1.25l3.22,2.71a2.26,2.26,0,0,0,2,.37l5-1.64a3.46,3.46,0,0,1,2.11.12,25.67,25.67,0,0,0,2.64,1,1.37,1.37,0,0,1,.94,1.45l-.32,2.45a1.09,1.09,0,0,0,1,1.25l6.36.6a1.81,1.81,0,0,0,1.66-.92l1.3-2.52a2.27,2.27,0,0,1,1.66-1.11,32.74,32.74,0,0,0,3.3-.46,3.21,3.21,0,0,1,2.06.4l3.4,2.26a2.35,2.35,0,0,0,2,.19l5.12-2.13a.74.74,0,0,0,.29-1.27l-2.28-2.47a1,1,0,0,1,.16-1.51,14.68,14.68,0,0,0,1.41-1.27,2.88,2.88,0,0,1,1.89-.84l5.82.17a1.61,1.61,0,0,0,1.49-1.07l.91-2.86a.94.94,0,0,0-.76-1.28l-5.53-.9a1.85,1.85,0,0,1-1.34-1.3,7.06,7.06,0,0,0-.4-1.11,1.15,1.15,0,0,1,.48-1.53l4.12-2.13a.7.7,0,0,0,.15-1.25l-3.22-2.71A2.24,2.24,0,0,0,210.82,441.28Zm-9.66,7.21c3.79,3.19,2.37,7.65-3.18,9.95s-13.13,1.6-16.92-1.59-2.37-7.64,3.18-10S197.37,445.3,201.16,448.49Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277,360.81l-33.22-19.17c-6.81-3.94-18.3-4.84-25.64-2l-19.72,7.59a113.54,113.54,0,0,0-24.5,13.94L153.87,377c-2.88,2.27-4.3,5-4.31,7.73,0,.76,0,3.81,0,4.58,0,3.06,1.85,6,5.45,8.09l33.21,19.18c6.81,3.93,17.87,3.93,24.69,0l64.09-37c3.42-2,5.11-4.56,5.09-7.15v-4.43C282.11,365.36,280.42,362.78,277,360.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.57,389.26c0,3.06,1.85,6,5.45,8.09l33.21,19.18a25.3,25.3,0,0,0,12.34,3v-4.74l-51-29.45C149.56,386.46,149.56,388.63,149.57,389.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.57,389.26c0,3.06,1.85,6,5.45,8.09l33.21,19.18a25.3,25.3,0,0,0,12.34,3v-4.74l-51-29.45C149.56,386.46,149.56,388.63,149.57,389.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.15,339.63l-19.72,7.59a113.54,113.54,0,0,0-24.5,13.94L153.87,377c-6.18,4.87-5.67,12,1.15,15.95l33.21,19.17c6.81,3.94,17.87,3.94,24.69,0l64.09-37c6.81-3.94,6.81-10.32,0-14.26l-33.22-19.17C237,337.7,225.49,336.8,218.15,339.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79,341.64c-6.81-3.94-18.3-4.84-25.64-2l-19.72,7.59a113.54,113.54,0,0,0-24.5,13.94L153.87,377c-2.88,2.27-4.3,5-4.31,7.73,0,.76,0,3.81,0,4.58,0,3.06,1.85,6,5.45,8.09L173.52,408V403.6l88.8-51.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.68,361.81c0-9.79,3.06-40.63,9.49-47.85l-20.56-2.27c-10.11,10.69-22.22,36.22-29.54,50.94,0,0,6,2.45,13.48,5.53s17.8,3.08,23.13,0a7.16,7.16,0,0,0,4-6.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.68,361.81c0-9.79,3.06-40.63,9.49-47.85l-20.56-2.27c-10.11,10.69-22.22,36.22-29.54,50.94,0,0,6,2.45,13.48,5.53s17.8,3.08,23.13,0a7.16,7.16,0,0,0,4-6.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.84,314.66c4,1.65,9.54,1.65,12.39,0s2.86-4.86,0-7.17l-5.17-4.18a59.27,59.27,0,0,0-14.45,8.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.38,410.08c2.83,1.63,7.58,1.54,10.6-.2L355.89,266.15a12.06,12.06,0,0,0,5.46-9.46v-230c0-3.48-2.29-7.64-5.12-9.27a11.7,11.7,0,0,0-10.6.2L96.72,161.33a12.12,12.12,0,0,0-5.46,9.47v230A11.74,11.74,0,0,0,96.38,410.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,409.87,355.89,266.15a12.08,12.08,0,0,0,5.46-9.47v-230c0-3.49-2.44-4.9-5.46-3.16L107,167.25a12.08,12.08,0,0,0-5.47,9.47v230C101.51,410.2,104,411.62,107,409.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.51,388.12v18.6c0,3.48,2.45,4.9,5.47,3.15L355.89,266.15a12.08,12.08,0,0,0,5.46-9.47v-18.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.73,370.82V179.15a7.42,7.42,0,0,1,3.36-5.82L350.76,35.52c1.86-1.08,3.36-.21,3.36,1.94V229.13a7.4,7.4,0,0,1-3.36,5.82L112.1,372.76C110.24,373.84,108.73,373,108.73,370.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.87,165.4l10.25,5.91a11.58,11.58,0,0,0-1.62,5.4v230c0,3.18,2.15,5,5.47,3.16a11.61,11.61,0,0,1-10.6.2,10.53,10.53,0,0,1-5.13-8.61V170.8A11.27,11.27,0,0,1,92.87,165.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.42,325.23l12.36-7.09c1.11-.64,2-.19,2,1a4.3,4.3,0,0,1-2,3.33l-12.36,7.1c-1.11.64-2,.18-2-1A4.3,4.3,0,0,1,228.42,325.23Z",
    style: {
      fill: "#46C5FB"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.06,420.91H42.56l4.81,20h0c.37,2.42,2.15,4.77,5.35,6.62,7.23,4.18,19,4.18,26.19,0,3.44-2,5.22-4.57,5.39-7.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.39,434.64a19.59,19.59,0,0,0,2.79-1.95L88.79,422a18.69,18.69,0,0,1-4.7,3.74c-9.81,5.66-25.53,5.8-35.67.46l1.18-4.77-.36-.51H42.56l4.81,20h0c.37,2.42,2.15,4.77,5.35,6.62,5.15,3,12.58,3.82,19,2.56-11.59.86-19.53-4.2-20.73-8.87-.47-1.87-1.3-6-1.3-6C59.4,440.17,74.14,440,83.39,434.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.47,415a9.65,9.65,0,0,1-1.55,3.61,17.12,17.12,0,0,1-5.83,5.18c-10.09,5.83-26.46,5.83-36.56,0a17.12,17.12,0,0,1-5.83-5.18A9.79,9.79,0,0,1,40.16,415h0c-.9-4.38,1.57-8.95,7.38-12.31,10.1-5.83,26.47-5.83,36.56,0C89.91,406,92.37,410.61,91.47,415Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.92,418.6a17.12,17.12,0,0,1-5.83,5.18c-10.09,5.83-26.46,5.83-36.56,0a17.12,17.12,0,0,1-5.83-5.18A9.79,9.79,0,0,1,40.16,415h0l1.15,7.88c.52,3.17,2.88,6.26,7.1,8.69,9.62,5.55,25.21,5.55,34.83,0,4.15-2.4,6.51-5.45,7.07-8.58l.06-.4L91.47,415A9.65,9.65,0,0,1,89.92,418.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,404.44c-8.41-4.86-22.05-4.86-30.45,0-4.76,2.75-6.83,6.46-6.2,10.05.48,2.75,2.54,5.42,6.2,7.53,8.4,4.86,22,4.86,30.45,0,3.65-2.11,5.72-4.78,6.2-7.53C87.87,410.9,85.81,407.19,81,404.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.81,417.82a14.4,14.4,0,0,0,4.78,4.2c8.4,4.86,22,4.86,30.45,0a14.4,14.4,0,0,0,4.78-4.2c-.06-2.91-2-5.81-5.85-8-7.82-4.51-20.49-4.51-28.3,0C47.82,412,45.87,414.91,45.81,417.82Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.42,408.78c-3.86-1-4.52-9.43-2.35-18.26,2.1-8.6,8.85-21.49,10.28-21.21s3.22,14.3,2.22,23.55C76.35,404.07,71.29,409.82,67.42,408.78Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.42,408.78c-3.86-1-4.52-9.43-2.35-18.26,2.1-8.6,8.85-21.49,10.28-21.21s3.22,14.3,2.22,23.55C76.35,404.07,71.29,409.82,67.42,408.78Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.31,381.71c.69,1.09,1.12,2.94,2.74,3,1.3,0,2-1.37,3.16-1.69a3.19,3.19,0,0,1,2.59.78c0-.34,0-.67,0-1a4,4,0,0,0-2.24-.79,3.23,3.23,0,0,0-1.87.85c-.61.46-1.34,1.17-2.18.83s-1.2-1.57-1.68-2.36a3.26,3.26,0,0,0-1-1.06l-.32.72A2.1,2.1,0,0,1,69.31,381.71Zm4.58-3.46c.56-.26.88-.82,1.31-1.23a1.86,1.86,0,0,1,2-.38l.07,0-.12-.88-.36-.09a2.25,2.25,0,0,0-1.62.35c-.53.39-.83,1-1.39,1.38-1,.61-1.82-.49-2.12-1.32-.13-.37-.24-.75-.36-1.13l-.31.59c.07.27.13.53.21.79C71.54,377.44,72.57,378.88,73.89,378.25Zm-.13,11.18a9.75,9.75,0,0,1-2.11,1.39c-2,.56-2.45-2.51-3.72-3.42a2.63,2.63,0,0,0-1.81-.47c-.08.23-.15.47-.23.7a2.46,2.46,0,0,1,1,0,2.77,2.77,0,0,1,1.75,1.55c.63,1.14,1.44,2.78,3,2.46a5.08,5.08,0,0,0,1.85-1,3.32,3.32,0,0,1,2.69-.73,3.67,3.67,0,0,1,1.52.81c0-.3,0-.61,0-.91A3.78,3.78,0,0,0,76,389,3.44,3.44,0,0,0,73.76,389.43ZM75,396.19a3.9,3.9,0,0,0-2.64.35c-.92.45-1.59,1.34-2.56,1.71-2.1.79-2.43-2.26-4-3a3.09,3.09,0,0,0-1.59-.31c0,.24-.07.48-.1.71a4.12,4.12,0,0,1,.61,0,2.84,2.84,0,0,1,2.17,1.69c.75,1.38,1.73,2.51,3.43,1.68.91-.44,1.56-1.27,2.5-1.67a3,3,0,0,1,3.14.28,4.91,4.91,0,0,1,.59.73c.08-.3.15-.61.22-.92A3.35,3.35,0,0,0,75,396.19Z",
    style: {
      fill: "#46C5FB",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.42,408.78c3.87,1,8.93-4.71,10.15-15.92a65.85,65.85,0,0,0,.21-9.61c-3.15,2.59-6.32,7.88-6.32,7.88a86.84,86.84,0,0,0-3.75-8.45,57.89,57.89,0,0,0-2.64,7.84C62.9,399.35,63.56,407.73,67.42,408.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.27,413.42c-5.08,3.26-9.83-8.35-12.35-17.11S51,364.65,53.6,363.4C55.42,362.51,65,383,66.91,393,68.27,400.25,68.32,410.82,64.27,413.42Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.27,413.42c-5.08,3.26-9.83-8.35-12.35-17.11S51,364.65,53.6,363.4C55.42,362.51,65,383,66.91,393,68.27,400.25,68.32,410.82,64.27,413.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3,379.57c1.6.79,2.87.79,4.11-.56s2-2.83,3.82-2.63c-.18-.4-.35-.8-.53-1.19a2.67,2.67,0,0,0-.88.09c-1.57.42-2.28,2.06-3.39,3.1-1.7,1.59-3.52-.5-5.46-.39l-.17,0c0,.35,0,.7,0,1.05A4.91,4.91,0,0,1,53.3,379.57Zm14,15.76a4.42,4.42,0,0,0-.83-.24,3.11,3.11,0,0,0-2.4.54c-1.54,1.13-1.61,3.64-4.1,3-1.89-.49-3.31-1.74-5.3-.75a6.74,6.74,0,0,0-1.82,1.38c.09.29.19.58.28.87a5.64,5.64,0,0,1,2.48-1.53c2.14-.55,3.76,1.61,5.89,1.26,1.74-.29,1.92-2.2,3.13-3.14a2.73,2.73,0,0,1,2.82-.18C67.38,396.12,67.33,395.72,67.27,395.33ZM53.39,371.25c.59.82,1.43,1.73,2.53,1.16s1.27-2,2-3l-.41-.79c-.74,1-1.11,3.13-2.52,3.05-1.1-.06-1.53-1.69-2.46-2.17a1.53,1.53,0,0,0-.92-.17c0,.22-.07.44-.1.67l.22,0C52.53,370,53,370.69,53.39,371.25Zm3.83,17.39c2,.43,3-2,3.89-3.28A5.9,5.9,0,0,1,63.9,383l-.41-1.08a3.78,3.78,0,0,0-1.05.39,6.74,6.74,0,0,0-2.17,2.21c-.61.9-1.11,2.12-2.05,2.72s-2.33-.39-3.44-.59a6,6,0,0,0-3.1.25,5.06,5.06,0,0,0-.94.45c0,.5,0,1,.08,1.48a4.76,4.76,0,0,1,3.26-1.1C55.25,387.75,56.12,388.4,57.22,388.64Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.24,383.93a28.51,28.51,0,0,0-4.12,6.74s-5.52-7.48-9.4-10.88c-.21,6.22.1,12.71,1.2,16.52,2.52,8.76,7.27,20.37,12.35,17.11,4-2.6,4-13.17,2.64-20.4A63.82,63.82,0,0,0,64.24,383.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.92,419.39c-9.29.5-18-5.13-23.62-12.23s-10-21.76-8.76-22.66,16.27,8.35,21.9,15C60.83,408.28,63.92,419.39,63.92,419.39Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.92,419.39c-9.29.5-18-5.13-23.62-12.23s-10-21.76-8.76-22.66,16.27,8.35,21.9,15C60.83,408.28,63.92,419.39,63.92,419.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63,396.1c.54-.88.23-1.93.11-2.88a2.64,2.64,0,0,1,.38-1.8l-1-.75a3.78,3.78,0,0,0-.38,2.52c.15,1.08.41,2.41-1,2.61s-3.73-1.18-5,.36c-.6.75-.37,1.71-.39,2.59a2.54,2.54,0,0,1-.34,1.13c.17.36.34.71.52,1.05a3.14,3.14,0,0,0,.69-1.57c.13-1.08-.29-2.48,1.17-2.71a13.16,13.16,0,0,1,3,.38A2.36,2.36,0,0,0,43.63,396.1Zm-5.19-7.77a2.46,2.46,0,0,1,.41-.44l-.84-.51c-.68.9-.68,2.13-1.37,3a1.57,1.57,0,0,1-1.75.5A2.93,2.93,0,0,0,33,391a2.46,2.46,0,0,0-.39.22l.21.67a2.11,2.11,0,0,1,1-.27c.7,0,1.36.35,2.07.3a1.8,1.8,0,0,0,1.23-.63C37.81,390.43,37.85,389.25,38.44,388.33Zm10.3,12.46a4.47,4.47,0,0,0,1.41-2.39,14.32,14.32,0,0,0,.24-2c-.28-.26-.57-.52-.88-.78a9.33,9.33,0,0,1-.65,3.21A2.9,2.9,0,0,1,46,400.38a3,3,0,0,0-2.49.79,4.65,4.65,0,0,0-.92,2.49c-.19,1.3-.39,2.49-1.6,3.23a3.73,3.73,0,0,1-.64.3L41,408a3.86,3.86,0,0,0,1.33-1c1.56-1.85.29-5.52,3.6-5.51A4,4,0,0,0,48.74,400.79Zm5,.94a4.53,4.53,0,0,1,.7-1c-.26-.34-.53-.67-.8-1a6,6,0,0,0-1.49,2.92,8.78,8.78,0,0,1-1.21,3.46c-.81,1-2.1.93-3.17,1.53a4.48,4.48,0,0,0-2,2.31,11.19,11.19,0,0,0-.5,2.35l1,.81,0-.15a5.9,5.9,0,0,1,1.39-3.63c1-.92,2.34-.79,3.39-1.53C53.08,406.42,52.73,403.7,53.74,401.73Zm4,3.88a6.14,6.14,0,0,0-.75.69c-1.59,1.74-1.39,4-2,6.14a3.75,3.75,0,0,1-2,2.65c-.89.37-1.89,0-2.66.71l-.07.09c.45.26.92.51,1.39.74a3.94,3.94,0,0,1,.77-.08A3.64,3.64,0,0,0,54,416.2a4.19,4.19,0,0,0,1.77-1.93c1-2,.53-4.43,1.73-6.33a5.4,5.4,0,0,1,1-1.16Q58.13,406.2,57.77,405.61Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,390.61c.88,7.7,5,28.42,20.94,28.78,0,0-3.09-11.11-10.48-19.87A58.17,58.17,0,0,0,43,390.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.92,419.39c-7.31-1.07-13.59-5.7-16.81-19.48s-3.72-20-1.5-21.36C48.16,377,58.14,390.86,61.35,397,69.42,412.31,63.92,419.39,63.92,419.39Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.35,393.93c1.83.57,4.2,1.18,5.57-.62a16.85,16.85,0,0,0,1.31-3c-.32-.47-.64-.94-1-1.41-.8,1.3-.78,3.22-2.19,4a4.53,4.53,0,0,1-3.39-.13,8.05,8.05,0,0,0-3.36-.51,4.75,4.75,0,0,0-1.75.62c.08.4.17.83.26,1.25a7,7,0,0,1,.73-.35A5.65,5.65,0,0,1,50.35,393.93Zm-2.16-7.13a2.9,2.9,0,0,0,1.7.32c1.11-.23,1.69-1.3,2.26-2.17a5,5,0,0,1,.56-.72L52,383.4l-.14.14c-.7.84-1.28,2.55-2.57,2.57a8.58,8.58,0,0,1-1.82-.53,4.2,4.2,0,0,0-1.58,0,3.91,3.91,0,0,0-1.46.55l.12,1a4.44,4.44,0,0,1,2-.6A3.86,3.86,0,0,1,48.19,386.8Zm8,15.3a10.26,10.26,0,0,1,2.23-2.91,4.86,4.86,0,0,1,3.73-.66c-.25-.51-.51-1-.79-1.56a6.17,6.17,0,0,0-2.52.16,5.4,5.4,0,0,0-2.79,2,15.83,15.83,0,0,1-1.87,2.7c-1.49,1.36-3.51.17-5.17-.16a6,6,0,0,0-1.46-.11c.13.48.26.95.4,1.4a6.38,6.38,0,0,1,1.92.3C52.35,404.07,54.51,404.53,56.18,402.1Zm8.42,2.68c-.12,0-.25.06-.37.11a5.63,5.63,0,0,0-2.48,1.86c-.71.91-1.08,2-1.75,3a2.29,2.29,0,0,1-2.91,1,5,5,0,0,0-3.22-.24,5.35,5.35,0,0,0-2,1.28c.24.37.5.71.76,1a4.45,4.45,0,0,1,1.57-.92,3.51,3.51,0,0,1,2.52.32,4,4,0,0,0,5.18-1.58c.62-.91,1-2,1.69-2.86a4,4,0,0,1,1.51-1.16C64.93,406,64.78,405.4,64.6,404.78Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.35,397c-.58-1.11-1.38-2.47-2.32-4-3.16,9.78-4.18,24.05,4.89,26.37C63.92,419.39,69.42,412.31,61.35,397Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,419.39c9.3.5,18-5.13,23.63-12.23s10-21.76,8.76-22.66-16.28,8.35-21.91,15C70.79,408.28,67.7,419.39,67.7,419.39Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,419.39c9.3.5,18-5.13,23.63-12.23s10-21.76,8.76-22.66-16.28,8.35-21.91,15C70.79,408.28,67.7,419.39,67.7,419.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.32,397a13.16,13.16,0,0,1,3-.38c1.46.23,1,1.63,1.17,2.71a3.06,3.06,0,0,0,.69,1.57c.17-.34.35-.69.51-1.05a2.53,2.53,0,0,1-.33-1.13c0-.88.21-1.84-.4-2.59-1.25-1.54-3.42-.15-5-.36s-1.18-1.53-1-2.61a3.84,3.84,0,0,0-.38-2.52l-1,.75a2.64,2.64,0,0,1,.37,1.8c-.12.95-.43,2,.12,2.88A2.36,2.36,0,0,0,90.32,397Zm4.26-5.77a1.8,1.8,0,0,0,1.23.63c.71.05,1.36-.32,2.07-.3a2.07,2.07,0,0,1,1,.27c.08-.23.15-.45.21-.67a2.88,2.88,0,0,0-.38-.22,2.93,2.93,0,0,0-1.94-.07,1.59,1.59,0,0,1-1.76-.5c-.69-.89-.69-2.12-1.37-3l-.83.51a2.1,2.1,0,0,1,.4.44C93.78,389.25,93.81,390.43,94.58,391.26ZM85.7,401.5c3.3,0,2,3.66,3.6,5.51a3.77,3.77,0,0,0,1.33,1c.23-.27.46-.54.67-.81a4.12,4.12,0,0,1-.64-.3c-1.2-.74-1.4-1.93-1.59-3.23a4.66,4.66,0,0,0-.93-2.49,3,3,0,0,0-2.48-.79,2.91,2.91,0,0,1-2.9-1.52,9.57,9.57,0,0,1-.65-3.21l-.88.78a18.27,18.27,0,0,0,.24,2,4.6,4.6,0,0,0,1.41,2.39A4,4,0,0,0,85.7,401.5Zm-5.15,6.33c1,.74,2.4.61,3.38,1.53s1.19,2.32,1.4,3.63a.77.77,0,0,0,0,.15l1-.81a11.19,11.19,0,0,0-.5-2.35,4.53,4.53,0,0,0-2-2.31c-1.07-.6-2.36-.49-3.17-1.53a8.78,8.78,0,0,1-1.21-3.46A6,6,0,0,0,78,399.76c-.27.33-.54.66-.8,1a4.49,4.49,0,0,1,.69,1C78.89,403.7,78.54,406.42,80.55,407.83Zm-7.39-1.05a4.9,4.9,0,0,1,1,1.16c1.21,1.9.78,4.33,1.74,6.33a4.14,4.14,0,0,0,1.77,1.93,3.59,3.59,0,0,0,1.44.35,4,4,0,0,1,.78.08c.47-.23.93-.48,1.39-.74l-.07-.09c-.77-.7-1.78-.34-2.66-.71a3.75,3.75,0,0,1-2-2.65c-.58-2.14-.39-4.4-2-6.14a6.23,6.23,0,0,0-.76-.69Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,390.61c-.87,7.7-5,28.42-20.94,28.78,0,0,3.09-11.11,10.48-19.87A58.52,58.52,0,0,1,88.64,390.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,419.39c7.32-1.07,13.59-5.7,16.82-19.48s3.72-20,1.5-21.36C83.46,377,73.48,390.86,70.27,397,62.21,412.31,67.7,419.39,67.7,419.39Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.08,393.74a7,7,0,0,1,.73.35c.08-.42.17-.85.25-1.25a4.69,4.69,0,0,0-1.75-.62,8.05,8.05,0,0,0-3.36.51,4.5,4.5,0,0,1-3.38.13c-1.41-.74-1.39-2.66-2.2-4l-1,1.41a17.66,17.66,0,0,0,1.32,3c1.37,1.8,3.74,1.19,5.56.62A5.68,5.68,0,0,1,85.08,393.74Zm0-7.25a4.4,4.4,0,0,1,2,.6q.08-.51.12-1a3.79,3.79,0,0,0-1.46-.55,4.15,4.15,0,0,0-1.57,0,8.67,8.67,0,0,1-1.83.53c-1.29,0-1.87-1.73-2.56-2.57l-.14-.14-.69.83a3.87,3.87,0,0,1,.56.72c.57.87,1.15,1.94,2.26,2.17a2.88,2.88,0,0,0,1.7-.32A3.88,3.88,0,0,1,85.08,386.49ZM81.76,403.3a6.49,6.49,0,0,1,1.93-.3c.13-.45.26-.92.39-1.4a6,6,0,0,0-1.46.11c-1.66.33-3.67,1.52-5.16.16a15.83,15.83,0,0,1-1.87-2.7,5.44,5.44,0,0,0-2.79-2,6.22,6.22,0,0,0-2.53-.16c-.28.53-.53,1-.78,1.56a4.87,4.87,0,0,1,3.73.66,10.45,10.45,0,0,1,2.23,2.91C77.11,404.53,79.28,404.07,81.76,403.3Zm-15.2,3.27a4.12,4.12,0,0,1,1.51,1.16c.7.86,1.06,1.95,1.69,2.86a3.94,3.94,0,0,0,5.18,1.58,3.51,3.51,0,0,1,2.52-.32,4.54,4.54,0,0,1,1.57.92c.25-.34.51-.68.76-1a5.31,5.31,0,0,0-2-1.28,5,5,0,0,0-3.21.24,2.29,2.29,0,0,1-2.91-1c-.67-.94-1-2-1.76-3a5.6,5.6,0,0,0-2.47-1.86c-.13-.05-.25-.07-.37-.11C66.85,405.4,66.69,406,66.56,406.57Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.27,397c.58-1.11,1.39-2.47,2.33-4,3.16,9.78,4.18,24.05-4.9,26.37C67.7,419.39,62.21,412.31,70.27,397Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.81,420.9c6.17,0,8.22-8.39,7.61-15.15s-4.89-19.61-7.61-19.61-7,12.85-7.6,19.61S59.64,420.9,65.81,420.9Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.81,420.9c6.17,0,8.22-8.39,7.61-15.15s-4.89-19.61-7.61-19.61-7,12.85-7.6,19.61S59.64,420.9,65.81,420.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.78,394.93a5.07,5.07,0,0,0,2.29-1.64,4,4,0,0,1,1.91-1l-.48-1.17a5.79,5.79,0,0,0-2.6,1.6,3.69,3.69,0,0,1-1.29,1c-.75.26-1.2-.14-1.69-.63a4.12,4.12,0,0,0-2-1.21h-.06l-.39,1A3.82,3.82,0,0,1,63.59,394,2.32,2.32,0,0,0,65.78,394.93Zm-4.61,7.4c2.06,1.61,3.76-.67,5.07-2,1.1-1.14,2.26-1.37,3.51-.32a8,8,0,0,0,2.35,1.7,3.7,3.7,0,0,0,.71.18c-.08-.39-.17-.77-.26-1.17a6.91,6.91,0,0,1-2.5-1.67c-1.84-1.5-3.49-.87-5,.8-.83,1-2.19,2.61-3.57,1.58-.81-.61-1.2-1.64-2.05-2.23l0,0c-.09.34-.17.68-.25,1C60,400.7,60.41,401.73,61.17,402.33Zm2.31,7.4c1.16,1.54,2.62,1.92,4.2.6a25,25,0,0,1,2.11-2.13c1.17-.8,2.52-.38,3.73.09,0-.37,0-.73,0-1.1a8.28,8.28,0,0,0-1.71-.53,3.47,3.47,0,0,0-2.66.54c-.87.62-1.41,1.58-2.25,2.24a2.1,2.1,0,0,1-1.78.57c-.7-.27-1.13-1.15-1.64-1.67A5.08,5.08,0,0,0,61.07,407a4.36,4.36,0,0,0-3,.29c0,.35,0,.7,0,1.05A4.36,4.36,0,0,1,63.48,409.73ZM69.33,416a4.82,4.82,0,0,1-3.48,1.05,2.76,2.76,0,0,1-1.76-.77c-.34-.35-.58-.78-.93-1.13A4.2,4.2,0,0,0,60.84,414a4.69,4.69,0,0,0-1.94.16q.16.57.36,1.11a3.19,3.19,0,0,1,3.07.43c.74.55,1.1,1.45,1.88,2a4.32,4.32,0,0,0,2.41.62,5.29,5.29,0,0,0,2.55-.63c.89-.46,1.52-1.27,2.38-1.76a5.05,5.05,0,0,1,.71-.33,11.91,11.91,0,0,0,.46-1.39,4,4,0,0,0-.86.18A8.63,8.63,0,0,0,69.33,416Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.56,54.21V226.85a4.29,4.29,0,0,1-1.95,3.38L122.51,359a1.16,1.16,0,0,1-.64.18,1.07,1.07,0,0,1-.25,0,.49.49,0,0,1-.17-.06,1,1,0,0,1-.17-.09,1.68,1.68,0,0,1-.51-.65,2.4,2.4,0,0,1-.21-1V185.19a4.34,4.34,0,0,1,2-3.38L345.61,53.09a1.4,1.4,0,0,1,1.31-.17,1,1,0,0,1,.17.1h0l.13.13a.2.2,0,0,1,.06.07.33.33,0,0,1,.06.1,1.15,1.15,0,0,1,.12.25.47.47,0,0,1,0,.17.06.06,0,0,1,0,0,1,1,0,0,1,0,.18A1.93,1.93,0,0,1,347.56,54.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.48,53.82l0,.17v0l0,0V226.85a3.28,3.28,0,0,1-1.45,2.51L122,358.12a.45.45,0,0,1-.12.05h-.07a1.27,1.27,0,0,1-.17-.26,1.4,1.4,0,0,1-.1-.53V185.19a3.38,3.38,0,0,1,1.45-2.51L346.11,54a.87.87,0,0,1,.37-.14m0-1a1.78,1.78,0,0,0-.87.27L122.51,181.81a4.34,4.34,0,0,0-2,3.38V357.36a2.4,2.4,0,0,0,.21,1,1.68,1.68,0,0,0,.51.65,1.56,1.56,0,0,0,.17.09.49.49,0,0,0,.17.06,1.07,1.07,0,0,0,.25,0h0a1.25,1.25,0,0,0,.61-.18l223.1-128.76a4.29,4.29,0,0,0,1.95-3.38V54.21a1.93,1.93,0,0,0,0-.24,1,1,0,0,0,0-.18.06.06,0,0,0,0,0,.47.47,0,0,0,0-.17,1.15,1.15,0,0,0-.12-.25.33.33,0,0,0-.06-.1.2.2,0,0,0-.06-.07L347.1,53h0a1,1,0,0,0-.17-.1,1.05,1.05,0,0,0-.44-.1Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.92,52.92a1.4,1.4,0,0,0-1.31.17L122.51,181.81a4.34,4.34,0,0,0-2,3.38v6.37l-5-2.88v-6.33a4.29,4.29,0,0,1,2-3.37L340.61,50.25a1.36,1.36,0,0,1,1.41-.11C342.38,50.35,346.51,52.7,346.92,52.92Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.56,54.2c0-1.23-.88-1.73-1.95-1.11L122.51,181.81a4.34,4.34,0,0,0-1.94,3.38v6.37l227-131Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.61,53.09,122.52,181.81a4,4,0,0,0-1.38,1.45l-5-2.86a3.88,3.88,0,0,1,1.36-1.42L340.61,50.25a1.36,1.36,0,0,1,1.41-.11c.35.21,4.49,2.56,4.9,2.78A1.4,1.4,0,0,0,345.61,53.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.56,188.68v-6.33a4,4,0,0,1,.59-1.95l5,2.85a4,4,0,0,0-.58,1.94v6.37Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.5,61a2.92,2.92,0,0,0-1.1,2.33c0,.94.5,1.41,1.1,1.06a2.91,2.91,0,0,0,1.11-2.33C337.61,61.16,337.11,60.69,336.5,61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.47,58.75a2.89,2.89,0,0,0-1.1,2.33c0,.93.49,1.41,1.1,1.06a2.9,2.9,0,0,0,1.1-2.33C341.57,58.87,341.08,58.4,340.47,58.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.43,56.46a2.89,2.89,0,0,0-1.1,2.33c0,.93.49,1.41,1.1,1.05a2.89,2.89,0,0,0,1.1-2.33C345.53,56.58,345,56.1,344.43,56.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.28,359l-.24-.14-4.66-2.67a1.72,1.72,0,0,1-.59-.67,2.4,2.4,0,0,1-.23-1V188.68l5,2.88v165.8a2.58,2.58,0,0,0,.21,1A1.66,1.66,0,0,0,121.28,359Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Resume--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217,144.29l-89.21,51.44a3.71,3.71,0,0,0-1.67,2.89V342.81a3.68,3.68,0,0,0,1.67,2.89l.34.19a3.68,3.68,0,0,0,3.34,0l89.22-51.51a3.7,3.7,0,0,0,1.67-2.89V147.36a3.63,3.63,0,0,0-1.68-2.88l-.33-.2A3.73,3.73,0,0,0,217,144.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.35,291.6c0,1.47-1,2.4-2.31,3.13L132.1,345.51c-1.27.73-2.31.14-2.31-1.34V201.45h0a4.59,4.59,0,0,1,2.3-4L220,146.68a1.54,1.54,0,0,1,2.31,1.34h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.81,147h0a1,1,0,0,1,1,1V291.6c0,1-.63,1.88-2.05,2.69l-87.94,50.78a1.62,1.62,0,0,1-.78.24c-.69,0-.77-.79-.77-1.14V201.45a4.08,4.08,0,0,1,2-3.53l87.95-50.8a1.07,1.07,0,0,1,.52-.14m0-.5a1.55,1.55,0,0,0-.77.2l-87.95,50.8a4.59,4.59,0,0,0-2.3,4V344.17c0,1.05.53,1.65,1.28,1.65a2.12,2.12,0,0,0,1-.31L220,294.73c1.28-.73,2.31-1.66,2.31-3.13V148a1.54,1.54,0,0,0-1.54-1.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.35,147.36V148a1.53,1.53,0,0,0-2.31-1.32l-87.95,50.79a4.44,4.44,0,0,0-1.68,1.68.08.08,0,0,0,0,.05l-3.81-2.2a3.5,3.5,0,0,1,1.2-1.27L217,144.29a3.68,3.68,0,0,1,3.34,0l.34.2A3.63,3.63,0,0,1,222.35,147.36Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--resume--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.19,194.59v95.2l-80.25,46.32V240.92l80.25-46.33m.54-.94L135.4,240.6v96.45l81.33-46.95V193.65Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.85 313.12 216.73 290.1 216.73 193.65 176.85 216.67 176.85 313.12",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.85 313.12 216.73 290.1 216.73 193.65 176.85 216.67 176.85 313.12",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34,199.42a.47.47,0,0,1-.42-.24.48.48,0,0,1,.18-.67l51.4-29.65a.5.5,0,0,1,.67.18.48.48,0,0,1-.18.67l-51.4,29.65A.54.54,0,0,1,161.34,199.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34,204a.49.49,0,0,1-.24-.92l51.4-29.64a.49.49,0,0,1,.49.85L161.59,204A.45.45,0,0,1,161.34,204Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34,208.61a.47.47,0,0,1-.42-.24.48.48,0,0,1,.18-.67l51.4-29.65a.5.5,0,0,1,.67.18.48.48,0,0,1-.18.67l-51.4,29.65A.54.54,0,0,1,161.34,208.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34,194.82a.49.49,0,0,1-.24-.92l51.4-29.64a.49.49,0,0,1,.49.85l-51.4,29.64A.45.45,0,0,1,161.34,194.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9,198.8a6.26,6.26,0,0,1-2.6,5c-1.44.83-2.61-.05-2.61-2a6.24,6.24,0,0,1,2.61-5C193.73,196,194.9,196.88,194.9,198.8Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.92 202.7 191.51 202.36 191.51 199.82 190.92 200.16 190.92 202.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.21,199.66a.85.85,0,0,0,.35-.68c0-.25-.15-.37-.35-.26a.84.84,0,0,0-.35.67C190.86,199.65,191,199.77,191.21,199.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.46,200.48a.85.85,0,0,1,.36-.78c.21-.12.32,0,.32.39v1.33l.59-.34v-1.61c0-.68-.29-.84-.7-.61a1.55,1.55,0,0,0-.57.75v-.34l-.57.33v2.55l.57-.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.88,193.61a6.21,6.21,0,0,1-2.6,5c-1.44.83-2.6-.05-2.6-2a6.23,6.23,0,0,1,2.6-5C202.72,190.81,203.88,191.69,203.88,193.61Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.28,193.4l.63-.35a.89.89,0,0,1,.3-.1.29.29,0,0,1,.18.05.46.46,0,0,1,.11.18,1.16,1.16,0,0,1,.06.35c0,.22,0,.28,0,.84s0,.63,0,.85a2.14,2.14,0,0,1-.06.42,1.92,1.92,0,0,1-.11.31,1.7,1.7,0,0,1-.18.26,1.52,1.52,0,0,1-.3.24l-.63.37-.63.36a.61.61,0,0,1-.29.09.23.23,0,0,1-.18-.05.31.31,0,0,1-.12-.17,1,1,0,0,1-.05-.36c0-.21,0-.28,0-.84s0-.62,0-.84a1.61,1.61,0,0,1,.05-.42,1.05,1.05,0,0,1,.12-.31,1,1,0,0,1,.18-.26,1.38,1.38,0,0,1,.29-.24,7.17,7.17,0,0,1,.63-.38m0-.38c-.42.25-.48.28-.64.39a1.82,1.82,0,0,0-.38.32,1.57,1.57,0,0,0-.28.4,1.82,1.82,0,0,0-.18.47,2.11,2.11,0,0,0-.07.55c0,.23,0,.3,0,.87s0,.63,0,.85a1.33,1.33,0,0,0,.07.47.49.49,0,0,0,.18.26.36.36,0,0,0,.28.08.8.8,0,0,0,.38-.12c.16-.09.22-.11.64-.36s.48-.28.65-.38a2.13,2.13,0,0,0,.38-.32,1.75,1.75,0,0,0,.27-.4,2.08,2.08,0,0,0,.19-.48,3.4,3.4,0,0,0,.07-.54c0-.23,0-.3,0-.87s0-.64,0-.86a2,2,0,0,0-.07-.46.53.53,0,0,0-.19-.27.43.43,0,0,0-.27-.08,1.07,1.07,0,0,0-.38.12l-.65.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.28,194a1.93,1.93,0,0,0-.8,1.54c0,.59.36.86.8.61a1.93,1.93,0,0,0,.81-1.54c0-.59-.36-.87-.81-.61m0,1.77c-.29.17-.52,0-.52-.4a1.23,1.23,0,0,1,.52-1c.29-.17.52,0,.52.39a1.25,1.25,0,0,1-.52,1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.31,193.41a.46.46,0,0,1-.19.36c-.11.06-.19,0-.19-.15a.43.43,0,0,1,.19-.35c.1-.06.19,0,.19.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.87,188.42a6.24,6.24,0,0,1-2.6,5c-1.44.83-2.6,0-2.6-2a6.21,6.21,0,0,1,2.6-5C211.7,185.63,212.87,186.51,212.87,188.42Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.84,191.43a1.16,1.16,0,0,0,.23-.26,2.59,2.59,0,0,0,.14-.29,1.36,1.36,0,0,0,.09-.48.61.61,0,0,0-.08-.34A.25.25,0,0,0,210,190a.79.79,0,0,0,.15-.24,1,1,0,0,0,.09-.44.6.6,0,0,0-.09-.36c-.1-.12-.27-.12-.52,0l-1,.56v2.66l.9-.52A1.31,1.31,0,0,0,209.84,191.43Zm-.78-1.71.43-.25a.72.72,0,0,1,.24-.1c.07,0,.11.06.11.19a.45.45,0,0,1-.09.28.55.55,0,0,1-.21.19l-.48.28Zm0,1.74v-.71l.49-.28a.32.32,0,0,1,.2-.07c.08,0,.13.07.13.21a.64.64,0,0,1-.14.41.56.56,0,0,1-.2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.64,190.84a.56.56,0,0,0,.52-.06,1.36,1.36,0,0,0,.55-.61,1.2,1.2,0,0,0,.15-.44l-.4.23a.75.75,0,0,1-.08.18.53.53,0,0,1-.21.21.28.28,0,0,1-.22.05c-.09,0-.14-.13-.15-.32l1.08-.63a3.18,3.18,0,0,0,0-.38.65.65,0,0,0-.11-.34.33.33,0,0,0-.26-.14.65.65,0,0,0-.35.1,1.5,1.5,0,0,0-.53.58,2,2,0,0,0-.2.91C210.41,190.54,210.49,190.76,210.64,190.84Zm.27-1.47a.62.62,0,0,1,.23-.25.25.25,0,0,1,.23,0,.32.32,0,0,1,.11.26l-.67.38A1,1,0,0,1,210.91,189.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.55 187.97 210.68 188.47 210.68 188.74 211.55 188.24 211.55 187.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.91,204a6.23,6.23,0,0,1-2.6,5c-1.44.83-2.6-.05-2.6-2a6.21,6.21,0,0,1,2.6-5C184.75,201.19,185.91,202.07,185.91,204Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.88,208l.69-.4v-2.32l.49-.28.05-.81-.54.31v-.44c0-.18,0-.27.16-.35l.38-.22v-.8l-.48.27a1.41,1.41,0,0,0-.75,1.32v.62l-.37.21v.79l.37-.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,230,211,219.83c.58-.34,1.06-.1,1.06.54a2.3,2.3,0,0,1-1.06,1.76l-17.62,10.18c-.59.33-1.06.09-1.06-.54A2.27,2.27,0,0,1,193.34,230Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,230,205,223.29c.59-.34,1.07-.1,1.07.53a2.28,2.28,0,0,1-1.07,1.77l-11.63,6.72c-.59.33-1.06.09-1.06-.54A2.27,2.27,0,0,1,193.34,230Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,224.92,211,214.75c.58-.34,1.06-.1,1.06.54a2.27,2.27,0,0,1-1.06,1.76l-17.62,10.18c-.59.34-1.06.09-1.06-.54A2.27,2.27,0,0,1,193.34,224.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,224.92l7-4c.59-.34,1.06-.1,1.06.53a2.27,2.27,0,0,1-1.06,1.77l-7,4.06c-.59.34-1.06.09-1.06-.54A2.27,2.27,0,0,1,193.34,224.92Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,235.08,211,224.91c.58-.34,1.06-.1,1.06.54a2.3,2.3,0,0,1-1.06,1.76l-17.62,10.17c-.59.34-1.06.1-1.06-.54A2.27,2.27,0,0,1,193.34,235.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,235.08l15.62-9c.59-.34,1.06-.1,1.06.54a2.27,2.27,0,0,1-1.06,1.76l-15.62,9c-.59.34-1.06.1-1.06-.54A2.27,2.27,0,0,1,193.34,235.08Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,240.16,211,230c.58-.34,1.06-.09,1.06.54a2.3,2.3,0,0,1-1.06,1.77l-17.62,10.17c-.59.34-1.06.1-1.06-.54A2.24,2.24,0,0,1,193.34,240.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,240.16,205,233.44c.59-.34,1.07-.1,1.07.54a2.28,2.28,0,0,1-1.07,1.76l-11.63,6.72c-.59.34-1.06.1-1.06-.54A2.24,2.24,0,0,1,193.34,240.16Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,245.23,211,235.06c.58-.34,1.06-.1,1.06.54a2.3,2.3,0,0,1-1.06,1.76l-17.62,10.18c-.59.33-1.06.09-1.06-.54A2.27,2.27,0,0,1,193.34,245.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,245.23l15.62-9c.59-.34,1.06-.1,1.06.54a2.27,2.27,0,0,1-1.06,1.77l-15.62,9c-.59.33-1.06.09-1.06-.54A2.27,2.27,0,0,1,193.34,245.23Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,232a.26.26,0,0,1-.23-.13.27.27,0,0,1,.1-.37l5.5-3.17a.27.27,0,0,1,.27.47l-5.5,3.17A.32.32,0,0,1,183.44,232Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,237.12a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l5.5-3.17a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37l-5.5,3.17A.32.32,0,0,1,183.44,237.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,242.21a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l5.5-3.17a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37l-5.5,3.16A.23.23,0,0,1,183.44,242.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,247.3a.27.27,0,0,1-.23-.14.28.28,0,0,1,.1-.37l5.5-3.17a.27.27,0,0,1,.27.47l-5.5,3.17A.23.23,0,0,1,183.44,247.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,252.39a.27.27,0,0,1-.23-.14.28.28,0,0,1,.1-.37l5.5-3.17a.27.27,0,0,1,.27.47l-5.5,3.17A.23.23,0,0,1,183.44,252.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,228.23c0-2.82,1.71-6.1,3.83-7.32s3.84.07,3.84,2.9-1.72,6.1-3.84,7.32S173,231.06,173,228.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.33,231.73a2.05,2.05,0,0,1-1.06-.28,3.55,3.55,0,0,1-1.39-3.22c0-2.86,1.75-6.2,3.9-7.44a2.59,2.59,0,0,1,2.65-.2,3.55,3.55,0,0,1,1.39,3.22c0,2.86-1.75,6.2-3.9,7.44A3.19,3.19,0,0,1,175.33,231.73Zm3-11.15a3,3,0,0,0-1.46.44c-2.08,1.2-3.77,4.44-3.77,7.21a3.3,3.3,0,0,0,1.26,3,2.34,2.34,0,0,0,2.37-.2c2.08-1.2,3.77-4.44,3.77-7.21a3.3,3.3,0,0,0-1.26-3A1.77,1.77,0,0,0,178.38,220.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.29,227.75h0s0,0-.05-.05c0-.48-.18-.62-.55-.42,0,0-.07,0-.07-.06a.58.58,0,0,0-.13-.48c-.09-.06-.22,0-.41.07H176a.06.06,0,0,1,0-.06c0-.25,0-.41-.13-.47s-.22-.05-.41.06h0a0,0,0,0,1-.07,0,.15.15,0,0,1,0-.11l2.41-4.61s.07-.07.1,0l1.85,1.4s0,.08,0,.13l-2.41,4.61Zm-.55-.7c.35-.15.55,0,.61.36l2.26-4.31-1.76-1.33-2.25,4.3a.35.35,0,0,1,.35,0c.11.08.16.24.17.49.2-.09.35-.1.45,0S176.73,226.8,176.74,227.05Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.74,230.15h-.05s0,0,0-.08l.7-3.81s0-.11.08-.11.06,0,.05.08l-.66,3.64,2.44-2.3s.07,0,.08,0a.16.16,0,0,1-.05.14l-2.55,2.41Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.74 230.06 175.43 229.3 175 228.98 174.74 230.06",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.06,226.54a0,0,0,0,1-.05,0s0-.08,0-.13l2-3.87s.07-.08.09-.06,0,.08,0,.14l-2,3.87A.12.12,0,0,1,177.06,226.54Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.44,226.07s0,0-.05,0,0-.08,0-.13l2-3.87s.07-.08.1-.06a.16.16,0,0,1,0,.14l-2,3.87A.12.12,0,0,1,176.44,226.07Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,267.15c0-2.83,1.71-6.11,3.83-7.33s3.84.07,3.84,2.9-1.72,6.1-3.84,7.33S173,270,173,267.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.33,270.64a2.14,2.14,0,0,1-1.06-.27,3.57,3.57,0,0,1-1.39-3.22c0-2.87,1.75-6.21,3.9-7.45a2.59,2.59,0,0,1,2.65-.2,3.55,3.55,0,0,1,1.39,3.22c0,2.86-1.75,6.2-3.9,7.44A3.19,3.19,0,0,1,175.33,270.64Zm3-11.15a2.9,2.9,0,0,0-1.46.45c-2.08,1.19-3.77,4.43-3.77,7.21a3.29,3.29,0,0,0,1.26,3,2.32,2.32,0,0,0,2.37-.2c2.08-1.2,3.77-4.44,3.77-7.21a3.3,3.3,0,0,0-1.26-3A1.77,1.77,0,0,0,178.38,259.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32,267.61h0a.05.05,0,0,1,0-.05,1.34,1.34,0,0,0-.43-1.1,1.51,1.51,0,0,1-.41-1.31,3.57,3.57,0,0,1,1.28-2.49h0a1,1,0,0,1,1.14-.18,1.32,1.32,0,0,1,.49,1.17,3.71,3.71,0,0,1-.43,1.63,3.42,3.42,0,0,0-.43,1.58.19.19,0,0,1-.07.14Zm.08-.13Zm.31-4.65a3.2,3.2,0,0,0-1.16,2.25,1.37,1.37,0,0,0,.37,1.19,1.4,1.4,0,0,1,.47,1.12l.93-.54a3.86,3.86,0,0,1,.47-1.65,3.23,3.23,0,0,0,.39-1.47,1.18,1.18,0,0,0-.44-1.05.91.91,0,0,0-1,.15Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.39,268.46l-1.07.61s-.07,0-.07-.05v-.85a.19.19,0,0,1,.07-.13l1.07-.62s.07,0,.07.06v.84A.16.16,0,0,1,177.39,268.46Zm-1,.39.92-.54v-.66l-.92.54Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,267.21s-.07,0-.07,0a7.11,7.11,0,0,1,.25-1.93l-.68.39a4.54,4.54,0,0,1,.25,1.64.16.16,0,0,1-.07.14s-.07,0-.07,0a3.44,3.44,0,0,0-.29-1.67.17.17,0,0,1,0-.1s0-.07.06-.08l.91-.53a0,0,0,0,1,.06,0,.07.07,0,0,1,0,.09,6.79,6.79,0,0,0-.28,2A.16.16,0,0,1,177,267.21Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.86,262s-.07,0-.07-.06v-.83a.19.19,0,0,1,.07-.14s.07,0,.07.06v.83A.19.19,0,0,1,176.86,262Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.88,262.86a0,0,0,0,1-.06,0l-.31-.54a.15.15,0,0,1,0-.14c0-.05.08-.06.1,0l.31.54a.15.15,0,0,1,0,.14Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.16,264.22h0l-.55-.1s0-.06,0-.12.06-.09.09-.09l.55.11s0,.05,0,.11A.1.1,0,0,1,175.16,264.22Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9,265.68l-.63.36s-.07,0-.07-.05a.16.16,0,0,1,.07-.14l.63-.36s.07,0,.07.05A.19.19,0,0,1,174.9,265.68Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.61,267.56a0,0,0,0,1-.06,0,.13.13,0,0,1,0-.14l.54-.73c0-.05.08-.06.1,0a.2.2,0,0,1,0,.14l-.54.73A.05.05,0,0,1,174.61,267.56Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.08,265h0l-.54-.11s0-.06,0-.11.06-.1.1-.09l.54.1s0,.06,0,.12A.16.16,0,0,1,179.08,265Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.43,263.08l-.62.36s-.07,0-.07-.05a.16.16,0,0,1,.07-.14l.62-.36s.07,0,.07.05A.19.19,0,0,1,179.43,263.08Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.55,262.28s-.05,0-.06,0a.15.15,0,0,1,0-.14l.55-.73s.07-.06.09,0a.15.15,0,0,1,0,.14l-.55.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.84,261.74h0s0-.06,0-.12l.32-.9c0-.06.06-.1.09-.09s0,.05,0,.11l-.31.91Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,285.36c0-2.82,1.71-6.1,3.83-7.33s3.84.08,3.84,2.9-1.72,6.11-3.84,7.33S173,288.19,173,285.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.33,288.86a2.05,2.05,0,0,1-1.06-.28,3.55,3.55,0,0,1-1.39-3.22c0-2.86,1.75-6.2,3.9-7.44a2.59,2.59,0,0,1,2.65-.2,3.54,3.54,0,0,1,1.39,3.21c0,2.87-1.75,6.21-3.9,7.45A3.19,3.19,0,0,1,175.33,288.86Zm3-11.15a3,3,0,0,0-1.46.44c-2.08,1.2-3.77,4.44-3.77,7.21a3.3,3.3,0,0,0,1.26,3,2.37,2.37,0,0,0,2.37-.2c2.08-1.2,3.77-4.44,3.77-7.22a3.29,3.29,0,0,0-1.26-3A1.77,1.77,0,0,0,178.38,277.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.35,286.28l-1,.57s-.07,0-.07-.05v-.68a1,1,0,0,1-.43,0l-.36.69c0,.05-.07.08-.1.06l-.7-.54s0-.08,0-.13l.36-.68a1.71,1.71,0,0,1-.18-.48l-.51.3s-.07,0-.07-.06V284a.16.16,0,0,1,.07-.13l.51-.29a4.27,4.27,0,0,1,.18-.68l-.36-.27s0-.08,0-.14l.7-1.34c0-.05.07-.08.1-.06l.36.27a5.19,5.19,0,0,1,.43-.49v-.67a.19.19,0,0,1,.07-.14l1-.57s.07,0,.07.05v.68a1,1,0,0,1,.43,0l.36-.69c0-.05.07-.08.1-.06l.7.54a.05.05,0,0,1,0,.05.13.13,0,0,1,0,.08l-.35.68a2.08,2.08,0,0,1,.17.48l.51-.3s.07,0,.07.06v1.33a.16.16,0,0,1-.07.13l-.51.29a5.2,5.2,0,0,1-.17.68l.35.27a.06.06,0,0,1,0,.06.16.16,0,0,1,0,.08l-.7,1.34c0,.05-.07.08-.1.06l-.36-.27a5.19,5.19,0,0,1-.43.49v.67A.19.19,0,0,1,177.35,286.28Zm-.93.34.86-.49v-.65a.19.19,0,0,1,.05-.13,3.48,3.48,0,0,0,.5-.56s.06-.05.08,0l.35.26.61-1.15-.35-.27s0-.06,0-.1a4.71,4.71,0,0,0,.2-.78.15.15,0,0,1,.07-.11l.49-.29v-1.14l-.49.29a.05.05,0,0,1-.07,0,1.83,1.83,0,0,0-.2-.54s0-.07,0-.12l.35-.66-.61-.46-.35.67s-.06.07-.08.06a1.21,1.21,0,0,0-.5,0s-.05,0-.05-.06v-.65l-.86.49v.65a.19.19,0,0,1,0,.13,3,3,0,0,0-.49.56s-.07.05-.09,0l-.35-.26-.6,1.15.34.27s0,.06,0,.1a4.13,4.13,0,0,0-.21.78.15.15,0,0,1-.07.11l-.49.29v1.14l.49-.29a.05.05,0,0,1,.07,0,1.6,1.6,0,0,0,.21.54.14.14,0,0,1,0,.12l-.34.66.6.46.35-.66a.1.1,0,0,1,.09-.07,1.16,1.16,0,0,0,.49,0s0,0,0,.06Zm.43-1.85c-.67.38-1.21,0-1.21-.92a2.92,2.92,0,0,1,1.21-2.32c.67-.38,1.21,0,1.21.92A2.92,2.92,0,0,1,176.85,284.77Zm0-3a2.57,2.57,0,0,0-1.07,2c0,.79.48,1.15,1.07.81a2.57,2.57,0,0,0,1.07-2.05C177.92,281.74,177.44,281.38,176.85,281.72Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,303.58c0-2.82,1.71-6.11,3.83-7.33s3.84.08,3.84,2.9-1.72,6.11-3.84,7.33S173,306.4,173,303.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.33,307.07a2.14,2.14,0,0,1-1.06-.27,3.56,3.56,0,0,1-1.39-3.22c0-2.86,1.75-6.2,3.9-7.45a2.64,2.64,0,0,1,2.65-.2,3.56,3.56,0,0,1,1.39,3.22c0,2.86-1.75,6.2-3.9,7.45A3.28,3.28,0,0,1,175.33,307.07Zm3-11.14a3,3,0,0,0-1.46.44c-2.08,1.2-3.77,4.43-3.77,7.21a3.29,3.29,0,0,0,1.26,3,2.32,2.32,0,0,0,2.37-.2c2.08-1.2,3.77-4.43,3.77-7.21a3.29,3.29,0,0,0-1.26-3A1.77,1.77,0,0,0,178.38,295.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.62,305.74h-.05a.13.13,0,0,1,0-.09l.38-1.74a2.71,2.71,0,0,1-.3-1.34,5.4,5.4,0,0,1,2.25-4.31c1.25-.72,2.26,0,2.26,1.7a5.4,5.4,0,0,1-2.26,4.31,1.62,1.62,0,0,1-1.06.26l-1.18,1.19Zm2.27-7.3a5.11,5.11,0,0,0-2.11,4.05,2.47,2.47,0,0,0,.3,1.28s0,0,0,.07l-.35,1.59,1.07-1.08s0,0,.06,0a1.61,1.61,0,0,0,1-.24,5.09,5.09,0,0,0,2.12-4C179,298.49,178.06,297.77,176.89,298.44Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.58,300.94a.74.74,0,0,1,.31-.59c.18-.1.31,0,.31.23a.73.73,0,0,1-.31.6C177.72,301.28,177.58,301.17,177.58,300.94Z",
    style: {
      fill: "#46C5FB",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.54,301.54a.76.76,0,0,1,.31-.59c.17-.1.31,0,.31.24a.76.76,0,0,1-.31.59C176.68,301.88,176.54,301.77,176.54,301.54Z",
    style: {
      fill: "#46C5FB",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,302.15a.76.76,0,0,1,.31-.6c.17-.09.31,0,.31.24a.74.74,0,0,1-.31.59C175.64,302.48,175.5,302.37,175.5,302.15Z",
    style: {
      fill: "#46C5FB",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,217.6l16.41-9.47c.33-.19.59-.06.59.29a1.25,1.25,0,0,1-.59,1L184,218.87c-.32.19-.58.06-.58-.29A1.28,1.28,0,0,1,184,217.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,223.29a.27.27,0,0,1-.23-.14.28.28,0,0,1,.1-.37l28.57-16.49a.27.27,0,0,1,.27.47l-28.57,16.49A.23.23,0,0,1,183.44,223.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,225.83a.27.27,0,0,1-.23-.14.28.28,0,0,1,.1-.37l22-12.69a.27.27,0,0,1,.27.47l-22,12.69A.23.23,0,0,1,183.44,225.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,258.22l16.41-9.48c.33-.19.59-.06.59.3a1.24,1.24,0,0,1-.59,1L184,259.48c-.32.19-.58.06-.58-.29A1.24,1.24,0,0,1,184,258.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,263.9a.27.27,0,0,1-.24-.14.26.26,0,0,1,.1-.36l28.57-16.5a.27.27,0,0,1,.27.47l-28.57,16.49A.22.22,0,0,1,183.45,263.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,266.44a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.37l28.57-16.49a.27.27,0,0,1,.27.47L183.58,266.4A.22.22,0,0,1,183.45,266.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,269a.28.28,0,0,1-.24-.13.27.27,0,0,1,.1-.37L211.88,252a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-28.57,16.5A.31.31,0,0,1,183.45,269Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,271.51a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.37l22-12.68a.27.27,0,0,1,.27.47l-22,12.68A.22.22,0,0,1,183.45,271.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,276l16.41-9.48c.33-.19.59-.05.59.3a1.24,1.24,0,0,1-.59,1L184,277.26c-.32.18-.58.05-.58-.3A1.24,1.24,0,0,1,184,276Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,281.67a.28.28,0,0,1-.24-.13.27.27,0,0,1,.1-.37l28.57-16.5a.27.27,0,0,1,.27.47l-28.57,16.5A.31.31,0,0,1,183.45,281.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,284.21a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.37l28.57-16.49a.27.27,0,1,1,.27.47l-28.57,16.49A.22.22,0,0,1,183.45,284.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,286.74a.26.26,0,0,1-.24-.13.27.27,0,0,1,.1-.37l28.57-16.5a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-28.57,16.5A.31.31,0,0,1,183.45,286.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,289.28a.27.27,0,0,1-.24-.14.26.26,0,0,1,.1-.36l22-12.69a.27.27,0,1,1,.27.47l-22,12.68A.22.22,0,0,1,183.45,289.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,293.75l16.41-9.47c.33-.19.59-.06.59.29a1.26,1.26,0,0,1-.59,1L184,295c-.32.19-.58.06-.58-.29A1.28,1.28,0,0,1,184,293.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,299.44a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.37l28.57-16.49a.27.27,0,0,1,.37.1.26.26,0,0,1-.1.36l-28.57,16.5A.22.22,0,0,1,183.45,299.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,302a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.37L211.88,285a.27.27,0,0,1,.37.09.27.27,0,0,1-.1.37l-28.57,16.5A.33.33,0,0,1,183.45,302Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,304.51a.28.28,0,0,1-.24-.13.27.27,0,0,1,.1-.37l15.39-8.89a.27.27,0,1,1,.27.47l-15.39,8.88A.22.22,0,0,1,183.45,304.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.27,243l16.41-9.47c.32-.19.59-.06.59.29a1.26,1.26,0,0,1-.59,1l-16.41,9.48c-.33.19-.59.06-.59-.3A1.24,1.24,0,0,1,142.27,243Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,251.89a.07.07,0,0,1-.07-.07v-3.88a.07.07,0,0,1,.14,0v3.88A.07.07,0,0,1,146.08,251.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,261.08A.07.07,0,0,1,146,261v-3.89a.07.07,0,0,1,.14,0V261A.07.07,0,0,1,146.08,261.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,311.9a.07.07,0,0,1-.07-.07V308a.07.07,0,1,1,.14,0v3.88A.07.07,0,0,1,146.08,311.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,297.55a.08.08,0,0,1-.07-.07V293.6a.07.07,0,1,1,.14,0v3.88A.08.08,0,0,1,146.08,297.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,306.74a.07.07,0,0,1-.07-.06v-3.89a.07.07,0,0,1,.14,0v3.89A.07.07,0,0,1,146.08,306.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,320.49a.07.07,0,0,1-.07-.06v-3.89a.07.07,0,0,1,.14,0v3.89A.07.07,0,0,1,146.08,320.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,272.37a.07.07,0,0,1-.07-.07v-3.88a.07.07,0,0,1,.14,0v3.88A.07.07,0,0,1,146.08,272.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,282.51a.07.07,0,0,1-.07-.07v-3.88a.07.07,0,1,1,.14,0v3.88A.07.07,0,0,1,146.08,282.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,287.68a.07.07,0,0,1-.07-.07v-3.88a.07.07,0,1,1,.14,0v3.88A.07.07,0,0,1,146.08,287.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,267.22a.07.07,0,0,1-.07-.07v-4.86a.07.07,0,0,1,.14,0v4.86A.07.07,0,0,1,146.08,267.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,255.93a.07.07,0,0,1-.07-.06v-2.78a.07.07,0,0,1,.14,0v2.78A.07.07,0,0,1,146.08,255.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,277.36a.07.07,0,0,1-.07-.07v-3.72a.07.07,0,1,1,.14,0v3.72A.07.07,0,0,1,146.08,277.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,292.39a.07.07,0,0,1-.07-.06v-3.45a.07.07,0,1,1,.14,0v3.45A.07.07,0,0,1,146.08,292.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,301.59a.07.07,0,0,1-.07-.06v-2.78a.07.07,0,1,1,.14,0v2.78A.07.07,0,0,1,146.08,301.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,315.34a.07.07,0,0,1-.07-.06V313.1a.07.07,0,1,1,.14,0v2.18A.07.07,0,0,1,146.08,315.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,248.08a.34.34,0,0,1-.17-.05.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.25,1.25,0,0,1-.59,1A.51.51,0,0,1,145.83,248.08Zm.49-1.42a.4.4,0,0,0-.21.07,1.13,1.13,0,0,0-.51.89.34.34,0,0,0,.12.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9c0-.14,0-.25-.13-.29A.2.2,0,0,0,146.32,246.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,257.28a.34.34,0,0,1-.17,0,.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.27,1.27,0,0,1-.59,1A.51.51,0,0,1,145.83,257.28Zm.49-1.42a.48.48,0,0,0-.21.06,1.17,1.17,0,0,0-.51.9.31.31,0,0,0,.12.29.32.32,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9c0-.14,0-.25-.13-.29A.2.2,0,0,0,146.32,255.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,293.74a.34.34,0,0,1-.17-.05.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.28,1.28,0,0,1-.59,1A.51.51,0,0,1,145.83,293.74Zm.49-1.42a.4.4,0,0,0-.21.07,1.13,1.13,0,0,0-.51.89.34.34,0,0,0,.12.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9c0-.14,0-.25-.13-.29A.2.2,0,0,0,146.32,292.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,302.94a.34.34,0,0,1-.17-.05.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.3,1.3,0,0,1-.59,1A.51.51,0,0,1,145.83,302.94Zm.49-1.42a.48.48,0,0,0-.21.06,1.17,1.17,0,0,0-.51.9.31.31,0,0,0,.12.29.32.32,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9c0-.14,0-.25-.13-.29A.2.2,0,0,0,146.32,301.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,316.69a.34.34,0,0,1-.17-.05.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.27,1.27,0,0,1-.59,1A.51.51,0,0,1,145.83,316.69Zm.49-1.42a.48.48,0,0,0-.21.06,1.17,1.17,0,0,0-.51.9.31.31,0,0,0,.12.29.31.31,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9c0-.14,0-.25-.13-.29A.2.2,0,0,0,146.32,315.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,268.56a.34.34,0,0,1-.17-.05.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.31,1.31,0,0,1-.59,1A.6.6,0,0,1,145.83,268.56Zm.49-1.42a.4.4,0,0,0-.21.07,1.13,1.13,0,0,0-.51.89.34.34,0,0,0,.12.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9c0-.14,0-.25-.13-.29A.2.2,0,0,0,146.32,267.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,278.7a.33.33,0,0,1-.17,0,.45.45,0,0,1-.2-.42,1.3,1.3,0,0,1,.58-1,.45.45,0,0,1,.46,0,.43.43,0,0,1,.2.41,1.27,1.27,0,0,1-.59,1A.5.5,0,0,1,145.83,278.7Zm.49-1.42a.52.52,0,0,0-.21.07,1.16,1.16,0,0,0-.51.89.33.33,0,0,0,.12.3.3.3,0,0,0,.32,0,1.12,1.12,0,0,0,.52-.89.32.32,0,0,0-.13-.3A.2.2,0,0,0,146.32,277.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,253.23a.34.34,0,0,1-.17,0,.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.31,1.31,0,0,1-.59,1A.6.6,0,0,1,145.83,253.23Zm.49-1.42a.4.4,0,0,0-.21.07,1.13,1.13,0,0,0-.51.89.34.34,0,0,0,.12.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9.3.3,0,0,0-.13-.29A.2.2,0,0,0,146.32,251.81Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,262.43a.34.34,0,0,1-.17-.05.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.25,1.25,0,0,1-.59,1A.51.51,0,0,1,145.83,262.43Zm.49-1.42a.4.4,0,0,0-.21.07,1.13,1.13,0,0,0-.51.89.34.34,0,0,0,.12.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9c0-.14,0-.25-.13-.29A.2.2,0,0,0,146.32,261Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,313.24a.26.26,0,0,1-.17-.05.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.45.45,0,0,1,.2.42,1.28,1.28,0,0,1-.59,1A.6.6,0,0,1,145.83,313.24Zm.49-1.42a.4.4,0,0,0-.21.07,1.13,1.13,0,0,0-.51.89.34.34,0,0,0,.12.3.32.32,0,0,0,.32,0,1.13,1.13,0,0,0,.52-.89.31.31,0,0,0-.13-.3A.2.2,0,0,0,146.32,311.82Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,298.89a.34.34,0,0,1-.17-.05.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.29,1.29,0,0,1-.59,1A.6.6,0,0,1,145.83,298.89Zm.49-1.42a.4.4,0,0,0-.21.07,1.13,1.13,0,0,0-.51.89.34.34,0,0,0,.12.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9.3.3,0,0,0-.13-.29A.2.2,0,0,0,146.32,297.47Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,308.09a.34.34,0,0,1-.17,0,.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.25,1.25,0,0,1-.59,1A.51.51,0,0,1,145.83,308.09Zm.49-1.42a.4.4,0,0,0-.21.07,1.13,1.13,0,0,0-.51.89.34.34,0,0,0,.12.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9c0-.14,0-.25-.13-.29A.2.2,0,0,0,146.32,306.67Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,321.84a.34.34,0,0,1-.17,0,.44.44,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.3,1.3,0,0,1-.59,1A.51.51,0,0,1,145.83,321.84Zm.49-1.42a.48.48,0,0,0-.21.06,1.17,1.17,0,0,0-.51.9.34.34,0,0,0,.12.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9c0-.14,0-.25-.13-.29A.2.2,0,0,0,146.32,320.42Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,273.71a.26.26,0,0,1-.17,0,.43.43,0,0,1-.2-.41,1.28,1.28,0,0,1,.58-1,.46.46,0,0,1,.46,0,.45.45,0,0,1,.2.42,1.28,1.28,0,0,1-.59,1A.6.6,0,0,1,145.83,273.71Zm.49-1.42a.4.4,0,0,0-.21.07,1.13,1.13,0,0,0-.51.89.34.34,0,0,0,.12.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.89.31.31,0,0,0-.13-.3A.2.2,0,0,0,146.32,272.29Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,283.86a.34.34,0,0,1-.17-.05.44.44,0,0,1-.2-.41,1.3,1.3,0,0,1,.58-1,.45.45,0,0,1,.46,0,.44.44,0,0,1,.2.41,1.3,1.3,0,0,1-.59,1A.51.51,0,0,1,145.83,283.86Zm.49-1.42a.48.48,0,0,0-.21.06,1.17,1.17,0,0,0-.51.9.31.31,0,0,0,.12.29.3.3,0,0,0,.32,0,1.12,1.12,0,0,0,.52-.89.32.32,0,0,0-.13-.3A.2.2,0,0,0,146.32,282.44Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,289a.33.33,0,0,1-.17,0,.46.46,0,0,1-.2-.42,1.3,1.3,0,0,1,.58-1,.41.41,0,0,1,.66.38,1.27,1.27,0,0,1-.59,1A.6.6,0,0,1,145.83,289Zm.49-1.42a.52.52,0,0,0-.21.07,1.13,1.13,0,0,0-.51.89.33.33,0,0,0,.12.3.32.32,0,0,0,.32,0,1.12,1.12,0,0,0,.52-.89.31.31,0,0,0-.13-.3A.2.2,0,0,0,146.32,287.6Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.72,249.64a.5.5,0,0,1,0-.12.74.74,0,0,1,0-.14.75.75,0,0,1,.07-.12.28.28,0,0,1,.1-.09l.11,0a.11.11,0,0,1,.07,0,.19.19,0,0,1,0,.09.36.36,0,0,1,0,.11.69.69,0,0,1,0,.2,1.65,1.65,0,0,1-.09.21l-.24.53.35-.21s0,0,0,0v0a.08.08,0,0,1,0,0l-.43.25s0,0,0,0v0a0,0,0,0,1,0,0s0,0,0-.05l.27-.58a.93.93,0,0,0,.05-.1l0-.09s0-.05,0-.07v-.07a.21.21,0,0,0,0-.15.11.11,0,0,0-.12,0,.36.36,0,0,0-.11.13.59.59,0,0,0-.05.2,0,0,0,0,1,0,0s0,0,0,0h0S141.72,249.66,141.72,249.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,249.41c0-.06,0-.12,0-.18a.84.84,0,0,1,0-.17.61.61,0,0,1,.07-.14l.12-.11c.05,0,.09,0,.12,0a.14.14,0,0,1,.08.05.34.34,0,0,1,0,.12.88.88,0,0,1,0,.16v.28c0,.06,0,.12,0,.18a.75.75,0,0,1,0,.16.71.71,0,0,1-.08.15.4.4,0,0,1-.12.1.14.14,0,0,1-.12,0s0,0-.07,0a.33.33,0,0,1,0-.12c0-.05,0-.1,0-.16Zm.44-.25a.44.44,0,0,0,0-.23c0-.05-.07-.06-.14,0a.37.37,0,0,0-.14.18.85.85,0,0,0,0,.29v.25a.49.49,0,0,0,0,.24s.08,0,.14,0a.27.27,0,0,0,.14-.17.84.84,0,0,0,0-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23,249.55a.08.08,0,0,1,0,0h0s0,0,0,0v-1L143,249s0,0,0,0v0a0,0,0,0,1,0,0l.22-.4v0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8,248.89a.31.31,0,0,0,0-.1.15.15,0,0,0,0-.06l-.06,0a.13.13,0,0,0-.08,0,.15.15,0,0,0-.06,0l0,.06a.05.05,0,0,0,0,.05l0,0h0s0,0,0,0l0-.55s0,0,0-.05l.34-.2s0,0,0,0v0s0,0,0,.05l-.3.17,0,.38s0,0,0-.06a.35.35,0,0,1,.09-.07l.1,0a.11.11,0,0,1,.08,0,.17.17,0,0,1,.06.08.61.61,0,0,1,0,.15.88.88,0,0,1,0,.17.52.52,0,0,1-.06.15.36.36,0,0,1-.08.12.39.39,0,0,1-.1.08l-.1,0a.08.08,0,0,1-.07,0,.12.12,0,0,1-.05-.07.3.3,0,0,1,0-.1,0,0,0,0,1,0,0h.05v0a.12.12,0,0,0,0,.07l0,0h.06l.05,0a.21.21,0,0,0,.08-.06l.06-.09s0-.07,0-.11A.53.53,0,0,0,143.8,248.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.71,258.62a.6.6,0,0,1,0-.12.5.5,0,0,1,0-.13.54.54,0,0,1,.07-.13l.1-.09.11,0a.11.11,0,0,1,.07,0,.19.19,0,0,1,0,.09.36.36,0,0,1,0,.11.69.69,0,0,1,0,.2,1.65,1.65,0,0,1-.09.21l-.25.53.36-.21s0,0,0,0v0a.06.06,0,0,1,0,.05l-.43.25s0,0,0,0v0a0,0,0,0,1,0,0,.17.17,0,0,1,0-.05l.27-.58.05-.1,0-.09a.64.64,0,0,0,0-.07v-.07a.21.21,0,0,0,0-.15.11.11,0,0,0-.12,0,.28.28,0,0,0-.11.13.59.59,0,0,0-.05.2,0,0,0,0,1,0,0v0h0S141.71,258.64,141.71,258.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.31,258.39a.78.78,0,0,1,.06-.35.61.61,0,0,1,.07-.14.43.43,0,0,1,.12-.11l.12,0a.16.16,0,0,1,.08.06.36.36,0,0,1,0,.11.88.88,0,0,1,0,.17v.27c0,.06,0,.12,0,.18a1,1,0,0,1,0,.17.64.64,0,0,1-.08.14.29.29,0,0,1-.12.1.24.24,0,0,1-.12,0,.13.13,0,0,1-.07-.06.33.33,0,0,1-.05-.12c0-.05,0-.1,0-.16Zm.44-.25a.44.44,0,0,0-.05-.23c0-.05-.08-.05-.14,0a.37.37,0,0,0-.14.18.85.85,0,0,0,0,.29v.25a.47.47,0,0,0,0,.24s.08,0,.14,0a.37.37,0,0,0,.14-.18.84.84,0,0,0,.05-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,258.53a.08.08,0,0,1,0,.05h0s0,0,0,0v-1l-.18.33s0,0,0,0v0a0,0,0,0,1,0,0l.22-.4h0l0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,258.12V258s0-.06,0-.09l0-.08s0,0,0-.06l.21-.57v0s0,0,0,0h0v0h0l-.16.43,0,0,0,0a.13.13,0,0,1,.11,0,.11.11,0,0,1,.08,0,.31.31,0,0,1,.05.1.51.51,0,0,1,0,.13.77.77,0,0,1,0,.15.66.66,0,0,1-.05.15.64.64,0,0,1-.08.14.31.31,0,0,1-.11.09.13.13,0,0,1-.11,0,.09.09,0,0,1-.08,0,.19.19,0,0,1-.05-.09A.53.53,0,0,1,143.37,258.12Zm.44-.26a.31.31,0,0,0,0-.11l-.05-.07-.06,0-.07,0-.07.05-.06.09a.56.56,0,0,0,0,.12.51.51,0,0,0,0,.13.31.31,0,0,0,0,.11.16.16,0,0,0,0,.07l.06,0a.11.11,0,0,0,.07,0,.18.18,0,0,0,.07-.05.47.47,0,0,0,.06-.09l.05-.12A.53.53,0,0,0,143.81,257.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,269.85a.69.69,0,0,1,0-.13.65.65,0,0,1,0-.13.75.75,0,0,1,.07-.12.28.28,0,0,1,.1-.09.19.19,0,0,1,.11,0s0,0,.06,0a.12.12,0,0,1,0,.08.5.5,0,0,1,0,.12.63.63,0,0,1,0,.19,1,1,0,0,1-.09.21l-.25.53.36-.2s0,0,0,0v0a.08.08,0,0,1,0,.05l-.43.24s0,0,0,0v0a.08.08,0,0,1,0,0l0-.05.27-.57.05-.11,0-.08a.64.64,0,0,1,0-.07v-.07c0-.08,0-.13,0-.15s-.07,0-.12,0a.35.35,0,0,0-.11.13.65.65,0,0,0-.05.2s0,0,0,0h0l0,0S141.81,269.87,141.81,269.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.41,269.61a1.09,1.09,0,0,1,0-.18,1,1,0,0,1,.05-.16.41.41,0,0,1,.07-.15.4.4,0,0,1,.12-.1.15.15,0,0,1,.12,0,.1.1,0,0,1,.08.05.34.34,0,0,1,0,.12s0,.1,0,.16v.27c0,.06,0,.12,0,.18a.85.85,0,0,1,0,.17.64.64,0,0,1-.08.14.32.32,0,0,1-.12.11.15.15,0,0,1-.12,0s-.06,0-.07-.05a.33.33,0,0,1-.05-.12.81.81,0,0,1,0-.16Zm.44-.24a.48.48,0,0,0,0-.24s-.08-.05-.14,0a.3.3,0,0,0-.14.17.88.88,0,0,0,0,.29.85.85,0,0,0,0,.26.43.43,0,0,0,0,.23c0,.05.08.06.14,0a.33.33,0,0,0,.14-.18.79.79,0,0,0,0-.29v-.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.32,269.76s0,0,0,0l0,0s0,0,0,0v-1l-.18.33s0,0,0,0h0v0a0,0,0,0,1,0,0l.22-.39v0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.87,268.34s0,0,0,0v.06a0,0,0,0,1,0,0l-.26,1.13a0,0,0,0,0,0,0l0,0h0v0h0l.27-1.15-.36.21s0,0,0,0v0s0,0,0-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.68,280.07a.49.49,0,0,1,0-.12.74.74,0,0,1,0-.14.75.75,0,0,1,.07-.12.31.31,0,0,1,.11-.09l.1,0a.09.09,0,0,1,.07,0,.2.2,0,0,1,0,.08s0,.08,0,.12a.69.69,0,0,1,0,.2,1.65,1.65,0,0,1-.09.21l-.24.53.35-.21s0,0,0,0v0s0,0,0,.05l-.43.25s0,0,0,0v-.06l0-.05.27-.58a.93.93,0,0,0,0-.1l0-.09s0-.05,0-.07v-.07a.21.21,0,0,0,0-.15s-.06,0-.11,0a.3.3,0,0,0-.12.13.59.59,0,0,0,0,.2,0,0,0,0,1,0,0v0h0S141.68,280.09,141.68,280.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.27,279.84a1.1,1.1,0,0,1,0-.18.47.47,0,0,1,0-.17.61.61,0,0,1,.07-.14l.12-.11s.09,0,.12,0a.11.11,0,0,1,.08.05.34.34,0,0,1,0,.12.88.88,0,0,1,0,.17v.27a1.1,1.1,0,0,1,0,.18.75.75,0,0,1,0,.16.44.44,0,0,1-.08.15.4.4,0,0,1-.12.1.14.14,0,0,1-.12,0s-.05,0-.07-.05a.21.21,0,0,1,0-.12.78.78,0,0,1,0-.16Zm.44-.25a.41.41,0,0,0-.05-.23c0-.05-.07-.06-.14,0a.35.35,0,0,0-.13.18.84.84,0,0,0,0,.29v.25a.48.48,0,0,0,0,.24c0,.05.07.05.13,0a.27.27,0,0,0,.14-.17.84.84,0,0,0,.05-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.18,280s0,0,0,0h0s0,0,0,0v-1l-.19.33s0,0,0,0l0,0v0a0,0,0,0,1,0,0l.22-.4,0,0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.33,279.61a.48.48,0,0,1,0-.2.8.8,0,0,1,.08-.16s0,0-.07-.06a.39.39,0,0,1,0-.13.34.34,0,0,1,0-.14.61.61,0,0,1,.05-.12.36.36,0,0,1,.07-.1.28.28,0,0,1,.09-.07l.1,0h.07a.18.18,0,0,1,.05.07.37.37,0,0,1,0,.12.78.78,0,0,1,0,.16.61.61,0,0,1-.07.14.09.09,0,0,1,.08.06.25.25,0,0,1,0,.16.77.77,0,0,1,0,.15l-.06.14a.44.44,0,0,1-.08.11.38.38,0,0,1-.11.08.21.21,0,0,1-.1,0h-.08a.28.28,0,0,1-.06-.08A.44.44,0,0,1,143.33,279.61Zm.07,0a.22.22,0,0,0,0,.09.08.08,0,0,0,.05,0l.06,0,.07,0,.08-.06a.47.47,0,0,0,.06-.09.31.31,0,0,0,.05-.1.34.34,0,0,0,0-.1.31.31,0,0,0,0-.1.12.12,0,0,0-.05-.05h-.06l-.08,0-.07.06a.21.21,0,0,0-.06.08l-.05.1A.41.41,0,0,0,143.4,279.57Zm0-.55a.19.19,0,0,0,0,.08l0,0h.06l.06,0a.26.26,0,0,0,.12-.12l0-.08a.28.28,0,0,0,0-.09.19.19,0,0,0,0-.08l0,0h-.05l-.07,0-.06,0-.06.08,0,.08A.29.29,0,0,0,143.42,279Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.72,295.3a.5.5,0,0,1,0-.12.74.74,0,0,1,0-.14.75.75,0,0,1,.07-.12.28.28,0,0,1,.1-.09l.11,0a.11.11,0,0,1,.07,0,.19.19,0,0,1,0,.08.5.5,0,0,1,0,.12.69.69,0,0,1,0,.2,1.65,1.65,0,0,1-.09.21l-.24.53.35-.21s0,0,0,0v0a.08.08,0,0,1,0,.05l-.43.25s0,0,0,0v0a0,0,0,0,1,0,0s0,0,0,0l.27-.58.05-.1,0-.09s0,0,0-.07v-.07a.21.21,0,0,0,0-.15.11.11,0,0,0-.12,0,.36.36,0,0,0-.11.13.59.59,0,0,0-.05.2,0,0,0,0,1,0,0v0h0S141.72,295.32,141.72,295.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,295.07c0-.06,0-.12,0-.18a.84.84,0,0,1,0-.17.61.61,0,0,1,.07-.14l.12-.11c.05,0,.09,0,.12,0a.14.14,0,0,1,.08.05.34.34,0,0,1,0,.12.88.88,0,0,1,0,.16v.28c0,.06,0,.12,0,.18a.75.75,0,0,1,0,.16.71.71,0,0,1-.08.15.4.4,0,0,1-.12.1.14.14,0,0,1-.12,0s0,0-.07-.05a.33.33,0,0,1,0-.12c0-.05,0-.1,0-.16Zm.44-.25a.41.41,0,0,0,0-.23s-.07-.06-.14,0a.37.37,0,0,0-.14.18.85.85,0,0,0,0,.29v.25a.49.49,0,0,0,0,.24s.08.05.14,0a.27.27,0,0,0,.14-.17.84.84,0,0,0,0-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23,295.21a.08.08,0,0,1,0,.05h0s0,0,0,0v-1l-.19.33s0,0,0,0v0a0,0,0,0,1,0,0l.22-.4v0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.86,294.1v.1l0,.08a.64.64,0,0,1,0,.07s0,0,0,.06l-.22.6v0l0,0h0v0h0l.17-.46a.18.18,0,0,1-.07.05.13.13,0,0,1-.11,0,.12.12,0,0,1-.08,0,.19.19,0,0,1,0-.09.51.51,0,0,1,0-.13.78.78,0,0,1,0-.14.83.83,0,0,1,0-.15.57.57,0,0,1,.08-.13.52.52,0,0,1,.11-.1l.11,0,.08,0a.31.31,0,0,1,0,.1A.49.49,0,0,1,143.86,294.1Zm-.43.25a.34.34,0,0,0,0,.11.15.15,0,0,0,0,.06s0,0,.06,0a.11.11,0,0,0,.07,0,.13.13,0,0,0,.07-.06l.06-.09a.36.36,0,0,0,0-.11.43.43,0,0,0,0-.12.36.36,0,0,0,0-.11s0,0,0-.06l-.06,0-.07,0a.19.19,0,0,0-.07.06l-.06.09s0,.07,0,.11A.49.49,0,0,0,143.43,294.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,304.4a.49.49,0,0,1,0-.12.74.74,0,0,1,0-.14.75.75,0,0,1,.07-.12.31.31,0,0,1,.11-.09l.1,0a.09.09,0,0,1,.07,0,.19.19,0,0,1,0,.09.37.37,0,0,1,0,.11.69.69,0,0,1,0,.2,1.65,1.65,0,0,1-.09.21l-.24.53.35-.21s0,0,0,0v0a.05.05,0,0,1,0,0l-.43.25s0,0,0,0v-.06s0,0,0-.05l.27-.58a.93.93,0,0,0,.05-.1.16.16,0,0,0,0-.09.19.19,0,0,0,0-.07v-.07a.21.21,0,0,0,0-.15s-.06,0-.11,0a.3.3,0,0,0-.12.13,1,1,0,0,0-.05.2,0,0,0,0,1,0,0v0h0S141.51,304.42,141.51,304.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1,304.17a1.1,1.1,0,0,1,0-.18.47.47,0,0,1,0-.17.39.39,0,0,1,.08-.14.43.43,0,0,1,.12-.11l.12,0a.13.13,0,0,1,.07.06.18.18,0,0,1,0,.11.88.88,0,0,1,0,.17v.27a1.1,1.1,0,0,1,0,.18.42.42,0,0,1,0,.16.69.69,0,0,1-.07.15l-.12.1a.24.24,0,0,1-.12,0,.12.12,0,0,1-.08-.06.34.34,0,0,1,0-.12.78.78,0,0,1,0-.16Zm.44-.25a.44.44,0,0,0,0-.23c0-.05-.07-.05-.13,0a.32.32,0,0,0-.14.18.84.84,0,0,0-.05.29v.25a.48.48,0,0,0,.05.24c0,.05.07.05.14,0a.44.44,0,0,0,.14-.18.85.85,0,0,0,0-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.75,303.69a.62.62,0,0,1,0-.13.65.65,0,0,1,0-.13.47.47,0,0,1,.07-.12.31.31,0,0,1,.11-.09.16.16,0,0,1,.1,0l.07,0a.15.15,0,0,1,0,.08.45.45,0,0,1,0,.12.63.63,0,0,1,0,.19,1.65,1.65,0,0,1-.09.21l-.24.53.35-.2s0,0,0,0v0a0,0,0,0,1,0,.05l-.43.25s0,0,0,0v-.06a.17.17,0,0,1,0-.05l.27-.57.05-.11a.16.16,0,0,0,0-.08.25.25,0,0,0,0-.07v-.08c0-.07,0-.12,0-.14s-.06,0-.11,0a.3.3,0,0,0-.12.13,1.17,1.17,0,0,0-.05.2s0,0,0,0v0h0S142.75,303.71,142.75,303.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.34,303.45a1.1,1.1,0,0,1,0-.18.47.47,0,0,1,0-.16.44.44,0,0,1,.08-.15.4.4,0,0,1,.12-.1.13.13,0,0,1,.11,0,.09.09,0,0,1,.08.05.21.21,0,0,1,0,.12.78.78,0,0,1,0,.16v.27a1.1,1.1,0,0,1,0,.18.47.47,0,0,1,0,.17.39.39,0,0,1-.08.14l-.11.11s-.09,0-.12,0a.11.11,0,0,1-.08-.05.34.34,0,0,1,0-.12.88.88,0,0,1,0-.17Zm.44-.24a.48.48,0,0,0-.05-.24s-.07-.05-.13,0a.27.27,0,0,0-.14.17.88.88,0,0,0-.05.29v.26a.41.41,0,0,0,.05.23s.07.06.14,0a.44.44,0,0,0,.14-.18.85.85,0,0,0,0-.29v-.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74,318.24a.53.53,0,0,1,0-.12.74.74,0,0,1,0-.14.75.75,0,0,1,.07-.12.48.48,0,0,1,.11-.09l.1,0a.09.09,0,0,1,.07,0,.19.19,0,0,1,0,.09s0,.07,0,.11a.69.69,0,0,1,0,.2,1.65,1.65,0,0,1-.09.21l-.24.53.35-.21s0,0,0,0v0s0,0,0,.05l-.43.25s0,0,0,0V319a.17.17,0,0,1,0-.05l.27-.58,0-.1a.16.16,0,0,0,0-.09.14.14,0,0,0,0-.07V318a.21.21,0,0,0,0-.15s-.06,0-.11,0a.3.3,0,0,0-.12.13,1,1,0,0,0,0,.2,0,0,0,0,1,0,0v0h0S141.74,318.26,141.74,318.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.33,318a1.1,1.1,0,0,1,0-.18.53.53,0,0,1,0-.17.39.39,0,0,1,.08-.14.43.43,0,0,1,.12-.11l.11,0a.12.12,0,0,1,.08.06.21.21,0,0,1,0,.11.88.88,0,0,1,0,.17V318a1.1,1.1,0,0,1,0,.18.42.42,0,0,1,0,.16.36.36,0,0,1-.08.15.35.35,0,0,1-.11.1.24.24,0,0,1-.12,0,.12.12,0,0,1-.08-.06.34.34,0,0,1,0-.12.78.78,0,0,1,0-.16Zm.44-.25a.44.44,0,0,0-.05-.23s-.07,0-.13,0a.32.32,0,0,0-.14.18.84.84,0,0,0,0,.29v.25a.45.45,0,0,0,0,.24s.07,0,.14,0a.35.35,0,0,0,.13-.18.84.84,0,0,0,.05-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,317.53a.62.62,0,0,1,0-.13.65.65,0,0,1,0-.13.47.47,0,0,1,.07-.12.31.31,0,0,1,.11-.09.16.16,0,0,1,.1,0l.07,0a.2.2,0,0,1,0,.08s0,.07,0,.12a.63.63,0,0,1,0,.19,1.65,1.65,0,0,1-.09.21l-.24.53.35-.2s0,0,0,0v0s0,.05,0,.05l-.43.25s0,0,0,0v-.06l0-.05.27-.57.05-.11a.16.16,0,0,0,0-.08.25.25,0,0,0,0-.07v-.08c0-.07,0-.12,0-.14s-.06,0-.11,0a.37.37,0,0,0-.12.13,1.17,1.17,0,0,0-.05.2s0,0,0,0h0S143,317.55,143,317.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.83,317.81s0,0,0,.05h0s0,0,0,0v-1l-.19.33s0,0,0,0v0a0,0,0,0,1,0,0l.22-.4,0,0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,247.67l12-6.93c.32-.19.58-.06.58.29a1.24,1.24,0,0,1-.58,1l-12,6.94c-.32.19-.59.06-.59-.29A1.29,1.29,0,0,1,151.06,247.67Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,247.67l12-6.93c.32-.19.58-.06.58.29a1.24,1.24,0,0,1-.58,1l-12,6.94c-.32.19-.59.06-.59-.29A1.29,1.29,0,0,1,151.06,247.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,252.09a.27.27,0,0,1-.13-.51l17.58-10.15a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-17.58,10.15A.23.23,0,0,1,150.47,252.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,318l12-6.94c.32-.19.58-.05.58.3a1.26,1.26,0,0,1-.58,1l-12,6.94c-.32.18-.59.05-.59-.3A1.27,1.27,0,0,1,151.06,318Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,318l12-6.94c.32-.19.58-.05.58.3a1.26,1.26,0,0,1-.58,1l-12,6.94c-.32.18-.59.05-.59-.3A1.27,1.27,0,0,1,151.06,318Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,322.39a.26.26,0,0,1-.23-.13.27.27,0,0,1,.1-.37l17.58-10.15a.27.27,0,1,1,.27.46l-17.58,10.16A.32.32,0,0,1,150.47,322.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,293.87l12-6.94c.32-.19.58-.06.58.3a1.26,1.26,0,0,1-.58,1l-12,6.94c-.32.18-.59.05-.59-.3A1.26,1.26,0,0,1,151.06,293.87Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,293.87l12-6.94c.32-.19.58-.06.58.3a1.26,1.26,0,0,1-.58,1l-12,6.94c-.32.18-.59.05-.59-.3A1.26,1.26,0,0,1,151.06,293.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,298.28a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l17.58-10.16a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-17.58,10.16A.32.32,0,0,1,150.47,298.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,277.76l12-6.93c.32-.19.58-.06.58.29a1.24,1.24,0,0,1-.58,1l-12,6.94c-.32.19-.59.06-.59-.29A1.29,1.29,0,0,1,151.06,277.76Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,277.76l12-6.93c.32-.19.58-.06.58.29a1.24,1.24,0,0,1-.58,1l-12,6.94c-.32.19-.59.06-.59-.29A1.29,1.29,0,0,1,151.06,277.76Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,282.18a.27.27,0,0,1-.13-.51l17.58-10.15a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-17.58,10.15A.23.23,0,0,1,150.47,282.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,256.56l12-6.94c.32-.19.58-.06.58.29a1.26,1.26,0,0,1-.58,1l-12,6.94c-.32.18-.59.05-.59-.3A1.26,1.26,0,0,1,151.06,256.56Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,256.56l12-6.94c.32-.19.58-.06.58.29a1.26,1.26,0,0,1-.58,1l-12,6.94c-.32.18-.59.05-.59-.3A1.26,1.26,0,0,1,151.06,256.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,261a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l17.58-10.16a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-17.58,10.15A.23.23,0,0,1,150.47,261Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,263.26a.27.27,0,0,1-.13-.51l17.58-10.15a.27.27,0,0,1,.27.47l-17.58,10.15A.23.23,0,0,1,150.47,263.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,267.34l12-6.94c.32-.18.58,0,.58.3a1.24,1.24,0,0,1-.58,1l-12,6.94c-.32.19-.59.06-.59-.29A1.29,1.29,0,0,1,151.06,267.34Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,267.34l12-6.94c.32-.18.58,0,.58.3a1.24,1.24,0,0,1-.58,1l-12,6.94c-.32.19-.59.06-.59-.29A1.29,1.29,0,0,1,151.06,267.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,271.76a.27.27,0,0,1-.13-.51l17.58-10.15a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-17.58,10.15A.23.23,0,0,1,150.47,271.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,274a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l17.58-10.15a.27.27,0,0,1,.37.1.26.26,0,0,1-.1.36L150.61,274A.32.32,0,0,1,150.47,274Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,284.24l12-6.94c.32-.19.58-.06.58.29a1.28,1.28,0,0,1-.58,1l-12,6.93c-.32.19-.59.06-.59-.29A1.26,1.26,0,0,1,151.06,284.24Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,284.24l12-6.94c.32-.19.58-.06.58.29a1.28,1.28,0,0,1-.58,1l-12,6.93c-.32.19-.59.06-.59-.29A1.26,1.26,0,0,1,151.06,284.24Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,288.65a.27.27,0,0,1-.23-.14.26.26,0,0,1,.1-.36L167.92,278a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-17.58,10.15A.23.23,0,0,1,150.47,288.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,290.94a.27.27,0,0,1-.13-.51l17.58-10.15a.27.27,0,0,1,.27.47L150.61,290.9A.33.33,0,0,1,150.47,290.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,302.18l12-6.94c.32-.19.58-.05.58.3a1.26,1.26,0,0,1-.58,1l-12,6.94c-.32.18-.59.05-.59-.3A1.27,1.27,0,0,1,151.06,302.18Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,302.18l12-6.94c.32-.19.58-.05.58.3a1.26,1.26,0,0,1-.58,1l-12,6.94c-.32.18-.59.05-.59-.3A1.27,1.27,0,0,1,151.06,302.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,306.59a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l17.58-10.15a.26.26,0,0,1,.37.09.27.27,0,0,1-.1.37l-17.58,10.16A.32.32,0,0,1,150.47,306.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,308.65l12-6.94c.32-.18.58,0,.58.3a1.26,1.26,0,0,1-.58,1l-12,6.94c-.32.19-.59.05-.59-.3A1.27,1.27,0,0,1,151.06,308.65Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,308.65l12-6.94c.32-.18.58,0,.58.3a1.26,1.26,0,0,1-.58,1l-12,6.94c-.32.19-.59.05-.59-.3A1.27,1.27,0,0,1,151.06,308.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,313.06a.26.26,0,0,1-.23-.13.27.27,0,0,1,.1-.37l17.58-10.15a.27.27,0,0,1,.27.47L150.61,313A.32.32,0,0,1,150.47,313.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,315.35a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l17.58-10.16a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-17.58,10.15A.23.23,0,0,1,150.47,315.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.35,212.19a11.93,11.93,0,0,0,.05,4.61,18,18,0,0,1,.37,4.62c0,.31-.06.67.17.87a.61.61,0,0,0,.76-.08,1.73,1.73,0,0,0,.42-.7c.1,1.1.19,2.21.28,3.32a2,2,0,0,0,.31,1.09,1.59,1.59,0,0,0,1.72.29,4.7,4.7,0,0,0,2.87-3.14,9.14,9.14,0,0,0,.1-4.38,17.78,17.78,0,0,0-2-5.66,17.75,17.75,0,0,1-1.51-2.9,3.22,3.22,0,0,0-.51-1.15c-.14-.17-.27-.12-.45,0a2.49,2.49,0,0,0-.51.27,4,4,0,0,0-.89.75,5.14,5.14,0,0,0-.67,1,5.46,5.46,0,0,0-.43,1.1A.83.83,0,0,0,138.35,212.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.53,222.41v1.67l-4.39,2.53-1.61-5.07C152.12,221.06,153.53,221.1,156.53,222.41Z",
    style: {
      fill: "#ffbda7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.91,231.74a15,15,0,0,0-1.41-6.2s1.09-.58,3.17-1.72a43.68,43.68,0,0,1,6.86-2.28,14.37,14.37,0,0,1,3.09,1.2,9.58,9.58,0,0,1,2.31,1.69l-14.08,8.12Z",
    style: {
      fill: "#46C5FB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.56,220.32c-.25-.93-1.4-1.6-2.49-3.21s-2.49-5.23-.27-6.92c-.41-2.16,1.33-4.83,3.7-5.89,3.12-1.4,6.76-1.21,8.87,1.46a4.88,4.88,0,0,1-.08,6.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,216.89a4.28,4.28,0,0,1-.92,1.83,5.28,5.28,0,0,1-2.51,1.41l0,.84,0,.54,0,.56,0,1s2,2.55,2.06,3.83l-1,.57c-2.2,0-5.33-1.79-7-2.94v-.14l-.06-1.4-.16-3.44,0-1a.89.89,0,0,1-.16.36,1.41,1.41,0,0,1-.51.42,1.46,1.46,0,0,1-1.25.07l-.09-.05a.38.38,0,0,1-.13-.06l-.1-.07a.28.28,0,0,1-.09-.06h0l-.09-.07a2.49,2.49,0,0,1-.74-2.87c.31-.72,1.13-1.37,1.75-1.12s.71.63,1,1.07,1.54-.9.66-3.18a4.13,4.13,0,0,0,1.26-3.67c.46-1.66,3.54-1.87,4.08-1.24.45-1.05.4-1.68,1.27-1.41s2.34.85,2.85,4.47A15.14,15.14,0,0,1,153,216.89Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.56,216.55l1.83,0a1.21,1.21,0,0,1-1.2,1.07C147.69,217.63,147.47,217.16,147.56,216.55Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.71,217.56a.79.79,0,0,0-1.07-.66l-.09,0a.71.71,0,0,0,.64.73A1,1,0,0,0,148.71,217.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.27 211.71 149.69 215.3 151.41 214.13 149.27 211.71",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.13,211.88a.48.48,0,0,0,.58.51.79.79,0,0,0,.6-.74.47.47,0,0,0-.58-.51A.81.81,0,0,0,151.13,211.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.87,213.33a.47.47,0,0,0,.58.5.78.78,0,0,0,.6-.74.47.47,0,0,0-.58-.51A.82.82,0,0,0,146.87,213.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.56,220.13a8.11,8.11,0,0,1-3.66-.17,3.62,3.62,0,0,1-1.72-1.43s-.13,1.16,1.6,2a9.77,9.77,0,0,0,3.81.47Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.25,210.11l-1.32.08a1.1,1.1,0,0,1,.86-.77C152.16,209.4,152.36,209.71,152.25,210.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.9,211.28l-1.43.95a1,1,0,0,1,.49-1.08C147.36,210.89,147.78,211,147.9,211.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.34,206.54c.26,1.43-1.4,4.73-3.63,6.24S143,214,143,214s-.26-4.56,2-6.28A7.55,7.55,0,0,1,150.34,206.54Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.36,232.26l-7,4V232c1-3.08,2.4-5.23,5.1-6.46h0C142,226.63,142.36,229.43,142.36,232.26Z",
    style: {
      fill: "#ffbda7"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M135.4,236.62a.34.34,0,0,1-.17-.05.32.32,0,0,1-.17-.29v-30a.34.34,0,0,1,.17-.3l21.13-12.2a.34.34,0,0,1,.34,0,.33.33,0,0,1,.18.29v30a.33.33,0,0,1-.18.29l-21.13,12.2A.34.34,0,0,1,135.4,236.62Zm.34-30.1v29.17l20.45-11.81V194.71Z",
    style: {
      fill: "#46C5FB"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--resume--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.86,84.89l-89.21,51.44a3.67,3.67,0,0,0-1.67,2.89V283.41a3.68,3.68,0,0,0,1.67,2.89l.34.19a3.71,3.71,0,0,0,3.34,0L323.54,235a3.67,3.67,0,0,0,1.67-2.89V88a3.68,3.68,0,0,0-1.67-2.89l-.34-.19A3.68,3.68,0,0,0,319.86,84.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.21,232.2c0,1.46-1,2.4-2.3,3.13L235,286.1c-1.27.74-2.31.14-2.31-1.33V142.05h0a4.59,4.59,0,0,1,2.3-4l88-50.8a1.53,1.53,0,0,1,2.3,1.33h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.67,87.58h0a1,1,0,0,1,1,1V232.2c0,1.05-.64,1.88-2.06,2.69l-87.94,50.77a1.51,1.51,0,0,1-.77.25c-.7,0-.77-.8-.77-1.14V142.05a4.11,4.11,0,0,1,2-3.54l88-50.79a1,1,0,0,1,.51-.14m0-.51a1.53,1.53,0,0,0-.76.21l-88,50.8a4.59,4.59,0,0,0-2.3,4V284.77c0,1.05.52,1.65,1.28,1.65a2,2,0,0,0,1-.32l87.94-50.77c1.27-.73,2.3-1.67,2.3-3.13V88.61a1.54,1.54,0,0,0-1.54-1.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.21,88v.65a1.54,1.54,0,0,0-2.31-1.33L235,138.08a4.42,4.42,0,0,0-1.68,1.67l0,.05-3.8-2.19a3.38,3.38,0,0,1,1.2-1.28l89.21-51.44a3.68,3.68,0,0,1,3.34,0l.34.19A3.68,3.68,0,0,1,325.21,88Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--resume--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.05,135.19v95.19l-80.24,46.33v-95.2l80.24-46.32m.54-.94L238.27,181.2v96.45l81.32-46.95V134.25Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.72 253.72 319.59 230.7 319.59 134.25 279.72 157.27 279.72 253.72",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.72 253.72 319.59 230.7 319.59 134.25 279.72 157.27 279.72 253.72",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.21,140a.51.51,0,0,1-.43-.24.5.5,0,0,1,.18-.67l51.41-29.65a.49.49,0,1,1,.49.85L264.45,140A.5.5,0,0,1,264.21,140Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.21,144.62a.5.5,0,0,1-.43-.25.5.5,0,0,1,.18-.67l51.41-29.64a.48.48,0,0,1,.67.18.5.5,0,0,1-.18.67l-51.41,29.64A.42.42,0,0,1,264.21,144.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.21,149.21a.51.51,0,0,1-.43-.24.5.5,0,0,1,.18-.67l51.41-29.65a.5.5,0,0,1,.67.18.5.5,0,0,1-.18.67l-51.41,29.65A.5.5,0,0,1,264.21,149.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.21,135.41a.49.49,0,0,1-.43-.24.5.5,0,0,1,.18-.67l51.41-29.65a.5.5,0,0,1,.67.18.5.5,0,0,1-.18.67l-51.41,29.65A.5.5,0,0,1,264.21,135.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.76,139.4a6.23,6.23,0,0,1-2.6,5c-1.43.83-2.6-.05-2.6-2a6.24,6.24,0,0,1,2.6-5C296.6,136.6,297.76,137.48,297.76,139.4Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.79 143.3 294.38 142.96 294.38 140.41 293.79 140.76 293.79 143.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.08,140.25a.84.84,0,0,0,.35-.67c0-.26-.16-.38-.35-.27a.88.88,0,0,0-.35.68C293.73,140.25,293.89,140.37,294.08,140.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.32,141.08a.87.87,0,0,1,.36-.78c.22-.13.33,0,.33.39V142l.58-.34v-1.61c0-.68-.29-.84-.69-.61a1.48,1.48,0,0,0-.58.75v-.34l-.56.33v2.54l.56-.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.75,134.21a6.23,6.23,0,0,1-2.6,5c-1.44.83-2.6-.05-2.6-2a6.23,6.23,0,0,1,2.6-5C305.59,131.41,306.75,132.29,306.75,134.21Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.15,134l.63-.35a.68.68,0,0,1,.29-.1.27.27,0,0,1,.18,0,.31.31,0,0,1,.12.17,1.1,1.1,0,0,1,.05.36c0,.22,0,.28,0,.84s0,.62,0,.85a1.68,1.68,0,0,1-.05.42,1.32,1.32,0,0,1-.12.31,1.2,1.2,0,0,1-.18.26,1.38,1.38,0,0,1-.29.24l-.63.37-.63.36a.8.8,0,0,1-.3.09.24.24,0,0,1-.18-.05.36.36,0,0,1-.11-.17,1.25,1.25,0,0,1-.06-.36c0-.22,0-.28,0-.84s0-.62,0-.85a2.28,2.28,0,0,1,.06-.42,1.54,1.54,0,0,1,.11-.3,1.32,1.32,0,0,1,.18-.26,1.22,1.22,0,0,1,.3-.24,7.17,7.17,0,0,1,.63-.38m0-.38-.65.39a2.11,2.11,0,0,0-.38.31,2.15,2.15,0,0,0-.46.88,3.39,3.39,0,0,0-.07.55c0,.23,0,.3,0,.86s0,.64,0,.86a2.14,2.14,0,0,0,.07.47.61.61,0,0,0,.18.26.37.37,0,0,0,.28.08.9.9,0,0,0,.38-.12l.65-.36c.42-.25.48-.28.64-.39a1.54,1.54,0,0,0,.38-.31,2,2,0,0,0,.46-.88,2,2,0,0,0,.07-.55c0-.22,0-.3,0-.86s0-.64,0-.86a1.26,1.26,0,0,0-.07-.46.52.52,0,0,0-.18-.27.4.4,0,0,0-.28-.08,1.14,1.14,0,0,0-.38.12l-.64.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.15,134.64a1.92,1.92,0,0,0-.81,1.54c0,.59.36.86.81.6a1.91,1.91,0,0,0,.8-1.53c0-.6-.36-.87-.8-.61m0,1.77c-.29.16-.52,0-.52-.4a1.26,1.26,0,0,1,.52-1c.29-.16.52,0,.52.4a1.26,1.26,0,0,1-.52,1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.17,134a.43.43,0,0,1-.19.35c-.1.06-.18,0-.18-.14a.45.45,0,0,1,.18-.36c.11-.06.19,0,.19.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.74,129a6.22,6.22,0,0,1-2.61,5c-1.43.83-2.6-.05-2.6-2a6.26,6.26,0,0,1,2.6-5C314.57,126.22,315.74,127.1,315.74,129Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.71,132a1.12,1.12,0,0,0,.22-.26,1.11,1.11,0,0,0,.14-.29,1.36,1.36,0,0,0,.09-.48.68.68,0,0,0-.07-.35.26.26,0,0,0-.24-.1,1.11,1.11,0,0,0,.16-.24,1,1,0,0,0,.09-.44.6.6,0,0,0-.09-.36c-.1-.12-.28-.12-.52,0l-1,.56v2.66l.9-.52A1.49,1.49,0,0,0,312.71,132Zm-.79-1.71.44-.25a.61.61,0,0,1,.23-.1c.08,0,.11.06.11.19a.51.51,0,0,1-.08.28.65.65,0,0,1-.21.19l-.49.28Zm0,1.74v-.71l.49-.29a.68.68,0,0,1,.2-.07c.09,0,.13.08.13.22a.58.58,0,0,1-.13.4.85.85,0,0,1-.2.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5,131.43a.52.52,0,0,0,.52-.05,1.38,1.38,0,0,0,.56-.61,1.16,1.16,0,0,0,.14-.44l-.39.23a.75.75,0,0,1-.08.18.63.63,0,0,1-.22.21.25.25,0,0,1-.21.05q-.15,0-.15-.33l1.07-.62a2.09,2.09,0,0,0,0-.38.71.71,0,0,0-.12-.34.31.31,0,0,0-.25-.15.74.74,0,0,0-.35.11,1.43,1.43,0,0,0-.53.58,1.87,1.87,0,0,0-.2.9C313.28,131.14,313.35,131.36,313.5,131.43Zm.28-1.47a.59.59,0,0,1,.23-.24.25.25,0,0,1,.23,0c.06,0,.09.12.1.25l-.66.39A.88.88,0,0,1,313.78,130Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.42 128.57 313.55 129.07 313.55 129.34 314.42 128.84 314.42 128.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.78,144.58a6.26,6.26,0,0,1-2.6,5c-1.44.83-2.61-.05-2.61-2a6.22,6.22,0,0,1,2.61-5C287.61,141.79,288.78,142.67,288.78,144.58Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.74,148.64l.7-.4v-2.32l.48-.28.05-.81-.53.31v-.44c0-.19,0-.27.16-.35l.37-.22v-.81l-.48.28a1.41,1.41,0,0,0-.75,1.32v.62l-.36.21v.79l.36-.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,170.6l17.61-10.17c.59-.34,1.07-.1,1.07.54a2.28,2.28,0,0,1-1.07,1.76L296.21,172.9c-.59.34-1.07.1-1.07-.53A2.28,2.28,0,0,1,296.21,170.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,170.6l11.63-6.72c.59-.34,1.06-.09,1.06.54a2.27,2.27,0,0,1-1.06,1.77l-11.63,6.71c-.59.34-1.07.1-1.07-.53A2.28,2.28,0,0,1,296.21,170.6Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,165.52l17.61-10.17c.59-.34,1.07-.1,1.07.54a2.28,2.28,0,0,1-1.07,1.76l-17.61,10.17c-.59.34-1.07.1-1.07-.53A2.28,2.28,0,0,1,296.21,165.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,165.52l7-4.06c.58-.34,1.06-.09,1.06.54a2.3,2.3,0,0,1-1.06,1.77l-7,4c-.59.34-1.07.1-1.07-.53A2.28,2.28,0,0,1,296.21,165.52Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,175.68l17.61-10.17c.59-.34,1.07-.1,1.07.53a2.28,2.28,0,0,1-1.07,1.77L296.21,178c-.59.34-1.07.1-1.07-.54A2.28,2.28,0,0,1,296.21,175.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,175.68l15.62-9c.59-.34,1.06-.1,1.06.53a2.3,2.3,0,0,1-1.06,1.77l-15.62,9c-.59.34-1.07.1-1.07-.54A2.28,2.28,0,0,1,296.21,175.68Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,180.75l17.61-10.17c.59-.34,1.07-.1,1.07.54a2.28,2.28,0,0,1-1.07,1.77l-17.61,10.17c-.59.34-1.07.09-1.07-.54A2.28,2.28,0,0,1,296.21,180.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,180.75,307.84,174c.59-.34,1.06-.1,1.06.53a2.27,2.27,0,0,1-1.06,1.77l-11.63,6.72c-.59.34-1.07.09-1.07-.54A2.28,2.28,0,0,1,296.21,180.75Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,185.83l17.61-10.17c.59-.34,1.07-.1,1.07.54a2.28,2.28,0,0,1-1.07,1.76l-17.61,10.17c-.59.34-1.07.1-1.07-.53A2.28,2.28,0,0,1,296.21,185.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,185.83l15.62-9c.59-.34,1.06-.1,1.06.54a2.3,2.3,0,0,1-1.06,1.76l-15.62,9c-.59.34-1.07.1-1.07-.53A2.28,2.28,0,0,1,296.21,185.83Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,172.63a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l5.49-3.17a.27.27,0,0,1,.27.47l-5.49,3.17A.35.35,0,0,1,286.31,172.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,177.72a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l5.49-3.17a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-5.49,3.16A.25.25,0,0,1,286.31,177.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,182.81a.27.27,0,0,1-.13-.51l5.49-3.17a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-5.49,3.17A.25.25,0,0,1,286.31,182.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,187.9a.27.27,0,0,1-.13-.51l5.49-3.17a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-5.49,3.17A.25.25,0,0,1,286.31,187.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,193a.27.27,0,0,1-.13-.51l5.49-3.17a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37L286.45,193A.37.37,0,0,1,286.31,193Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.88,168.83c0-2.82,1.72-6.1,3.84-7.33s3.83.08,3.83,2.9-1.71,6.11-3.83,7.33S275.88,171.66,275.88,168.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.19,172.33a2.11,2.11,0,0,1-1.05-.28,3.53,3.53,0,0,1-1.39-3.22c0-2.86,1.75-6.2,3.9-7.44a2.6,2.6,0,0,1,2.64-.21,3.56,3.56,0,0,1,1.4,3.22c0,2.87-1.75,6.21-3.9,7.45A3.23,3.23,0,0,1,278.19,172.33Zm3.05-11.15a3,3,0,0,0-1.45.44c-2.08,1.2-3.77,4.44-3.77,7.21a3.31,3.31,0,0,0,1.26,3,2.35,2.35,0,0,0,2.37-.21c2.08-1.2,3.77-4.43,3.77-7.21a3.29,3.29,0,0,0-1.26-3A1.83,1.83,0,0,0,281.24,161.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.16,168.34h0s0,0,0-.06c0-.48-.19-.61-.55-.41,0,0-.07,0-.07-.06,0-.25,0-.41-.13-.48s-.23,0-.41.06h-.06a.08.08,0,0,1,0-.06c0-.25,0-.41-.13-.48s-.23,0-.41.06h0s-.05,0-.06,0a.14.14,0,0,1,0-.11l2.41-4.61s.08-.08.1-.06l1.86,1.41s0,.08,0,.13l-2.41,4.61A.12.12,0,0,1,280.16,168.34Zm-.55-.69c.34-.15.55,0,.61.36l2.25-4.31-1.76-1.33-2.25,4.3a.37.37,0,0,1,.36,0,.67.67,0,0,1,.17.5.41.41,0,0,1,.45,0A.67.67,0,0,1,279.61,167.65Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.6,170.75h-.05a.09.09,0,0,1,0-.08l.69-3.81a.15.15,0,0,1,.09-.12s.06,0,.05.09l-.67,3.64,2.44-2.3s.08,0,.09,0a.16.16,0,0,1-.05.14l-2.56,2.41Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.6 170.66 278.3 169.9 277.87 169.57 277.6 170.66",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.93,167.14a0,0,0,0,1-.05,0s0-.08,0-.13l2-3.87s.07-.08.1-.06,0,.08,0,.13l-2,3.87Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.31,166.67a0,0,0,0,1-.05,0s0-.08,0-.13l2-3.87s.07-.08.1-.06,0,.08,0,.13l-2,3.88Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.72,
    cy: 205.53,
    rx: 5.89,
    ry: 3.33,
    transform: "translate(-18.93 382.44) rotate(-66.95)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.19,211.24a2,2,0,0,1-1.05-.28,3.53,3.53,0,0,1-1.39-3.22c0-2.86,1.75-6.2,3.9-7.44a2.58,2.58,0,0,1,2.64-.2,3.53,3.53,0,0,1,1.4,3.22c0,2.86-1.75,6.2-3.9,7.44A3.23,3.23,0,0,1,278.19,211.24Zm3.05-11.15a3,3,0,0,0-1.45.44c-2.08,1.2-3.77,4.44-3.77,7.21a3.3,3.3,0,0,0,1.26,3,2.37,2.37,0,0,0,2.37-.2c2.08-1.2,3.77-4.44,3.77-7.21a3.3,3.3,0,0,0-1.26-3A1.83,1.83,0,0,0,281.24,200.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.19,208.21h-.05a.08.08,0,0,1,0-.05,1.32,1.32,0,0,0-.43-1.1,1.51,1.51,0,0,1-.42-1.32,3.64,3.64,0,0,1,1.29-2.49h0a1,1,0,0,1,1.14-.17,1.32,1.32,0,0,1,.48,1.17,3.58,3.58,0,0,1-.43,1.63,3.53,3.53,0,0,0-.42,1.58.16.16,0,0,1-.07.13Zm.07-.13Zm.31-4.65a3.28,3.28,0,0,0-1.16,2.25,1.38,1.38,0,0,0,.38,1.19,1.41,1.41,0,0,1,.47,1.11l.93-.53a4,4,0,0,1,.46-1.65,3.27,3.27,0,0,0,.39-1.47,1.21,1.21,0,0,0-.44-1.06.91.91,0,0,0-1,.16Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.26,209.06l-1.07.61s-.07,0-.07,0v-.85a.16.16,0,0,1,.07-.13l1.07-.62s.07,0,.07,0v.85A.19.19,0,0,1,280.26,209.06Zm-1,.38.93-.53v-.66l-.93.53Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.89,207.81s-.07,0-.07-.05a7.61,7.61,0,0,1,.24-1.93l-.68.39a4.32,4.32,0,0,1,.25,1.64.19.19,0,0,1-.07.14s-.07,0-.07-.06a3.82,3.82,0,0,0-.28-1.67.14.14,0,0,1,0-.09.1.1,0,0,1,.06-.08l.91-.53a0,0,0,0,1,.06,0,.14.14,0,0,1,0,.09,6.76,6.76,0,0,0-.28,2A.19.19,0,0,1,279.89,207.81Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.72,202.55s-.07,0-.07-.06v-.83a.19.19,0,0,1,.07-.14.05.05,0,0,1,.08,0v.84A.2.2,0,0,1,279.72,202.55Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.75,203.45s-.05,0-.06,0l-.32-.54a.13.13,0,0,1,0-.14s.07-.06.09,0l.32.54a.13.13,0,0,1,0,.14S278.76,203.45,278.75,203.45Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,204.82h0l-.54-.11s0-.05,0-.11.07-.1.1-.09l.54.1s.05.06,0,.12A.17.17,0,0,1,278,204.82Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.76,206.27l-.62.37s-.07,0-.07-.06a.16.16,0,0,1,.07-.13l.62-.36s.07,0,.07,0A.16.16,0,0,1,277.76,206.27Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.48,208.16s-.05,0-.06,0a.15.15,0,0,1,0-.14l.55-.73c0-.05.07-.06.09,0a.17.17,0,0,1,0,.15l-.55.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,205.6s0,0,0,0l-.54-.1s0-.06,0-.11.06-.1.09-.09l.55.1s0,.06,0,.11A.2.2,0,0,1,282,205.6Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,203.68l-.63.36s-.07,0-.07-.06a.16.16,0,0,1,.07-.13l.63-.36s.07,0,.07,0A.19.19,0,0,1,282.3,203.68Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.41,202.88s0,0-.06,0,0-.1,0-.14l.54-.73c0-.05.08-.06.1,0a.15.15,0,0,1,0,.15l-.54.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.7,202.34h0s-.05-.05,0-.11l.31-.91s.07-.09.1-.08,0,0,0,.11l-.32.9A.15.15,0,0,1,280.7,202.34Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.88,226c0-2.82,1.72-6.1,3.84-7.33s3.83.08,3.83,2.9-1.71,6.11-3.83,7.33S275.88,228.79,275.88,226Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.19,229.46a2.11,2.11,0,0,1-1.05-.28,3.53,3.53,0,0,1-1.39-3.22c0-2.86,1.75-6.2,3.9-7.44a2.6,2.6,0,0,1,2.64-.21,3.54,3.54,0,0,1,1.4,3.22c0,2.87-1.75,6.2-3.9,7.45A3.33,3.33,0,0,1,278.19,229.46Zm3.05-11.15a3,3,0,0,0-1.45.44C277.71,220,276,223.18,276,226a3.31,3.31,0,0,0,1.26,3,2.35,2.35,0,0,0,2.37-.21c2.08-1.2,3.77-4.43,3.77-7.21a3.29,3.29,0,0,0-1.26-3A1.83,1.83,0,0,0,281.24,218.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.22,226.88l-1,.57s-.07,0-.07,0v-.68a1.25,1.25,0,0,1-.43,0l-.36.69c0,.05-.07.08-.1.05l-.71-.53a.14.14,0,0,1,0-.13l.36-.69a2.56,2.56,0,0,1-.18-.47l-.5.29s-.07,0-.07-.05v-1.33a.16.16,0,0,1,.07-.13l.5-.29c0-.23.11-.46.18-.68l-.36-.27a.17.17,0,0,1,0-.14l.71-1.34c0-.06.07-.08.1-.06l.36.27a3.43,3.43,0,0,1,.43-.49v-.67a.16.16,0,0,1,.07-.14l1-.57s.07,0,.07,0v.68a1,1,0,0,1,.43,0l.36-.69c0-.05.07-.08.1-.06l.7.53a.08.08,0,0,1,0,.06.31.31,0,0,1,0,.08l-.36.68a1.71,1.71,0,0,1,.18.48l.51-.3s.07,0,.07.06v1.32a.16.16,0,0,1-.07.14l-.51.29a4.27,4.27,0,0,1-.18.68l.36.27a.08.08,0,0,1,0,.06.19.19,0,0,1,0,.07l-.7,1.35c0,.05-.08.08-.1.06l-.36-.27a5.19,5.19,0,0,1-.43.48v.68A.23.23,0,0,1,280.22,226.88Zm-.93.34.85-.49v-.66a.2.2,0,0,1,.06-.12,3.39,3.39,0,0,0,.49-.56s.07,0,.09,0l.35.26.6-1.16-.35-.26s0-.06,0-.11a5.64,5.64,0,0,0,.21-.78.16.16,0,0,1,.07-.11l.49-.28v-1.14l-.49.28s-.06,0-.07,0a2,2,0,0,0-.21-.54.17.17,0,0,1,0-.12l.35-.66-.6-.46-.35.66a.1.1,0,0,1-.09.07,1,1,0,0,0-.49,0s-.06,0-.06-.06v-.66l-.85.5v.65a.18.18,0,0,1-.05.12,3.9,3.9,0,0,0-.5.56s-.06.06-.08,0l-.35-.26L277.7,223l.35.26a.1.1,0,0,1,0,.11,4.71,4.71,0,0,0-.2.78.18.18,0,0,1-.07.11l-.49.29v1.14l.49-.29a0,0,0,0,1,.07,0,1.79,1.79,0,0,0,.2.55s0,.07,0,.12l-.35.66.61.46.35-.67s0-.07.08-.06a1.21,1.21,0,0,0,.5,0s.05,0,.05.06Zm.43-1.85c-.67.38-1.22,0-1.22-.92a2.93,2.93,0,0,1,1.22-2.32c.67-.39,1.21,0,1.21.92A2.92,2.92,0,0,1,279.72,225.37Zm0-3.05a2.58,2.58,0,0,0-1.08,2.05c0,.79.49,1.15,1.08.81a2.57,2.57,0,0,0,1.07-2.05C280.79,222.34,280.31,222,279.72,222.32Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.88,244.18c0-2.83,1.72-6.11,3.84-7.33s3.83.07,3.83,2.9-1.71,6.1-3.83,7.33S275.88,247,275.88,244.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.19,247.67a2.11,2.11,0,0,1-1.05-.27,3.54,3.54,0,0,1-1.39-3.22c0-2.86,1.75-6.2,3.9-7.45a2.6,2.6,0,0,1,2.64-.2,3.53,3.53,0,0,1,1.4,3.22c0,2.86-1.75,6.2-3.9,7.44A3.23,3.23,0,0,1,278.19,247.67Zm3.05-11.14a2.85,2.85,0,0,0-1.45.44c-2.08,1.2-3.77,4.43-3.77,7.21a3.29,3.29,0,0,0,1.26,3,2.32,2.32,0,0,0,2.37-.2c2.08-1.2,3.77-4.43,3.77-7.21a3.31,3.31,0,0,0-1.26-3A1.82,1.82,0,0,0,281.24,236.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.49,246.33s0,0-.05,0,0-.05,0-.09l.39-1.75a2.64,2.64,0,0,1-.31-1.33,5.42,5.42,0,0,1,2.26-4.32c1.24-.71,2.25.05,2.25,1.71a5.42,5.42,0,0,1-2.25,4.31,1.64,1.64,0,0,1-1.07.26l-1.18,1.19Zm2.27-7.29a5.08,5.08,0,0,0-2.12,4,2.49,2.49,0,0,0,.31,1.29.08.08,0,0,1,0,.07L277.6,246l1.08-1.08.06,0a1.55,1.55,0,0,0,1-.24,5.07,5.07,0,0,0,2.11-4C281.87,239.09,280.92,238.37,279.76,239Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.45,241.54a.74.74,0,0,1,.31-.59c.17-.1.31,0,.31.23a.73.73,0,0,1-.31.59C280.59,241.87,280.45,241.77,280.45,241.54Z",
    style: {
      fill: "#46C5FB",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.41,242.14a.74.74,0,0,1,.31-.59c.17-.1.31,0,.31.23a.76.76,0,0,1-.31.6C279.55,242.48,279.41,242.37,279.41,242.14Z",
    style: {
      fill: "#46C5FB",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.36,242.74a.76.76,0,0,1,.31-.59c.18-.1.31,0,.31.24a.73.73,0,0,1-.31.59C278.5,243.08,278.36,243,278.36,242.74Z",
    style: {
      fill: "#46C5FB",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,158.2l16.41-9.47c.32-.19.59-.06.59.29a1.29,1.29,0,0,1-.59,1l-16.41,9.47c-.33.19-.59.06-.59-.29A1.25,1.25,0,0,1,286.9,158.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,163.89a.27.27,0,0,1-.13-.51l28.57-16.49a.26.26,0,0,1,.37.09.27.27,0,0,1-.1.37l-28.57,16.5A.25.25,0,0,1,286.31,163.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,166.43a.27.27,0,0,1-.13-.51l22-12.69a.27.27,0,0,1,.27.47l-22,12.69A.37.37,0,0,1,286.31,166.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,198.81l16.41-9.47c.32-.19.59-.06.59.29a1.29,1.29,0,0,1-.59,1l-16.41,9.47c-.33.19-.59.06-.59-.29A1.26,1.26,0,0,1,286.9,198.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,204.5a.27.27,0,0,1-.13-.51l28.57-16.49a.26.26,0,0,1,.37.09.27.27,0,0,1-.1.37l-28.57,16.5A.25.25,0,0,1,286.31,204.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,207a.27.27,0,0,1-.13-.51L314.75,190a.27.27,0,0,1,.37.09.27.27,0,0,1-.1.37L286.45,207A.37.37,0,0,1,286.31,207Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,209.57a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l28.57-16.5a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37l-28.57,16.49A.25.25,0,0,1,286.31,209.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,212.11a.27.27,0,0,1-.13-.51l22-12.68a.27.27,0,1,1,.27.46l-22,12.69A.37.37,0,0,1,286.31,212.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,216.59l16.41-9.48c.32-.19.59-.06.59.3a1.27,1.27,0,0,1-.59,1l-16.41,9.47c-.33.19-.59.06-.59-.29A1.23,1.23,0,0,1,286.9,216.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,222.27a.27.27,0,0,1-.23-.14.26.26,0,0,1,.1-.36l28.57-16.5a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37l-28.57,16.49A.25.25,0,0,1,286.31,222.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,224.81a.27.27,0,0,1-.13-.51l28.57-16.49a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37l-28.57,16.49A.25.25,0,0,1,286.31,224.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,227.34a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.37l28.57-16.5a.27.27,0,0,1,.27.47l-28.57,16.5A.35.35,0,0,1,286.31,227.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,229.88a.27.27,0,0,1-.13-.51l22-12.68a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37l-22,12.68A.25.25,0,0,1,286.31,229.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,234.35l16.41-9.47c.32-.19.59-.06.59.29a1.26,1.26,0,0,1-.59,1l-16.41,9.48c-.33.19-.59,0-.59-.3A1.24,1.24,0,0,1,286.9,234.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,240a.27.27,0,0,1-.13-.51L314.75,223a.27.27,0,1,1,.27.47L286.45,240A.37.37,0,0,1,286.31,240Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,242.57a.26.26,0,0,1-.23-.13.27.27,0,0,1,.1-.37l28.57-16.5a.27.27,0,1,1,.27.47l-28.57,16.5A.35.35,0,0,1,286.31,242.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,245.11a.27.27,0,0,1-.13-.51l15.38-8.88a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.37l-15.38,8.88A.25.25,0,0,1,286.31,245.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.13,183.59l16.42-9.48c.32-.18.58-.05.58.3a1.24,1.24,0,0,1-.58,1l-16.42,9.48c-.32.19-.58,0-.58-.3A1.26,1.26,0,0,1,245.13,183.59Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,192.48a.06.06,0,0,1-.06-.06v-3.89a.06.06,0,0,1,.06-.06.07.07,0,0,1,.07.06v3.89A.07.07,0,0,1,248.94,192.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,201.68a.07.07,0,0,1-.06-.07v-3.88a.06.06,0,0,1,.06-.06.07.07,0,0,1,.07.06v3.88A.07.07,0,0,1,248.94,201.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,252.49a.06.06,0,0,1-.06-.06v-3.89a.06.06,0,0,1,.06-.06.07.07,0,0,1,.07.06v3.89A.07.07,0,0,1,248.94,252.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,238.14a.06.06,0,0,1-.06-.06v-3.89a.06.06,0,0,1,.06-.06.07.07,0,0,1,.07.06v3.89A.07.07,0,0,1,248.94,238.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,247.34a.07.07,0,0,1-.06-.07v-3.88a.07.07,0,0,1,.06-.07.07.07,0,0,1,.07.07v3.88A.07.07,0,0,1,248.94,247.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,261.09a.07.07,0,0,1-.06-.07v-3.88a.07.07,0,0,1,.06-.07.07.07,0,0,1,.07.07V261A.07.07,0,0,1,248.94,261.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,213a.06.06,0,0,1-.06-.06V209a.06.06,0,0,1,.06-.06.07.07,0,0,1,.07.06v3.89A.07.07,0,0,1,248.94,213Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,223.11a.07.07,0,0,1-.06-.07v-3.88a.07.07,0,0,1,.06-.07.07.07,0,0,1,.07.07V223A.07.07,0,0,1,248.94,223.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,228.28a.07.07,0,0,1-.06-.07v-3.88a.07.07,0,0,1,.06-.07.07.07,0,0,1,.07.07v3.88A.07.07,0,0,1,248.94,228.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,207.81a.06.06,0,0,1-.06-.06v-4.87a.06.06,0,0,1,.06-.06.07.07,0,0,1,.07.06v4.87A.07.07,0,0,1,248.94,207.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,196.53a.07.07,0,0,1-.06-.07v-2.78a.06.06,0,0,1,.06-.06.07.07,0,0,1,.07.06v2.78A.07.07,0,0,1,248.94,196.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,218a.07.07,0,0,1-.06-.07v-3.72a.07.07,0,0,1,.06-.07.07.07,0,0,1,.07.07v3.72A.07.07,0,0,1,248.94,218Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,233a.07.07,0,0,1-.06-.07v-3.44a.07.07,0,0,1,.06-.07.07.07,0,0,1,.07.07v3.44A.07.07,0,0,1,248.94,233Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,242.19a.07.07,0,0,1-.06-.07v-2.78a.06.06,0,0,1,.06-.06.07.07,0,0,1,.07.06v2.78A.07.07,0,0,1,248.94,242.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,255.94a.07.07,0,0,1-.06-.07V253.7a.07.07,0,0,1,.06-.07.07.07,0,0,1,.07.07v2.17A.07.07,0,0,1,248.94,255.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,188.68a.41.41,0,0,1-.18-.05.45.45,0,0,1-.19-.41,1.26,1.26,0,0,1,.58-1,.4.4,0,0,1,.65.37,1.26,1.26,0,0,1-.58,1A.54.54,0,0,1,248.7,188.68Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.9.31.31,0,0,0,.13.29.32.32,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9.34.34,0,0,0-.13-.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,197.88a.41.41,0,0,1-.18,0,.45.45,0,0,1-.19-.41,1.28,1.28,0,0,1,.58-1,.4.4,0,0,1,.65.38,1.26,1.26,0,0,1-.58,1A.54.54,0,0,1,248.7,197.88Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.9.31.31,0,0,0,.13.29.3.3,0,0,0,.32,0,1.12,1.12,0,0,0,.52-.89.34.34,0,0,0-.13-.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,234.34a.41.41,0,0,1-.18-.05.45.45,0,0,1-.19-.41,1.27,1.27,0,0,1,.58-1,.43.43,0,0,1,.46,0,.45.45,0,0,1,.19.41,1.28,1.28,0,0,1-.58,1A.54.54,0,0,1,248.7,234.34Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.9.31.31,0,0,0,.13.29.3.3,0,0,0,.32,0,1.12,1.12,0,0,0,.52-.89.34.34,0,0,0-.13-.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,243.54a.41.41,0,0,1-.18,0,.45.45,0,0,1-.19-.41,1.27,1.27,0,0,1,.58-1,.43.43,0,0,1,.46,0,.45.45,0,0,1,.19.41,1.28,1.28,0,0,1-.58,1A.54.54,0,0,1,248.7,243.54Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.9.31.31,0,0,0,.13.29.3.3,0,0,0,.32,0,1.12,1.12,0,0,0,.52-.89.34.34,0,0,0-.13-.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,257.29a.41.41,0,0,1-.18-.05.46.46,0,0,1-.19-.42,1.27,1.27,0,0,1,.58-1,.4.4,0,0,1,.65.38,1.26,1.26,0,0,1-.58,1A.54.54,0,0,1,248.7,257.29Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.89.33.33,0,0,0,.13.3.3.3,0,0,0,.32,0,1.12,1.12,0,0,0,.52-.89.34.34,0,0,0-.13-.3A.2.2,0,0,0,249.19,255.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,209.16a.41.41,0,0,1-.18,0,.45.45,0,0,1-.19-.41,1.28,1.28,0,0,1,.58-1,.4.4,0,0,1,.65.37,1.28,1.28,0,0,1-.58,1A.54.54,0,0,1,248.7,209.16Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.9.31.31,0,0,0,.13.29.32.32,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9.31.31,0,0,0-.13-.29A.2.2,0,0,0,249.19,207.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,219.3a.39.39,0,0,1-.18,0,.47.47,0,0,1-.19-.42,1.26,1.26,0,0,1,.58-1,.46.46,0,0,1,.46,0,.47.47,0,0,1,.19.42,1.26,1.26,0,0,1-.58,1A.63.63,0,0,1,248.7,219.3Zm.49-1.42a.37.37,0,0,0-.21.07,1.12,1.12,0,0,0-.52.89.33.33,0,0,0,.13.3.32.32,0,0,0,.32,0,1.12,1.12,0,0,0,.52-.89.33.33,0,0,0-.13-.3A.2.2,0,0,0,249.19,217.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,193.83a.41.41,0,0,1-.18-.05.45.45,0,0,1-.19-.41,1.28,1.28,0,0,1,.58-1,.4.4,0,0,1,.65.37,1.28,1.28,0,0,1-.58,1A.54.54,0,0,1,248.7,193.83Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.9.31.31,0,0,0,.13.29.32.32,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9.31.31,0,0,0-.13-.29A.2.2,0,0,0,249.19,192.41Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,203a.41.41,0,0,1-.18-.05.45.45,0,0,1-.19-.41,1.26,1.26,0,0,1,.58-1,.4.4,0,0,1,.65.37,1.26,1.26,0,0,1-.58,1A.54.54,0,0,1,248.7,203Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.9.31.31,0,0,0,.13.29.32.32,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9.34.34,0,0,0-.13-.3Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,253.84a.41.41,0,0,1-.18-.05.45.45,0,0,1-.19-.41,1.26,1.26,0,0,1,.58-1,.4.4,0,0,1,.65.37,1.24,1.24,0,0,1-.58,1A.54.54,0,0,1,248.7,253.84Zm.49-1.42a.37.37,0,0,0-.21.07,1.12,1.12,0,0,0-.52.89.34.34,0,0,0,.13.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9.31.31,0,0,0-.13-.29A.2.2,0,0,0,249.19,252.42Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,239.49a.41.41,0,0,1-.18-.05.45.45,0,0,1-.19-.41,1.26,1.26,0,0,1,.58-1,.4.4,0,0,1,.65.37,1.26,1.26,0,0,1-.58,1A.54.54,0,0,1,248.7,239.49Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.9.31.31,0,0,0,.13.29.32.32,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9.31.31,0,0,0-.13-.29A.2.2,0,0,0,249.19,238.07Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,248.69a.41.41,0,0,1-.18-.05.45.45,0,0,1-.19-.41,1.24,1.24,0,0,1,.58-1,.43.43,0,0,1,.46,0,.45.45,0,0,1,.19.41,1.26,1.26,0,0,1-.58,1A.54.54,0,0,1,248.7,248.69Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.9.31.31,0,0,0,.13.29.32.32,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9.34.34,0,0,0-.13-.3Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,262.44a.41.41,0,0,1-.18-.05.45.45,0,0,1-.19-.41,1.27,1.27,0,0,1,.58-1,.43.43,0,0,1,.46,0,.45.45,0,0,1,.19.41,1.28,1.28,0,0,1-.58,1A.54.54,0,0,1,248.7,262.44Zm.49-1.42a.45.45,0,0,0-.21.06,1.15,1.15,0,0,0-.52.9.31.31,0,0,0,.13.29.3.3,0,0,0,.32,0,1.12,1.12,0,0,0,.52-.89.34.34,0,0,0-.13-.3Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,214.31a.41.41,0,0,1-.18-.05.45.45,0,0,1-.19-.41,1.26,1.26,0,0,1,.58-1,.4.4,0,0,1,.65.37,1.24,1.24,0,0,1-.58,1A.54.54,0,0,1,248.7,214.31Zm.49-1.42a.37.37,0,0,0-.21.07,1.12,1.12,0,0,0-.52.89.34.34,0,0,0,.13.3.35.35,0,0,0,.32,0,1.15,1.15,0,0,0,.52-.9.31.31,0,0,0-.13-.29A.2.2,0,0,0,249.19,212.89Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,224.45a.39.39,0,0,1-.18,0,.47.47,0,0,1-.19-.42,1.3,1.3,0,0,1,.58-1,.48.48,0,0,1,.46,0,.47.47,0,0,1,.19.42,1.3,1.3,0,0,1-.58,1A.63.63,0,0,1,248.7,224.45Zm.49-1.42a.47.47,0,0,0-.21.07,1.12,1.12,0,0,0-.52.89.33.33,0,0,0,.13.3.32.32,0,0,0,.32,0,1.12,1.12,0,0,0,.52-.89.33.33,0,0,0-.13-.3A.2.2,0,0,0,249.19,223Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,229.62a.31.31,0,0,1-.18-.05.44.44,0,0,1-.19-.41,1.26,1.26,0,0,1,.58-1,.4.4,0,0,1,.65.38,1.27,1.27,0,0,1-.58,1A.63.63,0,0,1,248.7,229.62Zm.49-1.42a.37.37,0,0,0-.21.07,1.12,1.12,0,0,0-.52.89.34.34,0,0,0,.13.3.32.32,0,0,0,.32,0,1.13,1.13,0,0,0,.52-.89.33.33,0,0,0-.13-.3A.2.2,0,0,0,249.19,228.2Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.59,190.24s0-.08,0-.12a.78.78,0,0,1,.05-.14.37.37,0,0,1,.07-.12.28.28,0,0,1,.1-.09s.07,0,.1,0a.09.09,0,0,1,.07,0,.2.2,0,0,1,0,.08.49.49,0,0,1,0,.12.58.58,0,0,1,0,.19.74.74,0,0,1-.08.22l-.25.52.35-.2s0,0,0,0v0a.05.05,0,0,1,0,.05l-.43.25s0,0,0,0V191l0-.05.27-.58a1.17,1.17,0,0,1,.05-.11l0-.08s0-.05,0-.07a.17.17,0,0,0,0-.07.27.27,0,0,0,0-.15s-.07,0-.12,0a.21.21,0,0,0-.11.13.38.38,0,0,0-.05.19s0,0,0,0l0,0h0S244.59,190.26,244.59,190.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.19,190a1.09,1.09,0,0,1,0-.18.85.85,0,0,1,0-.17.64.64,0,0,1,.08-.14.32.32,0,0,1,.12-.11.15.15,0,0,1,.12,0,.1.1,0,0,1,.08.05.34.34,0,0,1,0,.12.81.81,0,0,1,0,.16V190a.91.91,0,0,1,0,.17.85.85,0,0,1,0,.17.64.64,0,0,1-.08.14.32.32,0,0,1-.12.11.15.15,0,0,1-.12,0,.1.1,0,0,1-.08-.05.34.34,0,0,1,0-.12.81.81,0,0,1,0-.16A1.22,1.22,0,0,1,245.19,190Zm.44-.25a.52.52,0,0,0,0-.23c0-.05-.08-.06-.14,0a.3.3,0,0,0-.14.18.78.78,0,0,0-.05.28v.26a.48.48,0,0,0,.05.24s.08.05.14,0a.3.3,0,0,0,.14-.17,1.25,1.25,0,0,0,0-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.1,190.15a.08.08,0,0,1,0,0h0s0,0,0,0v-1l-.19.33s0,0,0,0h0a0,0,0,0,1,0,0,0,0,0,0,1,0,0l.23-.4v0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,189.49a.25.25,0,0,0,0-.1.09.09,0,0,0,0-.06.07.07,0,0,0-.06,0l-.07,0-.07.06,0,.05,0,.06,0,0h0v0l0-.55s0-.05,0-.05l.35-.2s0,0,0,0v0a.08.08,0,0,1,0,0l-.31.17,0,.38,0-.06a.22.22,0,0,1,.09-.07.21.21,0,0,1,.1,0,.11.11,0,0,1,.08,0,.12.12,0,0,1,.05.08.3.3,0,0,1,0,.14.5.5,0,0,1,0,.18.53.53,0,0,1-.05.15.36.36,0,0,1-.08.12l-.1.08-.1,0-.08,0-.05-.07a.31.31,0,0,1,0-.1v0h0l0,0h0s0,0,0,0l0,.07,0,0h0l.06,0a.13.13,0,0,0,.07-.06.35.35,0,0,0,.06-.09.36.36,0,0,0,0-.11A.51.51,0,0,0,246.67,189.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.58,199.22a.49.49,0,0,1,0-.12.78.78,0,0,1,0-.14.37.37,0,0,1,.07-.12.28.28,0,0,1,.1-.09l.1,0a.09.09,0,0,1,.07,0,.2.2,0,0,1,0,.08.49.49,0,0,1,0,.12.69.69,0,0,1,0,.2.8.8,0,0,1-.08.21l-.25.53.35-.21s0,0,0,0v0a.05.05,0,0,1,0,.05l-.43.25s0,0,0,0V200s0,0,0,0l.28-.58,0-.1,0-.09s0,0,0-.07,0-.05,0-.07a.27.27,0,0,0,0-.15.11.11,0,0,0-.12,0,.24.24,0,0,0-.11.13.42.42,0,0,0,0,.2,0,0,0,0,0,0,0l0,0h0S244.58,199.24,244.58,199.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.18,199a1.09,1.09,0,0,1,0-.18.85.85,0,0,1,0-.17.64.64,0,0,1,.08-.14.43.43,0,0,1,.12-.11s.09,0,.12,0a.14.14,0,0,1,.08,0,.83.83,0,0,1,0,.12.86.86,0,0,1,0,.16V199a1.09,1.09,0,0,1,0,.18c0,.06,0,.11,0,.16a.71.71,0,0,1-.08.15.4.4,0,0,1-.12.1.15.15,0,0,1-.12,0,.1.1,0,0,1-.08-.05.34.34,0,0,1,0-.12.81.81,0,0,1,0-.16A1.22,1.22,0,0,1,245.18,199Zm.44-.25a.52.52,0,0,0-.05-.23s-.08-.06-.14,0a.37.37,0,0,0-.14.18.84.84,0,0,0,0,.29v.25a.48.48,0,0,0,0,.24c0,.05.08.05.14,0a.3.3,0,0,0,.14-.17,1.16,1.16,0,0,0,.05-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.09,199.13a.05.05,0,0,1,0,.05h0s0,0,0,0v-1l-.19.33s0,0,0,0v0s0,0,0,0a0,0,0,0,0,0,0l.23-.4s0,0,0,0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.23,198.72a.31.31,0,0,1,0-.1.29.29,0,0,1,0-.09.24.24,0,0,1,0-.08.14.14,0,0,1,0-.06l.21-.57v0l0,0h0s0,0,0,0h0l-.15.44,0,0,0,0a.19.19,0,0,1,.11,0,.2.2,0,0,1,.08,0,.31.31,0,0,1,0,.1.53.53,0,0,1,0,.13.76.76,0,0,1,0,.15.88.88,0,0,1,0,.15.57.57,0,0,1-.08.13.35.35,0,0,1-.11.1c-.05,0-.08,0-.11,0a.08.08,0,0,1-.08,0,.13.13,0,0,1-.05-.09A.59.59,0,0,1,246.23,198.72Zm.45-.26a.37.37,0,0,0,0-.12.09.09,0,0,0,0-.06l-.06,0-.07,0-.07.06a.24.24,0,0,0-.06.09.43.43,0,0,0-.05.12.53.53,0,0,0,0,.13.37.37,0,0,0,0,.11.18.18,0,0,0,.05.07l.06,0,.07,0a.19.19,0,0,0,.07-.06.35.35,0,0,0,.06-.09.36.36,0,0,0,0-.11A.59.59,0,0,0,246.68,198.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.68,210.45a.62.62,0,0,1,0-.13.69.69,0,0,1,.05-.13.24.24,0,0,1,.07-.12l.1-.1.1,0,.07,0a.15.15,0,0,1,0,.08.37.37,0,0,1,0,.11.64.64,0,0,1,0,.2,1.45,1.45,0,0,1-.08.21l-.25.53.35-.2s0,0,0,0v0a0,0,0,0,1,0,.05l-.43.25s0,0,0,0v-.06a.08.08,0,0,0,0,0l.28-.58a.93.93,0,0,1,.05-.1l0-.08s0-.05,0-.08,0,0,0-.07a.21.21,0,0,0,0-.14s-.07,0-.12,0a.24.24,0,0,0-.11.13.46.46,0,0,0-.05.2,0,0,0,0,0,0,0l0,0h0S244.68,210.47,244.68,210.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.28,210.21a1.09,1.09,0,0,1,0-.18.75.75,0,0,1,0-.16.71.71,0,0,1,.08-.15.29.29,0,0,1,.12-.1.24.24,0,0,1,.12,0,.16.16,0,0,1,.08.06.83.83,0,0,1,0,.12.81.81,0,0,1,0,.16v.27a1.09,1.09,0,0,1,0,.18c0,.06,0,.12,0,.17a.64.64,0,0,1-.08.14.43.43,0,0,1-.12.11l-.12,0a.16.16,0,0,1-.08-.06.36.36,0,0,1,0-.11.91.91,0,0,1,0-.17A1.22,1.22,0,0,1,245.28,210.21Zm.44-.24a.62.62,0,0,0-.05-.24s-.08,0-.14,0a.37.37,0,0,0-.14.18.84.84,0,0,0,0,.29v.26a.41.41,0,0,0,0,.23c0,.05.08.05.14,0a.37.37,0,0,0,.14-.18,1.16,1.16,0,0,0,.05-.29V210Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.19,210.35a0,0,0,0,1,0,.05h0s0,0,0,0v-1l-.19.34s0,0,0,0v0s0,0,0,0,0,0,0,0l.23-.39v0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,208.94s0,0,0,0V209s0,0,0,0l-.27,1.13v0l0,0h0v0h0l.27-1.15-.36.21s0,0,0,0v0a.05.05,0,0,1,0-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.54,220.67a.5.5,0,0,1,0-.12.74.74,0,0,1,0-.14.75.75,0,0,1,.07-.12.28.28,0,0,1,.1-.09s.08,0,.1,0a.08.08,0,0,1,.07,0,.2.2,0,0,1,0,.08.49.49,0,0,1,0,.12.58.58,0,0,1,0,.19,1.28,1.28,0,0,1-.09.22l-.25.52.36-.2s0,0,0,0v0a.08.08,0,0,1,0,0l-.44.25s0,0,0,0v0a0,0,0,0,1,0,0s0,0,0-.05l.27-.58,0-.11,0-.08a158667781228.33,158667781228.33,0,0,1,0-.14.27.27,0,0,0,0-.15s-.07,0-.12,0a.24.24,0,0,0-.11.13.38.38,0,0,0,0,.19s0,0,0,0l0,0h0S244.54,220.69,244.54,220.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.14,220.44a1.09,1.09,0,0,1,0-.18.85.85,0,0,1,0-.17.64.64,0,0,1,.08-.14.32.32,0,0,1,.12-.11.15.15,0,0,1,.12,0,.1.1,0,0,1,.08.05.34.34,0,0,1,0,.12.81.81,0,0,1,0,.16,1.31,1.31,0,0,1,0,.28.91.91,0,0,1,0,.17.85.85,0,0,1,0,.17.64.64,0,0,1-.08.14.32.32,0,0,1-.12.11.15.15,0,0,1-.12,0,.1.1,0,0,1-.08,0,.34.34,0,0,1,0-.12.81.81,0,0,1,0-.16Zm.44-.25a.41.41,0,0,0-.05-.23c0-.05-.08-.06-.14,0a.3.3,0,0,0-.14.18,1.08,1.08,0,0,0-.05.28v.26a.62.62,0,0,0,.05.24s.08,0,.14,0a.3.3,0,0,0,.14-.17.88.88,0,0,0,.05-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,220.58a.08.08,0,0,1,0,0h0s0,0,0,0v-1l-.19.33s0,0,0,0h0s0,0,0,0v0l.23-.4s0,0,0,0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.2,220.21a.64.64,0,0,1,0-.2.51.51,0,0,1,.09-.16.13.13,0,0,1-.07-.06.23.23,0,0,1,0-.13.59.59,0,0,1,0-.14.73.73,0,0,1,0-.12.44.44,0,0,1,.08-.1l.09-.08a.16.16,0,0,1,.09,0,.11.11,0,0,1,.08,0,.18.18,0,0,1,.05.07.37.37,0,0,1,0,.12.45.45,0,0,1,0,.16.46.46,0,0,1-.07.14.1.1,0,0,1,.09.06.31.31,0,0,1,0,.15.41.41,0,0,1,0,.16.58.58,0,0,1,0,.14l-.09.11a.39.39,0,0,1-.1.08.21.21,0,0,1-.1,0,.11.11,0,0,1-.08,0,.11.11,0,0,1-.06-.07A.25.25,0,0,1,246.2,220.21Zm.06,0a.2.2,0,0,0,0,.09.1.1,0,0,0,0,.05.07.07,0,0,0,.06,0,.13.13,0,0,0,.08,0,.21.21,0,0,0,.08-.06l.06-.08a.3.3,0,0,0,0-.1.36.36,0,0,0,0-.11.29.29,0,0,0,0-.09.1.1,0,0,0,0,0h-.06a.13.13,0,0,0-.08,0s-.05,0-.08.06l-.06.08a.42.42,0,0,0,0,.1A.43.43,0,0,0,246.26,220.17Zm0-.55s0,.06,0,.08a.08.08,0,0,0,0,0h.06l.06,0,.07-.05.05-.07a.3.3,0,0,0,0-.08.31.31,0,0,0,0-.1.15.15,0,0,0,0-.07s0,0,0,0a0,0,0,0,0-.05,0l-.07,0-.06.05s0,0-.06.07a.36.36,0,0,0,0,.09S246.29,219.59,246.29,219.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.59,235.9s0-.08,0-.12a.78.78,0,0,1,.05-.14.37.37,0,0,1,.07-.12.28.28,0,0,1,.1-.09.11.11,0,0,1,.1,0,.09.09,0,0,1,.07,0,.2.2,0,0,1,0,.08.49.49,0,0,1,0,.12.58.58,0,0,1,0,.19.74.74,0,0,1-.08.22l-.25.52.35-.2s0,0,0,0v0a.05.05,0,0,1,0,.05l-.43.25s0,0,0,0v-.06l0,0,.27-.58a1.17,1.17,0,0,1,.05-.11l0-.08s0-.05,0-.07a.17.17,0,0,0,0-.07.25.25,0,0,0,0-.15s-.07,0-.12,0a.21.21,0,0,0-.11.13.38.38,0,0,0-.05.19s0,0,0,0h0l0,0S244.59,235.92,244.59,235.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.19,235.66a1,1,0,0,1,0-.17.85.85,0,0,1,0-.17.64.64,0,0,1,.08-.14.32.32,0,0,1,.12-.11.15.15,0,0,1,.12,0,.1.1,0,0,1,.08.05.34.34,0,0,1,0,.12.81.81,0,0,1,0,.16v.28a.91.91,0,0,1,0,.17.85.85,0,0,1,0,.17.64.64,0,0,1-.08.14.32.32,0,0,1-.12.11.15.15,0,0,1-.12,0,.1.1,0,0,1-.08-.05.34.34,0,0,1,0-.12.81.81,0,0,1,0-.16A1.31,1.31,0,0,1,245.19,235.66Zm.44-.24a.52.52,0,0,0,0-.23c0-.05-.08-.06-.14,0a.3.3,0,0,0-.14.18.78.78,0,0,0-.05.28v.26a.48.48,0,0,0,.05.24s.08.05.14,0a.3.3,0,0,0,.14-.17,1.25,1.25,0,0,0,0-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.1,235.81a.08.08,0,0,1,0,.05h0s0,0,0,0v-1l-.19.33s0,0,0,0h0a0,0,0,0,1,0,0s0,0,0,0l.23-.39v0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,234.7a.28.28,0,0,1,0,.09s0,.06,0,.09a.19.19,0,0,0,0,.07.14.14,0,0,0,0,.06l-.22.6v0l0,0h0a0,0,0,0,1,0,0v0h0l.17-.45-.07.05-.11,0a.12.12,0,0,1-.08,0,.26.26,0,0,1,0-.09.53.53,0,0,1,0-.13.66.66,0,0,1,0-.14.88.88,0,0,1,0-.15.57.57,0,0,1,.08-.13.52.52,0,0,1,.11-.1l.11,0a.12.12,0,0,1,.08,0,.3.3,0,0,1,0,.1A.43.43,0,0,1,246.73,234.7Zm-.44.25a.36.36,0,0,0,0,.11.09.09,0,0,0,0,.06.07.07,0,0,0,.06,0,.11.11,0,0,0,.07,0,.19.19,0,0,0,.07-.06l.06-.09s0-.07,0-.11a.49.49,0,0,0,0-.12.37.37,0,0,0,0-.11.15.15,0,0,0,0-.06.07.07,0,0,0-.06,0,.1.1,0,0,0-.07,0,.13.13,0,0,0-.07.06.35.35,0,0,0-.06.09.36.36,0,0,0,0,.11A.5.5,0,0,0,246.29,235Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.37,245a.5.5,0,0,1,0-.12.74.74,0,0,1,0-.14.75.75,0,0,1,.07-.12.28.28,0,0,1,.1-.09l.11,0a.07.07,0,0,1,.06,0,.12.12,0,0,1,0,.08.5.5,0,0,1,0,.12.69.69,0,0,1,0,.2,1.65,1.65,0,0,1-.09.21l-.25.52.36-.2s0,0,0,0v0a.08.08,0,0,1,0,.05l-.44.25s0,0,0,0v0a0,0,0,0,1,0,0s0,0,0,0l.27-.58a.54.54,0,0,0,.05-.11l0-.08a.17.17,0,0,0,0-.07.17.17,0,0,0,0-.07.21.21,0,0,0,0-.15.11.11,0,0,0-.12,0,.24.24,0,0,0-.11.13.53.53,0,0,0-.05.19s0,0,0,0l0,0h0S244.37,245,244.37,245Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,244.77a1.09,1.09,0,0,1,0-.18c0-.06,0-.12,0-.17a.64.64,0,0,1,.08-.14.32.32,0,0,1,.12-.11.15.15,0,0,1,.12,0,.14.14,0,0,1,.08.05.34.34,0,0,1,0,.12c0,.05,0,.1,0,.16v.28c0,.06,0,.12,0,.18a.94.94,0,0,1,0,.16,1.09,1.09,0,0,1-.08.15.4.4,0,0,1-.12.1.15.15,0,0,1-.12,0,.08.08,0,0,1-.07-.05.33.33,0,0,1-.05-.12.81.81,0,0,1,0-.16Zm.44-.25a.41.41,0,0,0,0-.23s-.08-.06-.14,0a.33.33,0,0,0-.14.18.85.85,0,0,0,0,.29.49.49,0,0,0,0,.12.57.57,0,0,0,0,.13.49.49,0,0,0,0,.24s.08.05.14,0a.3.3,0,0,0,.14-.17.84.84,0,0,0,0-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.61,244.28a.74.74,0,0,1,0-.12.65.65,0,0,1,0-.13.54.54,0,0,1,.07-.13l.1-.09.11,0a.11.11,0,0,1,.06,0,.25.25,0,0,1,0,.09.36.36,0,0,1,0,.11.64.64,0,0,1,0,.2,1.65,1.65,0,0,1-.09.21l-.25.53.36-.2s0,0,0,0v0a.06.06,0,0,1,0,.05l-.44.25s0,0,0,0v0a0,0,0,0,1,0,0l0,0,.27-.58a.93.93,0,0,0,0-.1l0-.08a.22.22,0,0,0,0-.08.15.15,0,0,0,0-.07c0-.07,0-.12,0-.14s-.07,0-.12,0a.28.28,0,0,0-.11.13.65.65,0,0,0,0,.2s0,0,0,0l0,0h0S245.61,244.3,245.61,244.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.21,244.05a1.09,1.09,0,0,1,0-.18,1,1,0,0,1,0-.17.64.64,0,0,1,.08-.14.29.29,0,0,1,.12-.1.24.24,0,0,1,.12,0,.16.16,0,0,1,.08.06.34.34,0,0,1,0,.12.81.81,0,0,1,0,.16,1.22,1.22,0,0,1,0,.27,1.09,1.09,0,0,1,0,.18,1,1,0,0,1,0,.17.64.64,0,0,1-.08.14.29.29,0,0,1-.12.1.24.24,0,0,1-.12,0,.11.11,0,0,1-.07-.06.33.33,0,0,1-.05-.12.76.76,0,0,1,0-.16Zm.44-.25a.46.46,0,0,0-.05-.23s-.08,0-.14,0a.37.37,0,0,0-.14.18.85.85,0,0,0,0,.29.85.85,0,0,0,0,.26.43.43,0,0,0,0,.23c0,.05.08.05.14,0a.37.37,0,0,0,.14-.18.84.84,0,0,0,.05-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.6,258.84a.5.5,0,0,1,0-.12.74.74,0,0,1,0-.14.75.75,0,0,1,.07-.12.28.28,0,0,1,.1-.09l.1,0a.08.08,0,0,1,.07,0,.2.2,0,0,1,0,.08.5.5,0,0,1,0,.12.69.69,0,0,1,0,.2,1.65,1.65,0,0,1-.09.21l-.25.53.36-.21s0,0,0,0v0a.08.08,0,0,1,0,0l-.44.25s0,0,0,0v0a0,0,0,0,1,0,0s0,0,0-.05l.27-.58a.93.93,0,0,0,.05-.1l0-.09a181334607117.45,181334607117.45,0,0,1,0-.14.21.21,0,0,0,0-.15.11.11,0,0,0-.12,0,.28.28,0,0,0-.11.13.53.53,0,0,0-.05.2v0l0,0h0S244.6,258.86,244.6,258.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2,258.61a1.09,1.09,0,0,1,0-.18.85.85,0,0,1,0-.17.64.64,0,0,1,.08-.14.43.43,0,0,1,.12-.11.15.15,0,0,1,.12,0,.14.14,0,0,1,.08,0,.34.34,0,0,1,0,.12.86.86,0,0,1,0,.16,1.31,1.31,0,0,1,0,.28,1.09,1.09,0,0,1,0,.18.94.94,0,0,1,0,.16.71.71,0,0,1-.08.15.4.4,0,0,1-.12.1.15.15,0,0,1-.12,0,.08.08,0,0,1-.07,0,.33.33,0,0,1,0-.12.81.81,0,0,1,0-.16Zm.44-.25a.41.41,0,0,0,0-.23c0-.05-.08-.06-.14,0a.37.37,0,0,0-.14.18.85.85,0,0,0,0,.29.49.49,0,0,0,0,.12.57.57,0,0,0,0,.13.49.49,0,0,0,0,.24s.08.05.14,0a.3.3,0,0,0,.14-.17.84.84,0,0,0,0-.29v-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84,258.12a.74.74,0,0,1,0-.12.65.65,0,0,1,0-.13.54.54,0,0,1,.07-.13l.1-.09.1,0a.11.11,0,0,1,.07,0,.25.25,0,0,1,0,.09.36.36,0,0,1,0,.11.64.64,0,0,1,0,.2,1.65,1.65,0,0,1-.09.21l-.25.53.36-.2s0,0,0,0v0a.06.06,0,0,1,0,.05l-.44.25s0,0,0,0v0s0,0,0,0a.17.17,0,0,1,0-.05l.27-.58.05-.1,0-.08a.22.22,0,0,0,0-.08.15.15,0,0,0,0-.07c0-.07,0-.12,0-.14s-.07,0-.12,0a.28.28,0,0,0-.11.13.46.46,0,0,0-.05.2v0l0,0h0S245.84,258.15,245.84,258.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.7,258.41a.08.08,0,0,1,0,0h0s0,0,0,0v-1l-.18.33s0,0,0,0h0v0s0,0,0,0l.22-.4s0,0,0,0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,188.27l12-6.94c.33-.18.59-.05.59.3a1.23,1.23,0,0,1-.59,1l-12,6.94c-.33.19-.59.06-.59-.3A1.24,1.24,0,0,1,253.93,188.27Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,188.27l12-6.94c.33-.18.59-.05.59.3a1.23,1.23,0,0,1-.59,1l-12,6.94c-.33.19-.59.06-.59-.3A1.24,1.24,0,0,1,253.93,188.27Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,192.69a.27.27,0,0,1-.23-.14.27.27,0,0,1,.09-.37L270.79,182a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37l-17.58,10.15A.25.25,0,0,1,253.34,192.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,258.58l12-6.94c.33-.19.59-.06.59.3a1.24,1.24,0,0,1-.59,1l-12,6.94c-.33.18-.59,0-.59-.3A1.23,1.23,0,0,1,253.93,258.58Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,258.58l12-6.94c.33-.19.59-.06.59.3a1.24,1.24,0,0,1-.59,1l-12,6.94c-.33.18-.59,0-.59-.3A1.23,1.23,0,0,1,253.93,258.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,263a.28.28,0,0,1-.23-.13.27.27,0,0,1,.09-.37l17.59-10.16a.27.27,0,1,1,.27.47L253.48,263A.35.35,0,0,1,253.34,263Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,234.46l12-6.93c.33-.19.59-.06.59.29a1.26,1.26,0,0,1-.59,1l-12,6.93c-.33.19-.59.06-.59-.29A1.26,1.26,0,0,1,253.93,234.46Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,234.46l12-6.93c.33-.19.59-.06.59.29a1.26,1.26,0,0,1-.59,1l-12,6.93c-.33.19-.59.06-.59-.29A1.26,1.26,0,0,1,253.93,234.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,238.88a.27.27,0,0,1-.23-.14.26.26,0,0,1,.09-.36l17.59-10.16a.27.27,0,1,1,.27.47l-17.58,10.15A.25.25,0,0,1,253.34,238.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,218.36l12-6.94c.33-.18.59,0,.59.3a1.23,1.23,0,0,1-.59,1l-12,6.94c-.33.19-.59.06-.59-.3A1.24,1.24,0,0,1,253.93,218.36Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,218.36l12-6.94c.33-.18.59,0,.59.3a1.23,1.23,0,0,1-.59,1l-12,6.94c-.33.19-.59.06-.59-.3A1.24,1.24,0,0,1,253.93,218.36Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,222.78a.27.27,0,0,1-.23-.14.27.27,0,0,1,.09-.37l17.59-10.15a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37l-17.58,10.15A.25.25,0,0,1,253.34,222.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,197.15l12-6.93c.33-.19.59-.06.59.29a1.26,1.26,0,0,1-.59,1l-12,6.93c-.33.19-.59.06-.59-.29A1.26,1.26,0,0,1,253.93,197.15Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,197.15l12-6.93c.33-.19.59-.06.59.29a1.26,1.26,0,0,1-.59,1l-12,6.93c-.33.19-.59.06-.59-.29A1.26,1.26,0,0,1,253.93,197.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,201.57a.27.27,0,0,1-.23-.14.27.27,0,0,1,.09-.37l17.59-10.15a.27.27,0,0,1,.27.47l-17.58,10.15A.25.25,0,0,1,253.34,201.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,203.86a.27.27,0,0,1-.23-.14.27.27,0,0,1,.09-.37l17.59-10.15a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37l-17.58,10.15A.37.37,0,0,1,253.34,203.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,207.94l12-6.94c.33-.18.59-.05.59.3a1.24,1.24,0,0,1-.59,1l-12,6.94c-.33.19-.59,0-.59-.3A1.24,1.24,0,0,1,253.93,207.94Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,207.94l12-6.94c.33-.18.59-.05.59.3a1.24,1.24,0,0,1-.59,1l-12,6.94c-.33.19-.59,0-.59-.3A1.24,1.24,0,0,1,253.93,207.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,212.36a.27.27,0,0,1-.23-.14.27.27,0,0,1,.09-.37l17.59-10.15a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37l-17.58,10.15A.37.37,0,0,1,253.34,212.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,214.64a.28.28,0,0,1-.23-.13.27.27,0,0,1,.09-.37L270.79,204a.27.27,0,1,1,.27.47L253.48,214.6A.25.25,0,0,1,253.34,214.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,224.83l12-6.93c.33-.19.59-.06.59.29a1.23,1.23,0,0,1-.59,1l-12,6.94c-.33.19-.59.06-.59-.29A1.26,1.26,0,0,1,253.93,224.83Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,224.83l12-6.93c.33-.19.59-.06.59.29a1.23,1.23,0,0,1-.59,1l-12,6.94c-.33.19-.59.06-.59-.29A1.26,1.26,0,0,1,253.93,224.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,229.25a.27.27,0,0,1-.23-.14.27.27,0,0,1,.09-.37l17.59-10.15a.27.27,0,1,1,.27.47l-17.58,10.15A.25.25,0,0,1,253.34,229.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,231.53a.26.26,0,0,1-.23-.13.27.27,0,0,1,.09-.37l17.59-10.15a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.37L253.48,231.5A.35.35,0,0,1,253.34,231.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,242.78l12-6.94c.33-.19.59-.06.59.29a1.25,1.25,0,0,1-.59,1l-12,6.94c-.33.18-.59,0-.59-.3A1.23,1.23,0,0,1,253.93,242.78Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,242.78l12-6.94c.33-.19.59-.06.59.29a1.25,1.25,0,0,1-.59,1l-12,6.94c-.33.18-.59,0-.59-.3A1.23,1.23,0,0,1,253.93,242.78Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,247.19a.28.28,0,0,1-.23-.13.27.27,0,0,1,.09-.37l17.59-10.16a.27.27,0,1,1,.27.47l-17.58,10.15A.25.25,0,0,1,253.34,247.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,249.25l12-6.94c.33-.19.59-.05.59.3a1.24,1.24,0,0,1-.59,1l-12,6.94c-.33.18-.59,0-.59-.3A1.23,1.23,0,0,1,253.93,249.25Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,249.25l12-6.94c.33-.19.59-.05.59.3a1.24,1.24,0,0,1-.59,1l-12,6.94c-.33.18-.59,0-.59-.3A1.23,1.23,0,0,1,253.93,249.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,253.66a.28.28,0,0,1-.23-.13.27.27,0,0,1,.09-.37L270.79,243a.27.27,0,1,1,.27.46l-17.58,10.16A.35.35,0,0,1,253.34,253.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,256a.27.27,0,0,1-.23-.14.27.27,0,0,1,.09-.37l17.59-10.15a.27.27,0,1,1,.27.47l-17.58,10.15A.25.25,0,0,1,253.34,256Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242,154a5.31,5.31,0,0,1-.71,4c-1.09,1.38-1.36,3-.19,4.25s.54,1.79-.22,2.83-.7,2.88,1,3,12-4.68,13.07-5.91,1.53-2.3.85-3.38-1.8-1.43-1.8-3.09,1.34-2.85.78-3.94S242,154,242,154Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.61,165.72s-2.49-1.88-2.68-1.62l-.68,1-1.18-3.71c2.49-.75,3.85.48,6.24,2.46v.94Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,171.56c-.24-5,1.5-6.33,1.52-6.34l1.13-.53c.81-.37,6.68-1.45,6.68-1.45l1.9-1.89a8.43,8.43,0,0,1,2.67,1.52,4.1,4.1,0,0,1,1.87,2.85l-15.79,9.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.36,161.13c-.2-1.72-2.86-1.36-4.1-5.13-.65-2-.35-5.88,1.81-6.83,1-3.7,4.94-5.94,8.62-5.77a4.77,4.77,0,0,1,4.21,3.22c1.4,3.76-.76,6.24-1.43,7.38-.35.61-.87-2.7-1.12-2a10.14,10.14,0,0,0-.47,1.51,6.73,6.73,0,0,1-2,2.36C250,157.59,248.14,159.32,246.36,161.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.56,162.73l-.45-3.72a1.56,1.56,0,0,1-2,.21,2.34,2.34,0,0,1-.8-3.09,1.63,1.63,0,0,1,2.74-.31c.95-.06,1.25-1.59.45-2.81,0,0-.39-2.63,1.34-3.77,1.32-.87,2.22-.5,3.7-.47,1.08-.39,1.18-1.94,2.56-1.72a4.88,4.88,0,0,1,1.19,4.08,7.15,7.15,0,0,0,.34,1.55c.55,2.48-.38,5.29-1.4,6.12a6,6,0,0,1-2.58,1.29l.12,1h0c.05.52.17.5.6.39l.66-.17s1.59,2.49-1.49,3.89c-4.59,2.11-7.09-.55-7.09-.55l1-.48A1.45,1.45,0,0,0,246.56,162.73Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29,156.65l1.71,0a1.17,1.17,0,0,1-1.05,1A.78.78,0,0,1,250.29,156.65Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.42,157a.76.76,0,0,1,1,.49,1,1,0,0,1-.49.15.68.68,0,0,1-.65-.58A.67.67,0,0,1,250.42,157Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.33,149.69l-1.26-.19a.83.83,0,0,1,.84-.65A.62.62,0,0,1,254.33,149.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.81,152,250,151a.58.58,0,0,0-.93,0A.9.9,0,0,0,248.81,152Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.46,151.87a.46.46,0,0,0,.56.49.77.77,0,0,0,.57-.72.45.45,0,0,0-.55-.48A.76.76,0,0,0,253.46,151.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.4,153.6a.46.46,0,0,0,.56.49.75.75,0,0,0,.57-.71.45.45,0,0,0-.55-.49A.78.78,0,0,0,249.4,153.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.69,160.09c-2.15.44-4.24.35-4.78-.53,0,0,.05,1.12,1,1.39a12.39,12.39,0,0,0,3.92-.07Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.92,155.21a1.6,1.6,0,0,1,.67.18l1.39-1.14.08-.06.13.09a.33.33,0,0,1,.11.17,6.45,6.45,0,0,0,.45,1.25,1.11,1.11,0,0,0,.41.35l.19.06.11,0a1.87,1.87,0,0,0,.33,0h.14l.09,0,.28-.09.12,0,.15-.07a3.29,3.29,0,0,0,1.84-1.94c.24-.67.1-1.39.63-1.64l.05,0,0,0c.4-.09.41.63.7,1a1.08,1.08,0,0,0,.42.37l.1.05h0l.05,0h.17a1.57,1.57,0,0,0,.47,0h.05a3.07,3.07,0,0,0,.56-.21,2.76,2.76,0,0,0,1-.71,2.57,2.57,0,0,0,.57-1,10.43,10.43,0,0,0,.22-1.56.62.62,0,0,1,.08-.24,1.46,1.46,0,0,0,.2-.63c0-.23-.18-.37-.33-.32l-.26.09c-.28.1-.58.22-.89.36a8.24,8.24,0,0,0-1.73.94,13,13,0,0,1-1.56,1.26,8.67,8.67,0,0,1-1.74.28,11.34,11.34,0,0,0-2.81,1.22l-.29.16-.32.28Zm8.09-3.72a4.29,4.29,0,0,1,1.36-1.21l.4-.21,0,0,.05,0L255,150l.05,0,.06,0,.12-.05.1,0,.09,0h.32a.65.65,0,0,1,.22,0c.19.08.15.86.1,1.28a2.75,2.75,0,0,1-.47,1.29,1.55,1.55,0,0,1-.24.28,2.49,2.49,0,0,1-.63.43c-.68.33-1.09.24-1.33,0h0l0,0,0,0h0l0-.05,0,0,0,0h0v0l0,0a2.08,2.08,0,0,1-.1-.24A1.78,1.78,0,0,1,253,151.49Zm-5.26,2.13a3.46,3.46,0,0,1,1.57-1,.19.19,0,0,1,.09,0l.4-.12.15,0,.39-.06h.33a.54.54,0,0,1,.27.08c.19.15.18.66.12,1.12a2.47,2.47,0,0,1-.35.93,2.6,2.6,0,0,1-1.22,1c-.62.28-1,.21-1.25,0a.08.08,0,0,1,0,0l0,0,0,0,0,0,0,0,0,0,0-.05a.54.54,0,0,1-.07-.13.59.59,0,0,1,0-.08,1.12,1.12,0,0,1-.05-.13,0,0,0,0,1,0,0v0C247.74,154.56,247.57,153.87,247.75,153.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.94,154l-1.79,1.22-.57-2.11c.07-.38.14-.69.46-.84l.06,0,0,0h0Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.17,173.43l-5.84,3.33v-6.09c1.53-4.12,2.64-4.49,5-5.45h0C245.31,167.08,244.48,171.85,244.17,173.43Z",
    style: {
      fill: "#46C5FB"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M238.27,177.22a.37.37,0,0,1-.35-.34v-30a.34.34,0,0,1,.18-.3l21.13-12.2a.34.34,0,0,1,.34,0,.32.32,0,0,1,.17.29v30a.33.33,0,0,1-.17.3l-21.13,12.2A.41.41,0,0,1,238.27,177.22Zm.34-30.11v29.17l20.45-11.8V135.3Z",
    style: {
      fill: "#46C5FB"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--resume--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--resume--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.76,47.88l-130.58,75.3a5.4,5.4,0,0,0-2.45,4.23V338.46a5.37,5.37,0,0,0,2.45,4.22l.5.28a5.4,5.4,0,0,0,4.89,0l130.58-75.39a5.41,5.41,0,0,0,2.44-4.23V52.38a5.34,5.34,0,0,0-2.45-4.22l-.49-.29A5.43,5.43,0,0,0,399.76,47.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59,263.5c0,2.15-1.51,3.52-3.37,4.59L275.5,342.4c-1.86,1.08-3.38.21-3.38-1.95V131.56h0a6.74,6.74,0,0,1,3.36-5.83L404.21,51.39a2.25,2.25,0,0,1,3.38,2h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.34,51.83a1.52,1.52,0,0,1,1.51,1.51V263.5c0,1.53-.93,2.75-3,3.95L275.13,341.76a2.42,2.42,0,0,1-1.14.36c-1,0-1.12-1.17-1.12-1.67V131.56a6,6,0,0,1,3-5.18L404.58,52a1.57,1.57,0,0,1,.76-.2m0-.74a2.25,2.25,0,0,0-1.13.3L275.48,125.73a6.74,6.74,0,0,0-3.36,5.83V340.45c0,1.53.77,2.41,1.87,2.41a3.07,3.07,0,0,0,1.51-.46l128.72-74.31c1.86-1.07,3.37-2.44,3.37-4.59V53.34a2.25,2.25,0,0,0-2.25-2.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59,52.38v1a2.26,2.26,0,0,0-3.38-2L275.48,125.74a6.55,6.55,0,0,0-2.45,2.45.3.3,0,0,0,0,.08l-5.57-3.22a4.94,4.94,0,0,1,1.76-1.86L399.76,47.88a5.41,5.41,0,0,1,4.88,0l.5.29A5.37,5.37,0,0,1,407.59,52.38Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--resume--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.57,121.51V260.84L281.12,328.66V189.32l117.45-67.81m.8-1.38-119,68.73V330l119-68.73V120.13Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341 295 399.37 261.3 399.37 120.13 341 153.83 341 295",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341 295 399.37 261.3 399.37 120.13 341 153.83 341 295",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,128.58a.69.69,0,0,1-.62-.36.7.7,0,0,1,.26-1l75.24-43.4a.72.72,0,0,1,.72,1.25l-75.24,43.39A.8.8,0,0,1,318.3,128.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,135.31a.71.71,0,0,1-.62-.36.72.72,0,0,1,.26-1l75.24-43.39a.72.72,0,1,1,.72,1.24l-75.24,43.39A.7.7,0,0,1,318.3,135.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,142a.72.72,0,0,1-.36-1.34l75.24-43.39a.72.72,0,1,1,.72,1.24l-75.24,43.39A.7.7,0,0,1,318.3,142Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,121.84a.71.71,0,0,1-.62-.36.72.72,0,0,1,.26-1l75.24-43.39a.72.72,0,1,1,.72,1.24l-75.24,43.4A.8.8,0,0,1,318.3,121.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.41,127.67c0,2.8-1.7,6.06-3.8,7.28s-3.81-.08-3.81-2.88,1.7-6.07,3.81-7.28S367.41,124.86,367.41,127.67Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.59 133.39 362.46 132.89 362.46 129.16 361.59 129.66 361.59 133.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,128.92a1.2,1.2,0,0,0,.51-1c0-.38-.22-.55-.51-.39a1.23,1.23,0,0,0-.51,1C361.51,128.91,361.74,129.09,362,128.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.84,130.13a1.24,1.24,0,0,1,.53-1.14c.32-.18.47,0,.47.57v1.95l.86-.5v-2.35c0-1-.42-1.24-1-.9a2.21,2.21,0,0,0-.84,1.1v-.5l-.83.48v3.73l.83-.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.57,120.08c0,2.8-1.71,6.06-3.81,7.27s-3.81-.07-3.81-2.88,1.7-6.06,3.81-7.27S380.57,117.27,380.57,120.08Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.76,119.77l.92-.52a1.3,1.3,0,0,1,.43-.14.38.38,0,0,1,.26.08.47.47,0,0,1,.17.25,1.43,1.43,0,0,1,.08.52c0,.32,0,.41,0,1.23s0,.91,0,1.24a2.21,2.21,0,0,1-.08.61,2,2,0,0,1-.17.46,1.7,1.7,0,0,1-.26.38,2.42,2.42,0,0,1-.43.35c-.24.15-.31.2-.92.55l-.93.52a1.2,1.2,0,0,1-.42.14.41.41,0,0,1-.27-.08.47.47,0,0,1-.17-.25,1.71,1.71,0,0,1-.08-.52c0-.32,0-.41,0-1.23s0-.91,0-1.24a2.91,2.91,0,0,1,.08-.62,2.07,2.07,0,0,1,.17-.45,1.74,1.74,0,0,1,.27-.38,1.88,1.88,0,0,1,.42-.35c.24-.15.32-.2.93-.55m0-.55-.95.56a2.89,2.89,0,0,0-1,1,3,3,0,0,0-.26.7,3.35,3.35,0,0,0-.11.8c0,.33,0,.44,0,1.27s0,.93,0,1.25a2.07,2.07,0,0,0,.11.68.77.77,0,0,0,.26.39.62.62,0,0,0,.41.12,1.49,1.49,0,0,0,.55-.18c.25-.13.33-.17.95-.53l.94-.56a2.77,2.77,0,0,0,.56-.47,2.69,2.69,0,0,0,.41-.58,3.53,3.53,0,0,0,.26-.7,3.35,3.35,0,0,0,.11-.8c0-.33,0-.44,0-1.27s0-.93,0-1.25a2.07,2.07,0,0,0-.11-.68.84.84,0,0,0-.26-.39.57.57,0,0,0-.41-.12,1.53,1.53,0,0,0-.56.18c-.24.13-.32.17-.94.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.76,120.7a2.84,2.84,0,0,0-1.18,2.25c0,.87.53,1.27,1.18.89a2.81,2.81,0,0,0,1.18-2.25c0-.86-.53-1.26-1.18-.89m0,2.59c-.42.25-.77,0-.77-.57a1.82,1.82,0,0,1,.77-1.46c.42-.25.76,0,.76.57a1.82,1.82,0,0,1-.76,1.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26,119.78a.65.65,0,0,1-.28.52c-.15.09-.27,0-.27-.2a.66.66,0,0,1,.27-.53c.15-.09.28,0,.28.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.72,112.48c0,2.81-1.71,6.06-3.81,7.28s-3.81-.08-3.81-2.88,1.71-6.06,3.81-7.28S393.72,109.68,393.72,112.48Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.29,116.89a2.12,2.12,0,0,0,.33-.39,2,2,0,0,0,.2-.42,2,2,0,0,0,.13-.7.92.92,0,0,0-.11-.51.36.36,0,0,0-.34-.15,1.61,1.61,0,0,0,.23-.35,1.51,1.51,0,0,0,.13-.65.85.85,0,0,0-.13-.52c-.15-.18-.4-.17-.76,0l-1.42.82v3.9l1.32-.76A2.42,2.42,0,0,0,389.29,116.89Zm-1.15-2.51.63-.37a1,1,0,0,1,.35-.13c.11,0,.16.08.16.26a.7.7,0,0,1-.12.42.91.91,0,0,1-.31.27l-.71.41Zm0,2.55v-1l.72-.42a.62.62,0,0,1,.29-.1c.12,0,.19.11.19.31a.92.92,0,0,1-.2.6.89.89,0,0,1-.29.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.45,116a.76.76,0,0,0,.76-.08A2.09,2.09,0,0,0,392,115a2.06,2.06,0,0,0,.21-.64l-.58.33a.89.89,0,0,1-.12.26.87.87,0,0,1-.31.32.43.43,0,0,1-.31.07c-.15,0-.22-.19-.23-.48l1.58-.91c0-.25,0-.44,0-.56a1.22,1.22,0,0,0-.17-.5.48.48,0,0,0-.38-.21,1,1,0,0,0-.51.16,2.07,2.07,0,0,0-.77.85,2.79,2.79,0,0,0-.3,1.32Q390.12,115.85,390.45,116Zm.4-2.15a1,1,0,0,1,.34-.36.36.36,0,0,1,.34,0,.44.44,0,0,1,.15.37l-1,.57A1.54,1.54,0,0,1,390.85,113.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.79 111.82 390.52 112.55 390.52 112.95 391.79 112.21 391.79 111.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.26,135.26c0,2.81-1.7,6.06-3.81,7.28s-3.8-.08-3.8-2.88,1.7-6.06,3.8-7.28S354.26,132.46,354.26,135.26Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.82,141.2l1-.59v-3.4l.71-.41.08-1.18-.79.45v-.64c0-.27.05-.4.24-.51l.55-.32v-1.18l-.7.41a2,2,0,0,0-1.1,1.93v.9l-.53.31v1.15l.53-.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,173.34l25.79-14.89c.86-.49,1.55-.14,1.55.79a3.31,3.31,0,0,1-1.55,2.58l-25.79,14.89c-.86.5-1.55.15-1.55-.79A3.33,3.33,0,0,1,365.13,173.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,173.34l17-9.83c.86-.5,1.56-.14,1.56.79a3.32,3.32,0,0,1-1.56,2.58l-17,9.83c-.86.5-1.55.15-1.55-.79A3.33,3.33,0,0,1,365.13,173.34Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,165.91,390.92,151c.86-.5,1.55-.15,1.55.79a3.33,3.33,0,0,1-1.55,2.58l-25.79,14.89c-.86.49-1.55.14-1.55-.79A3.31,3.31,0,0,1,365.13,165.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,165.91,375.41,160c.86-.5,1.56-.15,1.56.79a3.34,3.34,0,0,1-1.56,2.58l-10.28,5.94c-.86.49-1.55.14-1.55-.79A3.31,3.31,0,0,1,365.13,165.91Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,180.77l25.79-14.89c.86-.49,1.55-.14,1.55.79a3.35,3.35,0,0,1-1.55,2.59l-25.79,14.88c-.86.5-1.55.15-1.55-.78A3.33,3.33,0,0,1,365.13,180.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,180.77,388,167.57c.86-.5,1.56-.14,1.55.79a3.33,3.33,0,0,1-1.55,2.58l-22.87,13.2c-.86.5-1.55.15-1.55-.78A3.33,3.33,0,0,1,365.13,180.77Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,188.2l25.79-14.89c.86-.49,1.55-.14,1.55.79a3.35,3.35,0,0,1-1.55,2.59l-25.79,14.88c-.86.5-1.55.15-1.55-.78A3.33,3.33,0,0,1,365.13,188.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,188.2l17-9.83c.86-.5,1.56-.14,1.56.79a3.32,3.32,0,0,1-1.56,2.58l-17,9.83c-.86.5-1.55.15-1.55-.78A3.33,3.33,0,0,1,365.13,188.2Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,195.63l25.79-14.89c.86-.49,1.55-.14,1.55.79a3.35,3.35,0,0,1-1.55,2.59L365.13,199c-.86.5-1.55.15-1.55-.78A3.35,3.35,0,0,1,365.13,195.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,195.63,388,182.43c.86-.5,1.56-.14,1.55.79A3.31,3.31,0,0,1,388,185.8L365.13,199c-.86.5-1.55.15-1.55-.78A3.35,3.35,0,0,1,365.13,195.63Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,176.32a.4.4,0,0,1-.34-.2.39.39,0,0,1,.14-.54l8.05-4.64a.39.39,0,0,1,.54.14.4.4,0,0,1-.14.54l-8,4.64A.36.36,0,0,1,350.65,176.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,183.76a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l8.05-4.64a.4.4,0,0,1,.4.69l-8,4.64A.35.35,0,0,1,350.65,183.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,191.21a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l8.05-4.64a.4.4,0,0,1,.54.15.4.4,0,0,1-.14.54l-8,4.64A.46.46,0,0,1,350.65,191.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,198.66a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l8.05-4.64a.4.4,0,0,1,.54.15.4.4,0,0,1-.14.54l-8,4.64A.46.46,0,0,1,350.65,198.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,206.11a.4.4,0,0,1-.34-.2.39.39,0,0,1,.14-.54l8.05-4.64a.39.39,0,0,1,.54.14.4.4,0,0,1-.14.54l-8,4.64A.36.36,0,0,1,350.65,206.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.39,170.75c0-4.13,2.51-8.93,5.61-10.72s5.61.11,5.61,4.24S344.1,173.21,341,175,335.39,174.89,335.39,170.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.77,175.87a3,3,0,0,1-1.54-.41c-1.3-.74-2-2.46-2-4.71,0-4.19,2.56-9.08,5.71-10.9a3.8,3.8,0,0,1,3.87-.29c1.3.75,2,2.46,2,4.71,0,4.19-2.56,9.08-5.71,10.9A4.78,4.78,0,0,1,338.77,175.87Zm4.46-16.32a4.32,4.32,0,0,0-2.13.65c-3,1.75-5.52,6.49-5.52,10.55,0,2.1.67,3.7,1.85,4.37a3.42,3.42,0,0,0,3.47-.29c3-1.76,5.52-6.5,5.52-10.56,0-2.1-.68-3.69-1.85-4.37A2.65,2.65,0,0,0,343.23,159.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.65,170h0s-.06,0-.07-.09c0-.7-.27-.89-.8-.61-.06,0-.1,0-.1-.08a.9.9,0,0,0-.2-.7c-.12-.09-.33-.06-.6.09h0a.09.09,0,0,1-.07,0,.11.11,0,0,1,0-.08c0-.37-.06-.6-.19-.7s-.33-.07-.6.09h0a.06.06,0,0,1-.1,0,.31.31,0,0,1,0-.16l3.53-6.74c0-.08.11-.12.15-.09l2.72,2.06s0,.12,0,.19L341.72,170Zm-.81-1c.5-.23.8-.05.89.52l3.3-6.31-2.57-1.94-3.3,6.29a.52.52,0,0,1,.52,0,.91.91,0,0,1,.25.73c.29-.15.51-.16.66,0A.92.92,0,0,1,340.84,169Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,173.56a.06.06,0,0,1-.08,0,.12.12,0,0,1,0-.11l1-5.58a.19.19,0,0,1,.12-.17c.06,0,.09,0,.08.12l-1,5.32,3.57-3.36c.06-.05.11,0,.13,0a.26.26,0,0,1-.08.21l-3.74,3.52Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.9 173.43 338.92 172.32 338.3 171.84 337.9 173.43",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.3,168.28h-.07s0-.12,0-.2l3-5.66c0-.08.1-.12.14-.09s0,.12,0,.2l-3,5.66A.24.24,0,0,1,341.3,168.28Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.4,167.59a.06.06,0,0,1-.08,0s0-.11,0-.19l3-5.67c0-.07.11-.11.15-.08s0,.12,0,.19l-3,5.67A.19.19,0,0,1,340.4,167.59Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.39,227.71c0-4.14,2.51-8.94,5.61-10.73s5.61.11,5.61,4.25S344.1,230.16,341,232,335.39,231.84,335.39,227.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.77,232.82a3,3,0,0,1-1.54-.4c-1.3-.75-2-2.47-2-4.71,0-4.19,2.56-9.08,5.71-10.9a3.83,3.83,0,0,1,3.87-.3c1.3.75,2,2.47,2,4.72,0,4.19-2.56,9.07-5.71,10.89A4.68,4.68,0,0,1,338.77,232.82Zm4.46-16.31a4.3,4.3,0,0,0-2.13.64c-3,1.76-5.52,6.49-5.52,10.56,0,2.1.67,3.69,1.85,4.37a3.43,3.43,0,0,0,3.47-.3c3-1.76,5.52-6.49,5.52-10.55,0-2.11-.68-3.7-1.85-4.37A2.56,2.56,0,0,0,343.23,216.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.23,228.39s-.05,0-.07,0,0,0,0-.08a2,2,0,0,0-.64-1.61,2.23,2.23,0,0,1-.61-1.92,5.31,5.31,0,0,1,1.89-3.65h0a1.48,1.48,0,0,1,1.66-.25,1.91,1.91,0,0,1,.71,1.71,5.17,5.17,0,0,1-.63,2.38,5.17,5.17,0,0,0-.62,2.32.23.23,0,0,1-.1.2Zm.1-.2Zm.46-6.8a4.76,4.76,0,0,0-1.7,3.3,2,2,0,0,0,.55,1.73,2.13,2.13,0,0,1,.69,1.64l1.36-.79a5.71,5.71,0,0,1,.68-2.41,4.71,4.71,0,0,0,.57-2.15,1.79,1.79,0,0,0-.64-1.55,1.35,1.35,0,0,0-1.51.23Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.79,229.63l-1.56.9c-.06,0-.1,0-.1-.08v-1.24a.26.26,0,0,1,.1-.2l1.56-.9c.06,0,.1,0,.1.08v1.24A.23.23,0,0,1,341.79,229.63Zm-1.46.56,1.36-.78v-1l-1.36.78Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.25,227.8c-.06,0-.11,0-.11-.07a10.45,10.45,0,0,1,.37-2.83l-1,.58a6.25,6.25,0,0,1,.37,2.4.26.26,0,0,1-.11.2s-.1,0-.1-.08a5.41,5.41,0,0,0-.41-2.44.17.17,0,0,1,0-.14.21.21,0,0,1,.08-.12l1.33-.77s.08,0,.09,0a.17.17,0,0,1,0,.14,9.83,9.83,0,0,0-.41,2.92A.26.26,0,0,1,341.25,227.8Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,220.1c-.06,0-.1,0-.1-.08V218.8a.23.23,0,0,1,.1-.2c.06,0,.1,0,.1.08v1.22A.23.23,0,0,1,341,220.1Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.58,221.43s-.07,0-.09,0l-.46-.79a.21.21,0,0,1,0-.21c.05-.07.11-.08.14,0l.46.79a.21.21,0,0,1,0,.21S339.6,221.42,339.58,221.43Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53,223.43h0l-.8-.15c-.05,0-.07-.09,0-.17s.1-.14.14-.13l.8.15c.05,0,.06.08,0,.17A.29.29,0,0,1,338.53,223.43Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.14,225.56l-.92.53c-.06,0-.1,0-.1-.08a.25.25,0,0,1,.1-.2l.92-.53c.06,0,.1,0,.1.08A.25.25,0,0,1,338.14,225.56Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.72,228.32a.06.06,0,0,1-.09,0,.21.21,0,0,1,0-.21l.79-1.07c.05-.06.12-.08.14,0a.21.21,0,0,1,0,.21l-.8,1.07Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.27,224.57h0l-.8-.16c-.05,0-.06-.08,0-.16s.1-.14.14-.13l.8.15c.05,0,.06.08,0,.16A.33.33,0,0,1,344.27,224.57Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.78,221.75l-.92.53c-.06,0-.1,0-.1-.08a.23.23,0,0,1,.1-.19l.92-.53c.06,0,.1,0,.1.08A.23.23,0,0,1,344.78,221.75Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.48,220.59a.06.06,0,0,1-.09,0,.24.24,0,0,1,0-.21l.8-1.07c0-.06.11-.08.14,0a.21.21,0,0,1,0,.21l-.8,1.07A.12.12,0,0,1,343.48,220.59Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44,219.79s0,0-.05,0-.07-.08,0-.16l.46-1.33c0-.08.09-.14.14-.13s.07.08,0,.17l-.46,1.32A.19.19,0,0,1,342.44,219.79Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 341,
    cy: 251.13,
    rx: 8.62,
    ry: 4.88,
    transform: "translate(-23.6 466.57) rotate(-66.95)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.77,259.49a3,3,0,0,1-1.54-.41c-1.3-.75-2-2.46-2-4.71,0-4.19,2.56-9.08,5.71-10.9a3.8,3.8,0,0,1,3.87-.29c1.3.75,2,2.46,2,4.71,0,4.19-2.56,9.08-5.71,10.9A4.78,4.78,0,0,1,338.77,259.49Zm4.46-16.32a4.32,4.32,0,0,0-2.13.65c-3,1.75-5.52,6.49-5.52,10.55,0,2.1.67,3.69,1.85,4.37a3.41,3.41,0,0,0,3.47-.3c3-1.75,5.52-6.49,5.52-10.55,0-2.1-.68-3.69-1.85-4.37A2.65,2.65,0,0,0,343.23,243.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.73,255.71l-1.46.84c-.06,0-.1,0-.1-.08v-1a1.68,1.68,0,0,1-.63,0l-.53,1c0,.08-.11.12-.15.09l-1-.78s0-.12,0-.2l.53-1a3,3,0,0,1-.26-.69l-.75.43c-.05,0-.1,0-.1-.08v-2a.26.26,0,0,1,.1-.19l.75-.43a7.23,7.23,0,0,1,.26-1l-.53-.4s0-.12,0-.2l1-2c0-.07.11-.11.15-.08l.53.4a5.6,5.6,0,0,1,.63-.72v-1a.23.23,0,0,1,.1-.19l1.46-.85c.06,0,.1,0,.1.08v1a1.67,1.67,0,0,1,.63,0l.53-1c0-.07.1-.11.14-.08l1,.78a.12.12,0,0,1,0,.08.45.45,0,0,1,0,.11l-.53,1a2.68,2.68,0,0,1,.26.69l.74-.43c.06,0,.11,0,.11.08v1.94a.26.26,0,0,1-.11.2l-.74.43a7.23,7.23,0,0,1-.26,1l.53.4a.12.12,0,0,1,0,.08.61.61,0,0,1,0,.11l-1,2c0,.08-.1.12-.14.09l-.53-.4a6.24,6.24,0,0,1-.63.71v1A.23.23,0,0,1,341.73,255.71Zm-1.36.51,1.26-.73v-1a.27.27,0,0,1,.07-.18,5.9,5.9,0,0,0,.73-.82c0-.06.09-.08.12,0l.51.38.89-1.69-.51-.38a.17.17,0,0,1,0-.16,6,6,0,0,0,.3-1.14.28.28,0,0,1,.1-.16l.72-.42v-1.67l-.72.42s-.08,0-.1,0a2.32,2.32,0,0,0-.3-.79.24.24,0,0,1,0-.18l.51-1-.89-.67-.51,1c0,.07-.08.11-.12.1a1.64,1.64,0,0,0-.73,0s-.07,0-.07-.08v-1l-1.26.72v1a.31.31,0,0,1-.07.18,4.9,4.9,0,0,0-.73.82c0,.05-.09.07-.12.05l-.51-.39-.89,1.7.51.38s0,.09,0,.16a6,6,0,0,0-.3,1.14.32.32,0,0,1-.1.16l-.72.41V254l.72-.41s.08,0,.1,0a2.46,2.46,0,0,0,.3.8.21.21,0,0,1,0,.17l-.51,1,.89.67.51-1c0-.06.08-.1.12-.09a1.65,1.65,0,0,0,.73,0s.07,0,.07.09Zm.63-2.72c-1,.57-1.78,0-1.78-1.34a4.27,4.27,0,0,1,1.78-3.4c1-.56,1.78,0,1.78,1.35A4.25,4.25,0,0,1,341,253.5Zm0-4.46a3.75,3.75,0,0,0-1.57,3c0,1.15.7,1.69,1.57,1.19a3.76,3.76,0,0,0,1.57-3C342.57,249.07,341.87,248.54,341,249Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 341,
    cy: 277.79,
    rx: 8.62,
    ry: 4.88,
    transform: "translate(-48.13 482.79) rotate(-66.95)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.77,286.15a3,3,0,0,1-1.54-.4c-1.3-.75-2-2.47-2-4.72,0-4.19,2.56-9.07,5.71-10.89a3.8,3.8,0,0,1,3.87-.3c1.3.75,2,2.47,2,4.71,0,4.19-2.56,9.08-5.71,10.9A4.68,4.68,0,0,1,338.77,286.15Zm4.46-16.31a4.3,4.3,0,0,0-2.13.64c-3,1.76-5.52,6.49-5.52,10.55,0,2.11.67,3.7,1.85,4.37a3.42,3.42,0,0,0,3.47-.29c3-1.76,5.52-6.49,5.52-10.56,0-2.1-.68-3.69-1.85-4.37A2.64,2.64,0,0,0,343.23,269.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,284.19s-.05,0-.07,0a.12.12,0,0,1,0-.12l.57-2.56a3.84,3.84,0,0,1-.45-2,8,8,0,0,1,3.3-6.31c1.82-1.05,3.3.07,3.3,2.5a7.92,7.92,0,0,1-3.3,6.31,2.56,2.56,0,0,1-1.56.38l-1.73,1.74Zm3.32-10.67a7.41,7.41,0,0,0-3.1,5.91,3.63,3.63,0,0,0,.45,1.88.19.19,0,0,1,0,.11l-.52,2.33,1.58-1.59s.06,0,.08,0a2.3,2.3,0,0,0,1.5-.36,7.4,7.4,0,0,0,3.1-5.91C344.16,273.58,342.77,272.53,341.06,273.52Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.07,277.17a1.08,1.08,0,0,1,.46-.86c.25-.15.45,0,.45.34a1.11,1.11,0,0,1-.45.87C342.28,277.66,342.07,277.51,342.07,277.17Z",
    style: {
      fill: "#46C5FB",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,278.06a1.08,1.08,0,0,1,.45-.87c.25-.15.45,0,.45.34a1.09,1.09,0,0,1-.45.87C340.75,278.54,340.55,278.39,340.55,278.06Z",
    style: {
      fill: "#46C5FB",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,278.94a1.08,1.08,0,0,1,.45-.87c.25-.14.46,0,.46.34a1.08,1.08,0,0,1-.46.87C339.22,279.42,339,279.27,339,278.94Z",
    style: {
      fill: "#46C5FB",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.51,155.19l24-13.87c.47-.27.86-.07.86.44a1.84,1.84,0,0,1-.86,1.42l-24,13.87c-.48.28-.86.08-.86-.43A1.85,1.85,0,0,1,351.51,155.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,163.52a.4.4,0,0,1-.34-.2.39.39,0,0,1,.14-.54l41.83-24.15a.39.39,0,1,1,.39.68l-41.82,24.15A.36.36,0,0,1,350.65,163.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,167.23a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l32.17-18.57a.39.39,0,0,1,.4.68l-32.17,18.58A.46.46,0,0,1,350.65,167.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.51,214.64l24-13.87c.47-.28.86-.08.86.43a1.84,1.84,0,0,1-.86,1.42l-24,13.87c-.48.28-.86.08-.86-.43A1.82,1.82,0,0,1,351.51,214.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,223a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l41.83-24.15a.4.4,0,0,1,.54.14.41.41,0,0,1-.15.55L350.85,222.9A.36.36,0,0,1,350.65,223Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,226.67a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l41.83-24.14a.39.39,0,1,1,.39.68l-41.82,24.15A.46.46,0,0,1,350.65,226.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,230.38a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l41.83-24.14a.39.39,0,1,1,.39.68l-41.82,24.15A.46.46,0,0,1,350.65,230.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,234.09a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l32.17-18.56a.39.39,0,1,1,.39.68L350.85,234A.46.46,0,0,1,350.65,234.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.51,240.65l24-13.87c.47-.28.86-.08.86.43a1.88,1.88,0,0,1-.86,1.43l-24,13.87c-.48.27-.86.07-.86-.44A1.82,1.82,0,0,1,351.51,240.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,249a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l41.83-24.15a.4.4,0,1,1,.39.69l-41.82,24.15A.46.46,0,0,1,350.65,249Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,252.68a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l41.83-24.14a.4.4,0,1,1,.39.69l-41.82,24.14A.35.35,0,0,1,350.65,252.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,256.39a.39.39,0,0,1-.2-.73l41.83-24.15a.4.4,0,1,1,.39.69l-41.82,24.14A.35.35,0,0,1,350.65,256.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,260.1a.39.39,0,0,1-.2-.73l32.17-18.57a.39.39,0,1,1,.39.68l-32.16,18.57A.35.35,0,0,1,350.65,260.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.51,266.65l24-13.87c.47-.27.86-.08.86.44a1.84,1.84,0,0,1-.86,1.42l-24,13.87c-.48.27-.86.08-.86-.43A1.83,1.83,0,0,1,351.51,266.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,275a.39.39,0,0,1-.34-.19.4.4,0,0,1,.14-.55l41.83-24.14a.39.39,0,1,1,.39.68l-41.82,24.15A.35.35,0,0,1,350.65,275Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,278.69a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l41.83-24.14a.38.38,0,0,1,.54.14.4.4,0,0,1-.15.54l-41.82,24.14A.36.36,0,0,1,350.65,278.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,282.4a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.54l22.52-13a.39.39,0,1,1,.4.68l-22.52,13A.46.46,0,0,1,350.65,282.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.38,192.35l24-13.87c.48-.27.86-.08.86.44a1.82,1.82,0,0,1-.86,1.42l-24,13.87c-.47.27-.86.08-.86-.43A1.88,1.88,0,0,1,290.38,192.35Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,205.37a.09.09,0,0,1-.1-.1v-5.68a.1.1,0,0,1,.1-.1.11.11,0,0,1,.1.1v5.68A.1.1,0,0,1,296,205.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,218.84a.1.1,0,0,1-.1-.1v-5.69a.09.09,0,0,1,.1-.09.1.1,0,0,1,.1.09v5.69A.11.11,0,0,1,296,218.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,293.21a.1.1,0,0,1-.1-.1v-5.68a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v5.68A.11.11,0,0,1,296,293.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,272.2a.09.09,0,0,1-.1-.1v-5.68a.1.1,0,0,1,.1-.1.11.11,0,0,1,.1.1v5.68A.1.1,0,0,1,296,272.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,285.67a.1.1,0,0,1-.1-.1v-5.68a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v5.68A.11.11,0,0,1,296,285.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,305.79a.09.09,0,0,1-.1-.1V300a.1.1,0,0,1,.1-.1.11.11,0,0,1,.1.1v5.68A.1.1,0,0,1,296,305.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,235.35a.1.1,0,0,1-.1-.1v-5.68a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v5.68A.11.11,0,0,1,296,235.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,250.2a.1.1,0,0,1-.1-.1v-5.68a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v5.68A.11.11,0,0,1,296,250.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,257.76a.09.09,0,0,1-.1-.1V252a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v5.68A.1.1,0,0,1,296,257.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,227.81a.09.09,0,0,1-.1-.1v-7.12a.09.09,0,0,1,.1-.09.1.1,0,0,1,.1.09v7.12A.1.1,0,0,1,296,227.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,211.3a.1.1,0,0,1-.1-.1v-4.07a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v4.07A.11.11,0,0,1,296,211.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,242.66a.1.1,0,0,1-.1-.1v-5.45a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v5.45A.11.11,0,0,1,296,242.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,264.66a.09.09,0,0,1-.1-.1v-5a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v5A.1.1,0,0,1,296,264.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,278.13a.1.1,0,0,1-.1-.1V274a.1.1,0,0,1,.1-.1.11.11,0,0,1,.1.1V278A.11.11,0,0,1,296,278.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,298.25a.09.09,0,0,1-.1-.1V295a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v3.18A.1.1,0,0,1,296,298.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,199.8a.48.48,0,0,1-.26-.07.66.66,0,0,1-.29-.6,1.85,1.85,0,0,1,.86-1.48.64.64,0,0,1,.67-.06.67.67,0,0,1,.28.61,1.87,1.87,0,0,1-.85,1.48A.83.83,0,0,1,295.6,199.8Zm.72-2.08a.57.57,0,0,0-.31.1,1.66,1.66,0,0,0-.76,1.31.39.39,0,0,0,.66.37,1.64,1.64,0,0,0,.75-1.3.48.48,0,0,0-.18-.44A.29.29,0,0,0,296.32,197.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,213.26a.58.58,0,0,1-.26-.06.67.67,0,0,1-.29-.61,1.88,1.88,0,0,1,.86-1.48.59.59,0,0,1,.95.55,1.87,1.87,0,0,1-.85,1.48A.83.83,0,0,1,295.6,213.26Zm.72-2.07a.64.64,0,0,0-.31.09,1.67,1.67,0,0,0-.76,1.31.49.49,0,0,0,.19.44.52.52,0,0,0,.47-.06,1.66,1.66,0,0,0,.75-1.31.46.46,0,0,0-.18-.43A.29.29,0,0,0,296.32,211.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,266.63a.48.48,0,0,1-.26-.07.66.66,0,0,1-.29-.6,1.89,1.89,0,0,1,.86-1.48.68.68,0,0,1,.67-.06.67.67,0,0,1,.28.61,1.89,1.89,0,0,1-.85,1.48A.83.83,0,0,1,295.6,266.63Zm.72-2.08a.66.66,0,0,0-.31.1,1.67,1.67,0,0,0-.76,1.31.47.47,0,0,0,.19.43.48.48,0,0,0,.47-.05,1.66,1.66,0,0,0,.75-1.31.48.48,0,0,0-.18-.44A.42.42,0,0,0,296.32,264.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,280.1a.59.59,0,0,1-.26-.07.67.67,0,0,1-.29-.61,1.9,1.9,0,0,1,.86-1.48.59.59,0,0,1,.95.55A1.88,1.88,0,0,1,296,280,.85.85,0,0,1,295.6,280.1Zm.72-2.08a.64.64,0,0,0-.31.09,1.67,1.67,0,0,0-.76,1.31.4.4,0,0,0,.66.38,1.66,1.66,0,0,0,.75-1.31.46.46,0,0,0-.18-.43A.29.29,0,0,0,296.32,278Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,300.22a.48.48,0,0,1-.26-.07.66.66,0,0,1-.29-.6,1.85,1.85,0,0,1,.86-1.48.68.68,0,0,1,.67-.06.67.67,0,0,1,.28.61,1.87,1.87,0,0,1-.85,1.48A.83.83,0,0,1,295.6,300.22Zm.72-2.08a.66.66,0,0,0-.31.1,1.67,1.67,0,0,0-.76,1.31.47.47,0,0,0,.19.43.48.48,0,0,0,.47-.05,1.68,1.68,0,0,0,.75-1.31.48.48,0,0,0-.18-.44A.42.42,0,0,0,296.32,298.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,229.78a.59.59,0,0,1-.26-.07.67.67,0,0,1-.29-.61,1.92,1.92,0,0,1,.86-1.48.59.59,0,0,1,.95.55,1.88,1.88,0,0,1-.85,1.48A.85.85,0,0,1,295.6,229.78Zm.72-2.08a.57.57,0,0,0-.31.1,1.65,1.65,0,0,0-.76,1.3.49.49,0,0,0,.19.44.46.46,0,0,0,.47-.06,1.65,1.65,0,0,0,.75-1.31.46.46,0,0,0-.18-.43A.29.29,0,0,0,296.32,227.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,244.62a.58.58,0,0,1-.26-.06.67.67,0,0,1-.29-.61,1.88,1.88,0,0,1,.86-1.48.59.59,0,0,1,.95.55,1.84,1.84,0,0,1-.85,1.48A.83.83,0,0,1,295.6,244.62Zm.72-2.07a.64.64,0,0,0-.31.09,1.67,1.67,0,0,0-.76,1.31.49.49,0,0,0,.19.44.46.46,0,0,0,.47-.06,1.66,1.66,0,0,0,.75-1.31.46.46,0,0,0-.18-.43A.29.29,0,0,0,296.32,242.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,207.34a.48.48,0,0,1-.26-.07.66.66,0,0,1-.29-.61,1.89,1.89,0,0,1,.86-1.47.64.64,0,0,1,.67-.06.67.67,0,0,1,.28.61,1.91,1.91,0,0,1-.85,1.48A.83.83,0,0,1,295.6,207.34Zm.72-2.08a.57.57,0,0,0-.31.1,1.65,1.65,0,0,0-.76,1.3.48.48,0,0,0,.19.44.46.46,0,0,0,.47-.06,1.64,1.64,0,0,0,.75-1.3.47.47,0,0,0-.18-.44A.29.29,0,0,0,296.32,205.26Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,220.8a.58.58,0,0,1-.26-.06.69.69,0,0,1-.29-.61,1.88,1.88,0,0,1,.86-1.48.58.58,0,0,1,.95.55,1.87,1.87,0,0,1-.85,1.48A.83.83,0,0,1,295.6,220.8Zm.72-2.07a.64.64,0,0,0-.31.09,1.67,1.67,0,0,0-.76,1.31.4.4,0,0,0,.66.38,1.66,1.66,0,0,0,.75-1.31.46.46,0,0,0-.18-.43A.29.29,0,0,0,296.32,218.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,295.18a.59.59,0,0,1-.26-.07.67.67,0,0,1-.29-.61,1.88,1.88,0,0,1,.86-1.48.59.59,0,0,1,.95.55,1.84,1.84,0,0,1-.85,1.48A.85.85,0,0,1,295.6,295.18Zm.72-2.08a.64.64,0,0,0-.31.09,1.69,1.69,0,0,0-.76,1.31.49.49,0,0,0,.19.44.46.46,0,0,0,.47-.06,1.66,1.66,0,0,0,.75-1.31.46.46,0,0,0-.18-.43A.29.29,0,0,0,296.32,293.1Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,274.17a.48.48,0,0,1-.26-.07.66.66,0,0,1-.29-.6,1.85,1.85,0,0,1,.86-1.48.68.68,0,0,1,.67-.06.67.67,0,0,1,.28.61,1.87,1.87,0,0,1-.85,1.48A.83.83,0,0,1,295.6,274.17Zm.72-2.08a.57.57,0,0,0-.31.1,1.67,1.67,0,0,0-.76,1.31.47.47,0,0,0,.19.43.48.48,0,0,0,.47-.05,1.68,1.68,0,0,0,.75-1.31.48.48,0,0,0-.18-.44A.42.42,0,0,0,296.32,272.09Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,287.63a.58.58,0,0,1-.26-.06.67.67,0,0,1-.29-.61,1.88,1.88,0,0,1,.86-1.48.59.59,0,0,1,.95.55,1.87,1.87,0,0,1-.85,1.48A.83.83,0,0,1,295.6,287.63Zm.72-2.07a.64.64,0,0,0-.31.09,1.67,1.67,0,0,0-.76,1.31.49.49,0,0,0,.19.44.52.52,0,0,0,.47-.06,1.66,1.66,0,0,0,.75-1.31.46.46,0,0,0-.18-.43A.29.29,0,0,0,296.32,285.56Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,307.76a.48.48,0,0,1-.26-.07.66.66,0,0,1-.29-.6,1.89,1.89,0,0,1,.86-1.48.66.66,0,0,1,.67-.06.67.67,0,0,1,.28.61,1.91,1.91,0,0,1-.85,1.48A.83.83,0,0,1,295.6,307.76Zm.72-2.08a.57.57,0,0,0-.31.1,1.66,1.66,0,0,0-.76,1.31.39.39,0,0,0,.66.37,1.64,1.64,0,0,0,.75-1.3.48.48,0,0,0-.18-.44A.42.42,0,0,0,296.32,305.68Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,237.32a.59.59,0,0,1-.26-.07.67.67,0,0,1-.29-.61,1.88,1.88,0,0,1,.86-1.48.59.59,0,0,1,.95.55,1.84,1.84,0,0,1-.85,1.48A.85.85,0,0,1,295.6,237.32Zm.72-2.08a.57.57,0,0,0-.31.1,1.65,1.65,0,0,0-.76,1.3.49.49,0,0,0,.19.44.46.46,0,0,0,.47-.06,1.66,1.66,0,0,0,.75-1.31.46.46,0,0,0-.18-.43A.29.29,0,0,0,296.32,235.24Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,252.16a.58.58,0,0,1-.26-.06.67.67,0,0,1-.29-.61,1.9,1.9,0,0,1,.86-1.48.59.59,0,0,1,.95.55A1.88,1.88,0,0,1,296,252,.83.83,0,0,1,295.6,252.16Zm.72-2.07a.64.64,0,0,0-.31.09,1.67,1.67,0,0,0-.76,1.31.49.49,0,0,0,.19.44.52.52,0,0,0,.47-.06,1.66,1.66,0,0,0,.75-1.31.46.46,0,0,0-.18-.43A.29.29,0,0,0,296.32,250.09Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,259.73a.48.48,0,0,1-.26-.07.66.66,0,0,1-.29-.61,1.84,1.84,0,0,1,.86-1.47.64.64,0,0,1,.67-.06.67.67,0,0,1,.28.61,1.87,1.87,0,0,1-.85,1.48A.83.83,0,0,1,295.6,259.73Zm.72-2.08a.57.57,0,0,0-.31.1,1.65,1.65,0,0,0-.76,1.3.48.48,0,0,0,.19.44.46.46,0,0,0,.47-.06,1.64,1.64,0,0,0,.75-1.3.48.48,0,0,0-.18-.44A.29.29,0,0,0,296.32,257.65Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.58,202.09a.68.68,0,0,1,0-.19.7.7,0,0,1,.06-.19.81.81,0,0,1,.1-.18.47.47,0,0,1,.15-.13.26.26,0,0,1,.15-.05.12.12,0,0,1,.1.05.23.23,0,0,1,.06.12.88.88,0,0,1,0,.17,1.35,1.35,0,0,1,0,.29,2.33,2.33,0,0,1-.13.31l-.36.77.51-.3s0,0,0,0v0a.07.07,0,0,1,0,.07l-.63.37s0,0,0,0v0a.09.09,0,0,1,0,0,.13.13,0,0,1,0-.07l.4-.85.07-.15c0-.05,0-.09,0-.12a.43.43,0,0,0,0-.11.34.34,0,0,0,0-.1.3.3,0,0,0-.06-.22s-.09,0-.17,0a.34.34,0,0,0-.16.19.7.7,0,0,0-.08.29.07.07,0,0,1,0,0l0,0h0S289.58,202.12,289.58,202.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.46,201.74a1.18,1.18,0,0,1,0-.26.94.94,0,0,1,.06-.24,1,1,0,0,1,.11-.21.69.69,0,0,1,.18-.16.24.24,0,0,1,.17,0,.12.12,0,0,1,.11.08.54.54,0,0,1,.07.17,1.66,1.66,0,0,1,0,.24v.39a2.45,2.45,0,0,1,0,.27,2.17,2.17,0,0,1-.07.24.53.53,0,0,1-.11.21.5.5,0,0,1-.17.15.23.23,0,0,1-.18,0,.17.17,0,0,1-.11-.08.38.38,0,0,1-.06-.17,1.66,1.66,0,0,1,0-.24Zm.64-.36A.72.72,0,0,0,291,201c0-.07-.11-.08-.2,0a.51.51,0,0,0-.21.26,1.67,1.67,0,0,0-.07.42v.37a.84.84,0,0,0,.07.35c.05.07.12.07.21,0a.45.45,0,0,0,.2-.26,1.06,1.06,0,0,0,.07-.42v-.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.79,202s0,.06,0,.07l0,0s0,0,0,0v-1.42l-.27.49s0,0-.05,0l0,0s0,0,0,0,0,0,0,0l.33-.58,0,0h0l0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.62,201a.34.34,0,0,0,0-.15.15.15,0,0,0-.06-.09.11.11,0,0,0-.08,0l-.11,0a.39.39,0,0,0-.1.08l-.06.08s0,.05,0,.08l0,.05h-.05a0,0,0,0,1,0,0l0-.81a.08.08,0,0,1,0-.07l.51-.29s0,0,0,0v0s0,.06,0,.07l-.45.26,0,.55.06-.08a.53.53,0,0,1,.14-.11.3.3,0,0,1,.14-.05.21.21,0,0,1,.12,0,.25.25,0,0,1,.08.12.69.69,0,0,1,0,.22,1.09,1.09,0,0,1,0,.26.83.83,0,0,1-.08.22.66.66,0,0,1-.12.17.53.53,0,0,1-.14.12.37.37,0,0,1-.15,0,.21.21,0,0,1-.11,0,.36.36,0,0,1-.07-.1.57.57,0,0,1,0-.15s0,0,0,0l0,0,0,0h0a0,0,0,0,1,0,0,.34.34,0,0,0,0,.12l.06.05h.08l.08,0,.11-.08.08-.13a.49.49,0,0,0,.06-.17A.58.58,0,0,0,292.62,201Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.57,215.23a1.41,1.41,0,0,1,0-.18.7.7,0,0,1,.06-.19.54.54,0,0,1,.11-.18.5.5,0,0,1,.15-.14.21.21,0,0,1,.15,0,.14.14,0,0,1,.1.05.33.33,0,0,1,0,.12.47.47,0,0,1,0,.17.86.86,0,0,1,0,.28,1.89,1.89,0,0,1-.13.31l-.36.78.52-.3s0,0,0,0v0a.08.08,0,0,1,0,.07l-.63.37s0,0,0,0v0s0,0,0-.06a.24.24,0,0,0,0-.07l.4-.84.07-.15a1.12,1.12,0,0,0,.05-.13s0-.07,0-.1v-.11a.36.36,0,0,0-.05-.21s-.1,0-.17,0a.35.35,0,0,0-.17.19.82.82,0,0,0-.07.29l0,.05,0,0,0,0S289.57,215.26,289.57,215.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.44,214.89a2.28,2.28,0,0,1,0-.26,1,1,0,0,1,.06-.25.82.82,0,0,1,.12-.2.44.44,0,0,1,.17-.16A.28.28,0,0,1,291,214a.21.21,0,0,1,.11.08.38.38,0,0,1,.06.17,1.94,1.94,0,0,1,0,.24v.4a2.11,2.11,0,0,1,0,.26,1,1,0,0,1-.06.25,2.12,2.12,0,0,1-.11.21.65.65,0,0,1-.18.15.26.26,0,0,1-.17.05.2.2,0,0,1-.12-.08,1.07,1.07,0,0,1-.06-.17,1.79,1.79,0,0,1,0-.24Zm.64-.36a.71.71,0,0,0-.06-.34q-.07-.1-.21,0a.48.48,0,0,0-.2.26,1.11,1.11,0,0,0-.07.43v.37a.63.63,0,0,0,.07.35c0,.06.11.07.2,0a.55.55,0,0,0,.21-.26,1.33,1.33,0,0,0,.06-.42,1.34,1.34,0,0,0,0-.19A1.28,1.28,0,0,0,291.08,214.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.78,215.1a.08.08,0,0,1,0,.07l0,0s0,0,0,0v-1.41l-.28.48s0,0,0,0v0s0,0,0,0,0,0,0,0l.33-.58,0,0,0,0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,214.49a.71.71,0,0,1,0-.14.59.59,0,0,1,0-.13l0-.11a.46.46,0,0,1,0-.09l.31-.84v0l0,0,0,0h0v.06h0l-.23.64s0,0,.05-.05l.05,0a.29.29,0,0,1,.16-.05.14.14,0,0,1,.12.06.26.26,0,0,1,.07.14.54.54,0,0,1,0,.19.89.89,0,0,1,0,.22.81.81,0,0,1-.07.22.82.82,0,0,1-.12.2.73.73,0,0,1-.16.14.27.27,0,0,1-.16,0,.14.14,0,0,1-.12-.06.4.4,0,0,1-.07-.13A.65.65,0,0,1,292,214.49Zm.65-.37a.72.72,0,0,0,0-.17.22.22,0,0,0-.07-.09.08.08,0,0,0-.08,0,.23.23,0,0,0-.11,0,.41.41,0,0,0-.1.09.3.3,0,0,0-.09.13.44.44,0,0,0-.06.16.64.64,0,0,0,0,.2.38.38,0,0,0,0,.16.14.14,0,0,0,.06.1.12.12,0,0,0,.09,0,.21.21,0,0,0,.1,0l.11-.08.08-.13a.87.87,0,0,0,.07-.17A1.23,1.23,0,0,0,292.64,214.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.71,231.66a.67.67,0,0,1,0-.18.76.76,0,0,1,.06-.2.59.59,0,0,1,.1-.17.5.5,0,0,1,.15-.14.24.24,0,0,1,.15,0,.15.15,0,0,1,.1,0,.23.23,0,0,1,.06.13.79.79,0,0,1,0,.17,1.35,1.35,0,0,1,0,.28,1.89,1.89,0,0,1-.13.31l-.36.77.52-.29s0,0,0,0v0a.1.1,0,0,1,0,.08l-.64.36s0,0,0,0v0a.11.11,0,0,1,0-.05.17.17,0,0,1,0-.07l.4-.84.07-.16a.56.56,0,0,0,0-.12.36.36,0,0,0,0-.1.41.41,0,0,0,0-.11.29.29,0,0,0-.06-.21s-.09,0-.17,0a.49.49,0,0,0-.16.19,1,1,0,0,0-.08.3s0,0,0,0l0,0,0,0S289.71,231.69,289.71,231.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.59,231.32a2.11,2.11,0,0,1,0-.26,1,1,0,0,1,.06-.25,2.12,2.12,0,0,1,.11-.21.65.65,0,0,1,.18-.15.26.26,0,0,1,.17,0,.2.2,0,0,1,.12.08,1.07,1.07,0,0,1,.06.17,1.79,1.79,0,0,1,0,.24v.4a2.11,2.11,0,0,1,0,.26l-.06.25a1.13,1.13,0,0,1-.12.21.5.5,0,0,1-.17.15.28.28,0,0,1-.18.05.21.21,0,0,1-.11-.08.42.42,0,0,1-.06-.18,1.64,1.64,0,0,1,0-.23Zm.64-.36a.59.59,0,0,0-.07-.34c0-.07-.11-.08-.2,0a.51.51,0,0,0-.21.26,1.67,1.67,0,0,0-.07.42v.38a.79.79,0,0,0,.07.34q.08.1.21,0a.48.48,0,0,0,.2-.26,1.11,1.11,0,0,0,.07-.43V231Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.92,231.53a.08.08,0,0,1,0,.07l0,0s0,0,0,0v-1.41l-.27.48s0,0-.05,0l0,0v0a.08.08,0,0,1,0,0l.33-.58s0,0,0,0l0,0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.72,229.45s0,0,0,0v0a.07.07,0,0,1,0,0v.05l-.39,1.65s0,0,0,0,0,0,0,0l0,0h0v0a0,0,0,0,1,0,0l.39-1.67-.52.3s0,0,0,0v0a.07.07,0,0,1,0-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.51,246.63a1.1,1.1,0,0,1,0-.18,1.18,1.18,0,0,1,.07-.2.81.81,0,0,1,.1-.18.47.47,0,0,1,.15-.13.26.26,0,0,1,.15-.05.12.12,0,0,1,.1.05.23.23,0,0,1,.06.12.88.88,0,0,1,0,.17,1,1,0,0,1-.05.29,2.13,2.13,0,0,1-.12.31l-.36.77.51-.3s0,0,0,0v0a.07.07,0,0,1,0,.07l-.63.37s0,0,0,0v0a.09.09,0,0,1,0-.05.13.13,0,0,1,0-.07l.4-.85a1.07,1.07,0,0,1,.07-.15.83.83,0,0,1,0-.12.43.43,0,0,0,0-.11.34.34,0,0,0,0-.1.3.3,0,0,0-.06-.22s-.1,0-.17,0a.4.4,0,0,0-.17.19.82.82,0,0,0-.07.29.43.43,0,0,1,0,.05l0,0,0,0S289.51,246.66,289.51,246.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.39,246.28a1.18,1.18,0,0,1,0-.26.94.94,0,0,1,.06-.24.7.7,0,0,1,.11-.21.69.69,0,0,1,.18-.16.24.24,0,0,1,.17,0,.14.14,0,0,1,.11.07.75.75,0,0,1,.07.18,1.66,1.66,0,0,1,0,.24v.4a2.6,2.6,0,0,1,0,.26,1.05,1.05,0,0,1-.06.24.53.53,0,0,1-.11.21.61.61,0,0,1-.17.15.23.23,0,0,1-.18,0,.15.15,0,0,1-.11-.08.38.38,0,0,1-.06-.17.9.9,0,0,1,0-.24A2.67,2.67,0,0,1,290.39,246.28Zm.64-.36a.72.72,0,0,0-.07-.34c0-.07-.11-.08-.2,0a.46.46,0,0,0-.21.26,1.67,1.67,0,0,0-.07.42v.37a.84.84,0,0,0,.07.35c.05.07.11.08.21,0a.45.45,0,0,0,.2-.26,1.32,1.32,0,0,0,.07-.42v-.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.72,246.49s0,.06,0,.07l0,0s0,0,0,0v-1.42l-.27.49s0,0-.05,0l0,0s0,0,0,0,0,0,0,0l.33-.58s0,0,0,0h0l0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.94,246a.64.64,0,0,1,.05-.28.9.9,0,0,1,.12-.24.17.17,0,0,1-.1-.09.47.47,0,0,1,0-.19,1.49,1.49,0,0,1,0-.21,1.42,1.42,0,0,1,.08-.18l.11-.15.13-.1a.39.39,0,0,1,.14,0,.14.14,0,0,1,.11,0,.22.22,0,0,1,.07.09.48.48,0,0,1,0,.18.67.67,0,0,1,0,.24.75.75,0,0,1-.1.2.14.14,0,0,1,.13.09.46.46,0,0,1,0,.23.91.91,0,0,1,0,.23.72.72,0,0,1-.09.2.61.61,0,0,1-.12.16.79.79,0,0,1-.15.12.3.3,0,0,1-.15.05.17.17,0,0,1-.12,0,.2.2,0,0,1-.08-.11A.5.5,0,0,1,291.94,246Zm.1,0a.27.27,0,0,0,0,.13.11.11,0,0,0,.06.07.15.15,0,0,0,.09,0l.11,0,.11-.09.1-.12.06-.15a.78.78,0,0,0,0-.16.51.51,0,0,0,0-.13.22.22,0,0,0-.06-.07.16.16,0,0,0-.1,0l-.11,0a.31.31,0,0,0-.11.09l-.09.12a.39.39,0,0,0-.06.15A.41.41,0,0,0,292,245.9Zm0-.81a.31.31,0,0,0,0,.11.2.2,0,0,0,.06.07h.08l.09,0a.39.39,0,0,0,.1-.08l.08-.1a.61.61,0,0,0,.05-.12.68.68,0,0,0,0-.14.36.36,0,0,0,0-.11.1.1,0,0,0-.05-.06.11.11,0,0,0-.08,0l-.1,0-.09.08a.39.39,0,0,0-.08.1.52.52,0,0,0-.06.13A.51.51,0,0,0,292.07,245.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.58,268.92a.57.57,0,0,1,0-.18.76.76,0,0,1,.06-.2.81.81,0,0,1,.1-.18.47.47,0,0,1,.15-.13.26.26,0,0,1,.15-.05.16.16,0,0,1,.1.05.23.23,0,0,1,.06.12.88.88,0,0,1,0,.17,1.35,1.35,0,0,1,0,.29,2.33,2.33,0,0,1-.13.31l-.36.77.51-.3s0,0,0,0v0s0,.06,0,.07l-.63.37s0,0,0,0v0a.11.11,0,0,1,0,0,.13.13,0,0,1,0-.07l.4-.85.07-.15a.56.56,0,0,0,0-.12.43.43,0,0,0,0-.11.31.31,0,0,0,0-.1.3.3,0,0,0-.06-.22s-.09,0-.17,0a.38.38,0,0,0-.16.19.7.7,0,0,0-.08.29.07.07,0,0,1,0,0l0,0h0S289.58,269,289.58,268.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.46,268.57a1.18,1.18,0,0,1,0-.26,1.05,1.05,0,0,1,.06-.24,1,1,0,0,1,.11-.21.65.65,0,0,1,.18-.15.22.22,0,0,1,.17,0,.13.13,0,0,1,.11.08.54.54,0,0,1,.07.17,1.66,1.66,0,0,1,0,.24v.4a2.46,2.46,0,0,1,0,.26,1.68,1.68,0,0,1-.07.24.53.53,0,0,1-.11.21.52.52,0,0,1-.17.16.26.26,0,0,1-.18,0,.15.15,0,0,1-.11-.07.48.48,0,0,1-.06-.18,1.66,1.66,0,0,1,0-.24Zm.64-.35a.74.74,0,0,0-.07-.35c0-.07-.11-.08-.2,0a.51.51,0,0,0-.21.26,1.67,1.67,0,0,0-.07.42v.38a.83.83,0,0,0,.07.34c.05.07.12.08.21,0a.46.46,0,0,0,.2-.25,1.14,1.14,0,0,0,.07-.43v-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.79,268.78s0,.06,0,.07l0,0s0,0,0,0v-1.42l-.27.49s0,0-.05,0l0,0s0,0,0,0a.06.06,0,0,1,0,0l.33-.58,0,0h0l0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.71,267.17v.13l0,.12,0,.11,0,.09-.31.87,0,0,0,0h-.06v-.07l.25-.66-.1.07a.29.29,0,0,1-.16.05.23.23,0,0,1-.12-.06.46.46,0,0,1-.07-.14,1,1,0,0,1,0-.18,1.49,1.49,0,0,1,0-.21,1.42,1.42,0,0,1,.07-.22.76.76,0,0,1,.12-.19.43.43,0,0,1,.16-.14.27.27,0,0,1,.16-.05.24.24,0,0,1,.11.06.31.31,0,0,1,.07.14A.58.58,0,0,1,292.71,267.17Zm-.63.36a.78.78,0,0,0,0,.16.15.15,0,0,0,.06.09.11.11,0,0,0,.08,0,.23.23,0,0,0,.11,0,.41.41,0,0,0,.1-.09l.09-.13.06-.16a1.1,1.1,0,0,0,0-.18.78.78,0,0,0,0-.16l-.06-.09a.16.16,0,0,0-.09,0,.19.19,0,0,0-.1,0,.44.44,0,0,0-.11.09.57.57,0,0,0-.08.13.44.44,0,0,0-.06.16A1.1,1.1,0,0,0,292.08,267.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.27,282.24a.55.55,0,0,1,0-.18.76.76,0,0,1,.06-.2,1.62,1.62,0,0,1,.1-.18.47.47,0,0,1,.15-.13.37.37,0,0,1,.15-.05.16.16,0,0,1,.1.05.23.23,0,0,1,.06.12.88.88,0,0,1,0,.17.92.92,0,0,1,0,.29,2.33,2.33,0,0,1-.13.31l-.36.77.52-.3s0,0,0,0v0a.1.1,0,0,1,0,.08l-.64.36s0,0,0,0v0a.11.11,0,0,1,0-.05.13.13,0,0,1,0-.07l.4-.85a1,1,0,0,0,.07-.15.56.56,0,0,0,0-.12l0-.11v-.1a.3.3,0,0,0-.06-.22s-.09,0-.17,0a.43.43,0,0,0-.16.19.89.89,0,0,0-.08.29.07.07,0,0,1,0,.05l0,0h0S289.27,282.27,289.27,282.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,281.9a2.45,2.45,0,0,1,0-.27,1.05,1.05,0,0,1,.06-.24,1,1,0,0,1,.11-.21.65.65,0,0,1,.18-.15.26.26,0,0,1,.17,0,.16.16,0,0,1,.12.08.38.38,0,0,1,.06.17,1.66,1.66,0,0,1,0,.24v.4a2.28,2.28,0,0,1,0,.26.84.84,0,0,1-.06.24.72.72,0,0,1-.12.21.44.44,0,0,1-.17.16.26.26,0,0,1-.18,0,.15.15,0,0,1-.11-.07.48.48,0,0,1-.06-.18,1.64,1.64,0,0,1,0-.23Zm.64-.36a.63.63,0,0,0-.07-.35c0-.07-.11-.07-.2,0a.45.45,0,0,0-.2.26,1.09,1.09,0,0,0-.07.42,1.81,1.81,0,0,0,0,.38.59.59,0,0,0,.07.34c0,.07.11.08.2,0a.43.43,0,0,0,.2-.25,1.11,1.11,0,0,0,.07-.43v-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.08,281.19a1.41,1.41,0,0,1,0-.18,1.52,1.52,0,0,1,.06-.2.62.62,0,0,1,.11-.17.5.5,0,0,1,.15-.14.37.37,0,0,1,.15-.05.31.31,0,0,1,.1.05.53.53,0,0,1,.06.13.86.86,0,0,1,0,.17.9.9,0,0,1,0,.28,3.21,3.21,0,0,1-.12.31l-.37.77.52-.29s0,0,0,0v0a.1.1,0,0,1,0,.08l-.63.36s0,0,0,0v0a.43.43,0,0,0,0-.05.24.24,0,0,0,0-.07l.4-.84a.71.71,0,0,0,.07-.16.61.61,0,0,0,.05-.12.44.44,0,0,0,0-.1s0-.07,0-.11a.28.28,0,0,0-.06-.21s-.1,0-.17,0a.52.52,0,0,0-.17.19,1,1,0,0,0-.07.29.08.08,0,0,1,0,.05s0,0,0,0l0,0S291.08,281.22,291.08,281.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,280.85a2.11,2.11,0,0,1,0-.26,1.82,1.82,0,0,1,.07-.25.71.71,0,0,1,.11-.21.61.61,0,0,1,.17-.15.28.28,0,0,1,.18-.05.18.18,0,0,1,.11.08.38.38,0,0,1,.06.17.93.93,0,0,1,0,.24,2.67,2.67,0,0,1,0,.4,2.28,2.28,0,0,1,0,.26,1,1,0,0,1-.06.25.78.78,0,0,1-.11.2.55.55,0,0,1-.18.16.25.25,0,0,1-.17.05.15.15,0,0,1-.11-.08.61.61,0,0,1-.07-.18,1.64,1.64,0,0,1,0-.23Zm.65-.36a.83.83,0,0,0-.07-.34q-.07-.11-.21,0a.45.45,0,0,0-.2.26,1.32,1.32,0,0,0-.07.42v.38a.66.66,0,0,0,.07.34c0,.07.11.08.2,0a.5.5,0,0,0,.21-.26,1.68,1.68,0,0,0,.07-.43v-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.6,302.5a1.1,1.1,0,0,1,0-.18l.06-.2a1.74,1.74,0,0,1,.11-.18.47.47,0,0,1,.15-.13.26.26,0,0,1,.15-.05.14.14,0,0,1,.1.05.23.23,0,0,1,.06.12.88.88,0,0,1,0,.17,1,1,0,0,1,0,.29,2.13,2.13,0,0,1-.12.31l-.36.77.51-.3s0,0,0,0v0s0,.06,0,.07l-.63.37s0,0,0,0v-.09l0-.07.4-.85.08-.15s0-.08,0-.12a.43.43,0,0,0,0-.11.34.34,0,0,0,0-.1.3.3,0,0,0-.06-.22s-.1,0-.17,0a.4.4,0,0,0-.17.19.82.82,0,0,0-.07.29.43.43,0,0,1,0,.05l0,0,0,0S289.6,302.53,289.6,302.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.48,302.15a1.18,1.18,0,0,1,0-.26,1.05,1.05,0,0,1,.06-.24.7.7,0,0,1,.11-.21.69.69,0,0,1,.18-.16.24.24,0,0,1,.17,0,.15.15,0,0,1,.11.08.38.38,0,0,1,.06.17,1.57,1.57,0,0,1,0,.24v.4a2.6,2.6,0,0,1,0,.26.94.94,0,0,1-.06.24.7.7,0,0,1-.11.21.87.87,0,0,1-.17.16.26.26,0,0,1-.18,0,.15.15,0,0,1-.11-.08.38.38,0,0,1-.06-.17.9.9,0,0,1,0-.24A2.67,2.67,0,0,1,290.48,302.15Zm.64-.36a.72.72,0,0,0-.07-.34c-.05-.07-.11-.08-.2,0a.46.46,0,0,0-.21.26,1.32,1.32,0,0,0-.07.42v.37a.71.71,0,0,0,.07.35c.05.07.11.08.21,0a.45.45,0,0,0,.2-.26,1.27,1.27,0,0,0,.07-.42v-.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.42,301.45a.55.55,0,0,1,0-.18.76.76,0,0,1,.06-.2,1.62,1.62,0,0,1,.1-.18.87.87,0,0,1,.15-.13.37.37,0,0,1,.15-.05.22.22,0,0,1,.11.05.33.33,0,0,1,.05.12,1,1,0,0,1,0,.17.92.92,0,0,1,0,.29,2.33,2.33,0,0,1-.13.31l-.36.77.52-.3s0,0,0,0v0a.1.1,0,0,1,0,.08l-.64.36s0,0,0,0v0a.11.11,0,0,1,0-.05.36.36,0,0,1,0-.07l.4-.84.07-.16a.56.56,0,0,0,0-.12.45.45,0,0,0,0-.11v-.1a.3.3,0,0,0-.06-.22s-.09,0-.17,0a.43.43,0,0,0-.16.19.89.89,0,0,0-.08.29.07.07,0,0,1,0,.05l0,0,0,0S291.42,301.48,291.42,301.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.67,301.86a.1.1,0,0,1,0,.08h0s0,0,0,0V300.5l-.28.49s0,0-.05,0v0a.08.08,0,0,1,0-.08l.33-.58,0,0h0l0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,199.21l17.59-10.16c.47-.27.86-.08.86.44a1.84,1.84,0,0,1-.86,1.42l-17.59,10.15c-.47.28-.86.08-.86-.43A1.84,1.84,0,0,1,303.25,199.21Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,199.21l17.59-10.16c.47-.27.86-.08.86.44a1.84,1.84,0,0,1-.86,1.42l-17.59,10.15c-.47.28-.86.08-.86-.43A1.84,1.84,0,0,1,303.25,199.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,205.67a.4.4,0,0,1-.2-.74l25.74-14.86a.39.39,0,0,1,.4.68l-25.74,14.87A.46.46,0,0,1,302.39,205.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,302.11,320.84,292c.47-.28.86-.08.86.43a1.84,1.84,0,0,1-.86,1.42L303.25,304c-.47.27-.86.08-.86-.44A1.84,1.84,0,0,1,303.25,302.11Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,302.11,320.84,292c.47-.28.86-.08.86.43a1.84,1.84,0,0,1-.86,1.42L303.25,304c-.47.27-.86.08-.86-.44A1.84,1.84,0,0,1,303.25,302.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,308.57a.39.39,0,0,1-.34-.2.39.39,0,0,1,.14-.54L327.93,293a.4.4,0,0,1,.4.69l-25.74,14.86A.35.35,0,0,1,302.39,308.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,266.82l17.59-10.16c.47-.27.86-.08.86.44a1.84,1.84,0,0,1-.86,1.42l-17.59,10.16c-.47.27-.86.08-.86-.44A1.84,1.84,0,0,1,303.25,266.82Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,266.82l17.59-10.16c.47-.27.86-.08.86.44a1.84,1.84,0,0,1-.86,1.42l-17.59,10.16c-.47.27-.86.08-.86-.44A1.84,1.84,0,0,1,303.25,266.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,273.28a.4.4,0,0,1-.2-.74l25.74-14.86a.4.4,0,0,1,.4.69l-25.74,14.86A.46.46,0,0,1,302.39,273.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,243.25l17.59-10.16c.47-.27.86-.08.86.44a1.84,1.84,0,0,1-.86,1.42l-17.59,10.16c-.47.27-.86.08-.86-.44A1.84,1.84,0,0,1,303.25,243.25Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,243.25l17.59-10.16c.47-.27.86-.08.86.44a1.84,1.84,0,0,1-.86,1.42l-17.59,10.16c-.47.27-.86.08-.86-.44A1.84,1.84,0,0,1,303.25,243.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,249.71a.4.4,0,0,1-.2-.74l25.74-14.86a.4.4,0,0,1,.4.69l-25.74,14.86A.46.46,0,0,1,302.39,249.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,212.21l17.59-10.16c.47-.27.86-.08.86.44a1.84,1.84,0,0,1-.86,1.42l-17.59,10.16c-.47.27-.86.08-.86-.44A1.84,1.84,0,0,1,303.25,212.21Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,212.21l17.59-10.16c.47-.27.86-.08.86.44a1.84,1.84,0,0,1-.86,1.42l-17.59,10.16c-.47.27-.86.08-.86-.44A1.84,1.84,0,0,1,303.25,212.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,218.67a.4.4,0,0,1-.2-.74l25.74-14.86a.4.4,0,0,1,.4.69l-25.74,14.86A.46.46,0,0,1,302.39,218.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,222a.41.41,0,0,1-.34-.2.39.39,0,0,1,.14-.54l25.74-14.86a.39.39,0,0,1,.4.68L302.59,222A.36.36,0,0,1,302.39,222Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,228l17.59-10.16c.47-.27.86-.08.86.43a1.86,1.86,0,0,1-.86,1.43l-17.59,10.15c-.47.28-.86.08-.86-.43A1.84,1.84,0,0,1,303.25,228Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,228l17.59-10.16c.47-.27.86-.08.86.43a1.86,1.86,0,0,1-.86,1.43l-17.59,10.15c-.47.28-.86.08-.86-.43A1.84,1.84,0,0,1,303.25,228Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,234.46a.4.4,0,0,1-.2-.74l25.74-14.86a.39.39,0,1,1,.4.68L302.59,234.4A.36.36,0,0,1,302.39,234.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,237.8a.4.4,0,0,1-.2-.74l25.74-14.86a.4.4,0,0,1,.4.69l-25.74,14.86A.35.35,0,0,1,302.39,237.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,252.72l17.59-10.15c.47-.28.86-.08.86.43a1.84,1.84,0,0,1-.86,1.42l-17.59,10.16c-.47.27-.86.08-.86-.44A1.84,1.84,0,0,1,303.25,252.72Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,252.72l17.59-10.15c.47-.28.86-.08.86.43a1.84,1.84,0,0,1-.86,1.42l-17.59,10.16c-.47.27-.86.08-.86-.44A1.84,1.84,0,0,1,303.25,252.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,259.18a.4.4,0,0,1-.2-.74l25.74-14.86a.4.4,0,0,1,.4.69l-25.74,14.86A.35.35,0,0,1,302.39,259.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,262.53a.4.4,0,0,1-.2-.74l25.74-14.86a.4.4,0,0,1,.4.69l-25.74,14.86A.46.46,0,0,1,302.39,262.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,279l17.59-10.15c.47-.27.86-.08.86.43a1.86,1.86,0,0,1-.86,1.43l-17.59,10.15c-.47.28-.86.08-.86-.43A1.88,1.88,0,0,1,303.25,279Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,279l17.59-10.15c.47-.27.86-.08.86.43a1.86,1.86,0,0,1-.86,1.43l-17.59,10.15c-.47.28-.86.08-.86-.43A1.88,1.88,0,0,1,303.25,279Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,285.45a.41.41,0,0,1-.34-.2.39.39,0,0,1,.14-.54l25.74-14.86a.39.39,0,1,1,.4.68l-25.74,14.86A.36.36,0,0,1,302.39,285.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,288.46l17.59-10.16c.47-.27.86-.08.86.43a1.85,1.85,0,0,1-.86,1.43l-17.59,10.15c-.47.28-.86.08-.86-.43A1.84,1.84,0,0,1,303.25,288.46Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,288.46l17.59-10.16c.47-.27.86-.08.86.43a1.85,1.85,0,0,1-.86,1.43l-17.59,10.15c-.47.28-.86.08-.86-.43A1.84,1.84,0,0,1,303.25,288.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,294.92a.4.4,0,0,1-.2-.74l25.74-14.86a.39.39,0,1,1,.4.68l-25.74,14.86A.36.36,0,0,1,302.39,294.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,298.26a.4.4,0,0,1-.34-.19.39.39,0,0,1,.14-.54l25.74-14.87a.4.4,0,0,1,.4.69l-25.74,14.86A.35.35,0,0,1,302.39,298.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.67,159.17c2.36-.43,5.84-.18,7.59,1.62v3.88L307.2,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.21,161.32c-1.12-1.2-2.85-2.2-3.54-2.15-2.33.52-4.43,1.06-6.49,1.67-4.55,1.34-10.24,5.91-12.53,7.72a10.55,10.55,0,0,0-1.89,4.52c-.1,2.63.07,8,.07,8l27-15.58A11.78,11.78,0,0,0,307.21,161.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,174.46c.56-1.93,1.76-4.5,5.75-7,2.71,2.21,2.5,5.66,2.72,10.21l-8.47,4.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.5,142.47c-2.85,3.61-.82,7.23.2,10.66,1.19,3.89,1.67,5.36,3,5.84-.84-10,1.71-3.61,7.24-6.38a15.18,15.18,0,0,0,5.27-5.38,14.8,14.8,0,0,1,.69-1.51,2.86,2.86,0,0,0,.74-4.19,1.61,1.61,0,0,0,0-3.2c1.27-1.47.89-3.68-.18-4.29a1.9,1.9,0,0,0-2,.19,11.34,11.34,0,0,1-2.54,1.18c-2.24.62-4.22.74-6.49,1.29C291.43,137.38,288.31,139.11,288.5,142.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.53,156.83c1.31.62,2.41-1.17,2.41-1.17l.66,8.59s1.56,2.94,6.3,3.42c2.8.28,7-1.53,2-6.08l-.13-2.62a12.36,12.36,0,0,0,2.55-.93c1.21-.69,2-1.89,2.43-4,.67-3.36.34-8.07-.9-13.95-2,2.12-6.43-1.1-10.09,2.89,1,1.95-.44,5.56-1.74,6.3.42,1.7.2,2.52-.29,2.7-.87.32-1.45-.86-2-1.33s-2.13-.85-2.86,1.28A4.22,4.22,0,0,0,288.53,156.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.76,159c-1.54.36-4.49.24-5.64-.68a8.67,8.67,0,0,1-1.91-2.27,5.38,5.38,0,0,0,1.69,3.14c2.36,1.86,5.93,1.11,5.93,1.11Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.64,146l-1.51,1.5a1.31,1.31,0,0,1,.25-1.55A.78.78,0,0,1,296.64,146Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.49,144.12l-1.82-.11a1.12,1.12,0,0,1,1.08-1A.89.89,0,0,1,303.49,144.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,148.64a.63.63,0,0,0,.8.64,1.09,1.09,0,0,0,.7-1.08.63.63,0,0,0-.8-.63A1.08,1.08,0,0,0,296,148.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,146.65a.63.63,0,0,0,.8.63,1.08,1.08,0,0,0,.7-1.07.62.62,0,0,0-.8-.63A1.08,1.08,0,0,0,301.81,146.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.92,146.79l1.09,5,2.47-1.77C301.52,148.59,300,147.1,298.92,146.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.05,153.54l2.69.14a1.28,1.28,0,0,1-1.35,1.23A1.36,1.36,0,0,1,298.05,153.54Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,154.91a1.29,1.29,0,0,0,.66-.15,1.61,1.61,0,0,0-1.45-.93,1.59,1.59,0,0,0-.5.09A1.42,1.42,0,0,0,299.39,154.91Z",
    style: {
      fill: "#f28f8f"
    }
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,183a.55.55,0,0,1-.25-.07.5.5,0,0,1-.25-.43V138.68a.5.5,0,0,1,.25-.44L311,120.38a.5.5,0,0,1,.5,0,.48.48,0,0,1,.25.43v43.86a.48.48,0,0,1-.25.43L280.58,183A.59.59,0,0,1,280.33,183Zm.5-44.07v42.7l29.93-17.28v-42.7Z",
    style: {
      fill: "#46C5FB"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.45,99.21l-22.22,12.85a1.76,1.76,0,0,0-.79,1.38V140.6a1.73,1.73,0,0,0,.79,1.37l3.16,1.79a1.78,1.78,0,0,0,1.59,0l22.23-12.85a1.79,1.79,0,0,0,.79-1.38V102.36a1.74,1.74,0,0,0-.8-1.37L453,99.2A1.75,1.75,0,0,0,451.45,99.21Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,143.75a1.78,1.78,0,0,1-1.59,0l-3.16-1.8a1.72,1.72,0,0,1-.79-1.36V113.44a1.54,1.54,0,0,1,.25-.81l4.73,2.72c-.14.25-.23.53-.23.1v27.16C433.19,143.76,433.51,144,434,143.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,102.22c-.06-.4-.39-.55-.79-.32L434,114.76a1.68,1.68,0,0,0-.56.59l-4.74-2.72a1.67,1.67,0,0,1,.55-.57l22.23-12.85a1.75,1.75,0,0,1,1.59,0L456.2,101A1.77,1.77,0,0,1,457,102.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.21,101.9,434,114.76a1.74,1.74,0,0,0-.79,1.37v8.8l-7.06,7.54a.7.7,0,0,0,.45,1.21l6.61-.48h0v10.09c0,.51.35.71.79.46l22.23-12.85a1.79,1.79,0,0,0,.79-1.38V102.36C457,101.85,456.64,101.65,456.21,101.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.26,133.58c-.5-.3-4.29-2.44-4.42-2.51a.74.74,0,0,1-.15-1.13l6.75-7.74,4.75,2.73-7.06,7.54A.75.75,0,0,0,426.26,133.58Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--X--inject-88",
    d: "M451.8,126l-4.52-3.41,4.71-9a1.71,1.71,0,0,0-3-1.58l-4.44,8.48-4.06-3.08a1.71,1.71,0,1,0-2.06,2.73l4.52,3.42-4.51,8.6a1.71,1.71,0,0,0,.72,2.3,1.65,1.65,0,0,0,.79.2,1.71,1.71,0,0,0,1.52-.92l4.24-8.1,4.06,3.08a1.72,1.72,0,0,0,1,.34,1.67,1.67,0,0,0,1.36-.68A1.7,1.7,0,0,0,451.8,126Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.45,51.36,429.23,64.21c-.44.26-.79.87-.79,2.06V93.43c0-.17.35.44.79.68l3.16,1.8a1.78,1.78,0,0,0,1.59,0l22.23-12.85a1.79,1.79,0,0,0,.79-1.38V54.51a1.74,1.74,0,0,0-.8-1.37L453,51.35A1.75,1.75,0,0,0,451.45,51.36Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,95.9a1.81,1.81,0,0,1-1.59,0l-3.16-1.8c-.43-.24-.79-.86-.79-.68V66.27a2.54,2.54,0,0,1,.25-1.49l4.73,2.72c-.14.25-.23.53-.23.1V94.76C433.19,95.9,433.51,96.17,434,95.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,54.37c-.06-.4-.39-.55-.79-.32L434,66.91a1.68,1.68,0,0,0-.56.59l-4.74-2.72a1.67,1.67,0,0,1,.55-.57l22.23-12.85a1.75,1.75,0,0,1,1.59,0l3.15,1.79A1.77,1.77,0,0,1,457,54.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.26,85.73c-.5-.3-4.29-2.44-4.42-2.51a.74.74,0,0,1-.15-1.13l6.75-7.74,4.75,2.73-7.06,7.54A.75.75,0,0,0,426.26,85.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.26,85.73c-.5-.3-4.29-2.44-4.42-2.51a.74.74,0,0,1-.15-1.13l6.75-7.74,4.75,2.73-7.06,7.54A.75.75,0,0,0,426.26,85.73Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.21,54.05,434,66.91a1.74,1.74,0,0,0-.79,1.37v8.8l-7.06,7.54a.7.7,0,0,0,.45,1.21l6.61-.48h0V95.44c0,.51.35.71.79.46l22.23-12.85a1.79,1.79,0,0,0,.79-1.38V54.51C457,54,456.64,53.8,456.21,54.05Z",
    style: {
      fill: "#46C5FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-88",
    d: "M452.08,61.64a2,2,0,0,0-2.58,1L442,80.45l-1.77-1.73a2,2,0,1,0-2.75,2.83l3.85,3.75a2,2,0,0,0,1.37.55,1.87,1.87,0,0,0,.4,0,2,2,0,0,0,1.42-1.16l8.59-20.43A2,2,0,0,0,452.08,61.64Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.45,147.06l-22.22,12.85c-.44.26-.79.87-.79,2.06v27.16c0-.17.35.44.79.69l3.16,1.79a1.75,1.75,0,0,0,1.59,0l22.23-12.85a1.79,1.79,0,0,0,.79-1.38V150.21a1.75,1.75,0,0,0-.8-1.37L453,147.05A1.78,1.78,0,0,0,451.45,147.06Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,191.6a1.78,1.78,0,0,1-1.59,0l-3.16-1.8c-.43-.24-.79-.85-.79-.68V162a2.54,2.54,0,0,1,.25-1.49l4.73,2.72c-.14.25-.23.53-.23.1v27.16C433.19,191.61,433.51,191.87,434,191.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,150.07c-.06-.4-.39-.55-.79-.32L434,162.61a1.68,1.68,0,0,0-.56.59l-4.74-2.72a1.67,1.67,0,0,1,.55-.57l22.23-12.85a1.75,1.75,0,0,1,1.59,0l3.15,1.79A1.77,1.77,0,0,1,457,150.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.26,181.43c-.5-.3-4.29-2.44-4.42-2.51a.74.74,0,0,1-.15-1.13l6.75-7.74,4.75,2.73-7.06,7.54A.75.75,0,0,0,426.26,181.43Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.26,181.43c-.5-.3-4.29-2.44-4.42-2.51a.74.74,0,0,1-.15-1.13l6.75-7.74,4.75,2.73-7.06,7.54A.75.75,0,0,0,426.26,181.43Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.21,149.75,434,162.61a1.74,1.74,0,0,0-.79,1.37v8.8l-7.06,7.54a.7.7,0,0,0,.45,1.21l6.61-.48h0v10.09c0,.51.35.72.79.46l22.23-12.85a1.79,1.79,0,0,0,.79-1.38V150.21C457,149.71,456.64,149.5,456.21,149.75Z",
    style: {
      fill: "#46C5FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--check--inject-88",
    d: "M452.08,157.34a2,2,0,0,0-2.58,1L442,176.15l-1.77-1.73a2,2,0,0,0-2.75,2.83l3.85,3.75a2,2,0,0,0,1.37.55l.4,0a2,2,0,0,0,1.42-1.17l8.59-20.43A2,2,0,0,0,452.08,157.34Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.45,194.91l-22.22,12.85c-.44.26-.79.87-.79,2.06V237c0-.17.35.44.79.69l3.16,1.79a1.75,1.75,0,0,0,1.59,0l22.23-12.85a1.79,1.79,0,0,0,.79-1.38V198.06a1.72,1.72,0,0,0-.8-1.36L453,194.9A1.78,1.78,0,0,0,451.45,194.91Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,239.45a1.78,1.78,0,0,1-1.59,0l-3.16-1.8c-.43-.24-.79-.85-.79-.68V209.82a2.57,2.57,0,0,1,.25-1.49l4.73,2.72c-.14.25-.23.53-.23.1v27.16C433.19,239.46,433.51,239.72,434,239.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,197.92c-.06-.4-.39-.54-.79-.32L434,210.46a1.68,1.68,0,0,0-.56.59l-4.74-2.72a1.77,1.77,0,0,1,.55-.57l22.23-12.85a1.75,1.75,0,0,1,1.59,0l3.15,1.79A1.77,1.77,0,0,1,457,197.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.26,229.28c-.5-.3-4.29-2.44-4.42-2.51a.74.74,0,0,1-.15-1.13l6.75-7.74,4.75,2.73-7.06,7.54A.75.75,0,0,0,426.26,229.28Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.26,229.28c-.5-.3-4.29-2.44-4.42-2.51a.74.74,0,0,1-.15-1.13l6.75-7.74,4.75,2.73-7.06,7.54A.75.75,0,0,0,426.26,229.28Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.21,197.6,434,210.46a1.74,1.74,0,0,0-.79,1.37v8.8l-7.06,7.54a.7.7,0,0,0,.45,1.21l6.61-.48h0V239c0,.51.35.72.79.46l22.23-12.85a1.79,1.79,0,0,0,.79-1.38V198.06C457,197.56,456.64,197.35,456.21,197.6Z",
    style: {
      fill: "#46C5FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--check--inject-88",
    d: "M452.08,205.19a2,2,0,0,0-2.58,1.05L442,224l-1.77-1.73a2,2,0,1,0-2.75,2.83l3.85,3.75a2,2,0,0,0,1.37.55l.4,0a2,2,0,0,0,1.42-1.17l8.59-20.43A2,2,0,0,0,452.08,205.19Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--icons--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--team-icon--inject-88",
    d: "M46.7,128.77c3.53-2,6.38-7.5,6.38-12.2s-2.85-6.86-6.38-4.82-6.38,7.49-6.38,12.19S43.18,130.8,46.7,128.77Zm11.07,4.32c-.64-3.67-3.32-5-6.42-3.22l-9.3,5.37c-3.1,1.79-5.77,6.22-6.42,10.63l-1.14,7.77c-.23,1.54.58,2.41,1.66,1.78l21.1-12.18a4,4,0,0,0,1.66-3.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--team-icon--inject-88",
    d: "M82.53,108.08c3.52-2,6.38-7.49,6.38-12.19S86.05,89,82.53,91.06s-6.38,7.5-6.38,12.2S79,110.11,82.53,108.08ZM93.6,112.4c-.65-3.67-3.32-5-6.42-3.22l-9.3,5.37c-3.1,1.79-5.78,6.22-6.42,10.64L70.32,133c-.23,1.54.58,2.4,1.66,1.78l21.1-12.18a4,4,0,0,0,1.66-3.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--team-icon--inject-88",
    d: "M118.34,87.39c3.53-2,6.39-7.49,6.39-12.19s-2.86-6.86-6.39-4.82S112,77.87,112,82.57,114.82,89.43,118.34,87.39Zm11.08,4.32c-.65-3.66-3.33-5-6.43-3.21l-9.3,5.36c-3.09,1.79-5.77,6.23-6.42,10.64l-1.14,7.77c-.22,1.54.58,2.41,1.66,1.78l21.1-12.18a4,4,0,0,0,1.66-3.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--team-icon--inject-88",
    d: "M154.19,66.71c3.52-2,6.38-7.5,6.38-12.19s-2.86-6.86-6.38-4.83-6.39,7.49-6.39,12.19S150.66,68.74,154.19,66.71ZM165.26,71c-.65-3.67-3.33-5-6.42-3.22l-9.3,5.37c-3.1,1.79-5.78,6.22-6.43,10.64L142,91.59c-.22,1.54.59,2.4,1.67,1.78l21.09-12.18a4,4,0,0,0,1.67-3.7Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--team-icon--inject-88",
    d: "M190,46c3.52-2,6.38-7.49,6.38-12.19S193.52,27,190,29s-6.39,7.49-6.39,12.19S186.47,48.06,190,46Zm11.07,4.32c-.65-3.66-3.33-5-6.42-3.22l-9.3,5.37c-3.1,1.79-5.78,6.23-6.43,10.64l-1.13,7.77c-.23,1.54.58,2.4,1.66,1.78l21.1-12.18a4,4,0,0,0,1.66-3.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.48,338.74h0v0l20.26-54.47h0l0-.07h0c.51-1.27.21-2.88-1-4.54a14.71,14.71,0,0,0-12.25-5.24c-2.11.25-3.51,1.17-4,2.46l-25.54,52h0a12.34,12.34,0,1,0,22.59,9.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.43,276.84l-25.54,52a12.32,12.32,0,0,0,11.76,17.63c-4.13-.46-8.33-6.72-4.67-15.51s19.44-41.6,25.84-56.43a11.46,11.46,0,0,0-3.34-.12C51.37,274.63,50,275.55,49.43,276.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,279.6a14.73,14.73,0,0,0-12.26-5.22c-2,.25-3.41,1.12-4,2.34-.43.89-2.11,4.28-2.56,5.2-.65,1.34-.37,3.1,1,4.91a15.15,15.15,0,0,0,12.63,5.39c2.25-.27,3.71-1.28,4.23-2.67.36-1,2-5.39,2-5.39C67.3,282.89,67,281.27,65.72,279.6Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,279.6c2.55,3.39,1.2,6.56-3,7.07a14.67,14.67,0,0,1-12.25-5.22c-2.55-3.39-1.21-6.56,3-7.07A14.73,14.73,0,0,1,65.72,279.6Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,279.6c2.55,3.39,1.2,6.56-3,7.07a14.67,14.67,0,0,1-12.25-5.22c-2.55-3.39-1.21-6.56,3-7.07A14.73,14.73,0,0,1,65.72,279.6Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.93,256.17A9.74,9.74,0,0,1,72,259.65a3.08,3.08,0,0,1,.68,3h0v0h0l-8.44,19.72h0a3.13,3.13,0,0,1-2.68,1.61,9.76,9.76,0,0,1-8.11-3.47,3.11,3.11,0,0,1-.68-3.07h0l8.43-19.71h0A3.12,3.12,0,0,1,63.93,256.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.24,257.81a3.12,3.12,0,0,1,2.69-1.64,8.47,8.47,0,0,1,3.37.37L56.05,282.76a8.43,8.43,0,0,1-2.56-2.17,3.11,3.11,0,0,1-.68-3.07l8.43-19.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.91,155.47l-15.18-8.76c-8.25-4.76-19.64-4.08-32.21,3.19C61.36,164.42,41,199.74,41,228.79c0,14.53,5.09,24.73,13.34,29.49l15.18,8.77h0c8.24,4.76,19.63,4.07,32.21-3.19,25.16-14.53,45.55-49.85,45.55-78.9,0-14.52-5.1-24.73-13.34-29.49ZM72.6,261.65c-6.59-3.8-10.22-12.36-10.22-24.09,0-13,4.44-27.81,12.51-41.78s18.69-25.24,29.93-31.72c10.15-5.87,19.38-7,26-3.19S141,173.23,141,185c0,13-4.44,27.81-12.51,41.78S109.82,252,98.58,258.46C88.43,264.33,79.2,265.46,72.6,261.65Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.91,155.47l-15.18-8.76c-8.25-4.76-19.64-4.08-32.21,3.19C61.36,164.42,41,199.74,41,228.79c0,14.53,5.09,24.73,13.34,29.49l15.18,8.77h0c8.24,4.76,19.63,4.07,32.21-3.19,25.16-14.53,45.55-49.85,45.55-78.9,0-14.52-5.1-24.73-13.34-29.49ZM72.6,261.65c-6.59-3.8-10.22-12.36-10.22-24.09,0-13,4.44-27.81,12.51-41.78s18.69-25.24,29.93-31.72c10.15-5.87,19.38-7,26-3.19S141,173.23,141,185c0,13-4.44,27.81-12.51,41.78S109.82,252,98.58,258.46C88.43,264.33,79.2,265.46,72.6,261.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.44,263.84a17.73,17.73,0,0,1-9.84-2.19c-6.59-3.8-10.22-12.36-10.22-24.09a69.66,69.66,0,0,1,2.3-17.14l-20.76-12a77.14,77.14,0,0,0-3,20.35c0,14.53,5.09,24.73,13.34,29.49l15.18,8.77a23.92,23.92,0,0,0,13.23,3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.91,155.47h0l-15.18-8.76c-8.25-4.76-19.64-4.08-32.21,3.19a71.19,71.19,0,0,0-10,7L97.41,169.1a63.74,63.74,0,0,1,7.4-5c10.16-5.87,19.39-7,26-3.19a16.9,16.9,0,0,1,5.57,5.32l6-2.17A23.47,23.47,0,0,0,133.91,155.47Z",
    style: {
      fill: "#46C5FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.7,263.86C126.85,249.34,147.25,214,147.25,185s-20.4-40.83-45.55-26.3-45.55,49.84-45.55,78.89S76.54,278.39,101.7,263.86Zm-39.32-26.3c0-13,4.44-27.81,12.5-41.78s18.7-25.23,29.93-31.72c10.16-5.86,19.39-7,26-3.19S141,173.24,141,185c0,13-4.44,27.81-12.51,41.78S109.82,252,98.58,258.47c-10.16,5.86-19.38,7-26,3.19S62.38,249.29,62.38,237.56Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,170.73a28.44,28.44,0,0,0-7.23-12.37,22.5,22.5,0,0,0-13-6A33.38,33.38,0,0,0,110.85,154a54.25,54.25,0,0,0-6.68,2.81c-1.07.56-2.14,1.12-3.17,1.75l-3.06,1.94a30.25,30.25,0,0,0-3,2.09c-1,.72-1.94,1.44-2.89,2.18l-2.72,2.38L88,168.38c-.45.4-.86.84-1.29,1.26a106.41,106.41,0,0,0-28.56,49.47c-.15.58-.32,1.16-.45,1.75l-.35,1.77-.69,3.55c-.17,1.2-.3,2.4-.45,3.59a31.24,31.24,0,0,0-.33,3.61L55.74,237c0,1.21,0,2.42.07,3.62a54.5,54.5,0,0,0,.91,7.2,33.25,33.25,0,0,0,5.67,13.26,22.51,22.51,0,0,0,11.72,8.23,28.51,28.51,0,0,0,14.33.07,49.09,49.09,0,0,0,13.26-5.51,48.85,48.85,0,0,1-13.32,5.27,28.06,28.06,0,0,1-14.13-.3,22.07,22.07,0,0,1-11.36-8.13,32.65,32.65,0,0,1-5.42-13,54.72,54.72,0,0,1-.71-14.23,30.59,30.59,0,0,1,.33-3.56c.15-1.18.28-2.37.45-3.55l.7-3.51.35-1.75c.13-.58.3-1.15.45-1.73a107.89,107.89,0,0,1,28.31-49c.43-.41.84-.85,1.28-1.25L90,167.86l2.69-2.36c.94-.74,1.9-1.45,2.85-2.17a32.67,32.67,0,0,1,2.91-2.07,54.83,54.83,0,0,1,12.68-6.49,32.63,32.63,0,0,1,14-1.83,22,22,0,0,1,12.72,5.77,28.26,28.26,0,0,1,7.33,12.09A49.1,49.1,0,0,1,147.25,185,48.92,48.92,0,0,0,145.39,170.73Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6,261.66a17.33,17.33,0,0,1-6.34-6.56c5.11,0,10.95-1.82,17.14-5.41C94.63,243.22,105.27,232,113.33,218s12.51-28.81,12.5-41.78c0-7.14-1.34-13.11-3.88-17.55a17.39,17.39,0,0,1,8.85,2.22c6.59,3.8,10.22,12.36,10.22,24.1,0,13-4.44,27.81-12.5,41.77S109.81,252,98.59,258.47C88.42,264.34,79.19,265.47,72.6,261.66Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6,261.66a17.33,17.33,0,0,1-6.34-6.56c5.11,0,10.95-1.82,17.14-5.41C94.63,243.22,105.27,232,113.33,218s12.51-28.81,12.5-41.78c0-7.14-1.34-13.11-3.88-17.55a17.39,17.39,0,0,1,8.85,2.22c6.59,3.8,10.22,12.36,10.22,24.1,0,13-4.44,27.81-12.5,41.77S109.81,252,98.59,258.47C88.42,264.34,79.19,265.47,72.6,261.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,185c0-11.74-3.63-20.3-10.22-24.1a17.39,17.39,0,0,0-8.85-2.22c2.54,4.44,3.89,10.41,3.88,17.55a63.8,63.8,0,0,1-.67,9c.4-2.6,2.07-10.34,6.92-4.37,5.76,7.1,5.79,25.52,1.26,36.43v0C138.33,206.24,141,195,141,185Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.71,254.5c11.23-6.49,21.86-17.75,29.93-31.72S134.14,194,134.14,181c0-9.68-2.47-17.19-7-21.66-6.16-1.73-13.91-.12-22.29,4.72C93.58,170.55,83,181.81,74.88,195.78s-12.5,28.81-12.5,41.78c0,9.68,2.48,17.19,7,21.66C75.58,261,83.33,259.34,91.71,254.5Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.83,409.47c0,1.33.25,1.84-1.39,3s-5.17,1.75-7.86,1a7.26,7.26,0,0,1-4.35-2.63,34.83,34.83,0,0,1-2.52-3.8c-.48-.6-2.66-1.75-4.78-2.69s-6.48-3-8-6.57a8.54,8.54,0,0,1-.47-6.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.61,391.15c4.31,2.81,7.93,9.88,13.83,7.73.29,3.46,1.21,7.19.39,10.59-2.51,3.1-8,3.69-11.18,1.46-1.59-1.36-2.48-2.95-4-4.38a15.44,15.44,0,0,0-4.23-2.59,44.25,44.25,0,0,1-5.12-2.83C366.75,394.11,371.47,381.25,386.61,391.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.43,429.61c0,1.45-.1,2.53-1,3.14s-7.48,1.7-9.24,1.91-2-1-3.24-.55-4.1,2.51-8.41,3.47-7.83,2-13.8,0-6.57-4.29-6.49-6.31S371.43,429.61,371.43,429.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.57,416.13c1,4.14,2,10.33.86,13.48-1.2,1.2-5.24,1.9-8.76,2.37a27.35,27.35,0,0,0-9.31,2.9c-6.83,2.85-18.84,3.89-23.63-2.54-4.78-8.58,20.09-6.47,23.14-16.4C354,412.32,366.05,417.1,370.57,416.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74,363.34c-3.33-35.29-1.61-63.49-4.79-91.91,0,0-47.09-5.43-48.31,11.4s-1.43,64.22-1,71.64c.18,7.51,2.88,58.32,2.88,63.62,12.32,6.11,19.95,1.49,19.95,1.49-.08-6.83,5.27-37.36,2.37-54l2-32.5s8.45,54.88,9.87,68.55c3.64,5.39,14,4.13,15.68.88C401.32,402.48,403.9,373.73,402.74,363.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.77,333.05,378,305.8s9.34-1.72,14.74-8.48c-1.47,5.41-7.34,10.1-11.05,11.42l-3.71,23.13,1.54,25.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.36,327.7c.58,9.35,1.19,19,2,23.57,1.28,7.12,4.88,44.57,5.72,53.44-.28-.09-.56-.19-.83-.3-.91-9.5-4.42-46-5.67-53-.83-4.6-1.43-14.29-2-23.66-.44-7.05-.85-13.71-1.32-17.17l.8-.11C381.5,314,381.92,320.63,382.36,327.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.74,420.45c-1.07-16-3.62-56.23-3.41-72.39.24-19.31.89-53.55,2.46-66l.79.1c-1.56,12.43-2.21,46.64-2.45,65.93-.21,16.22,2.37,56.78,3.42,72.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,301.88c-4.37-4.39-3.76-13.6-3.37-19.34,0-.48.06-.93.08-1.36l-.79-.05c0,.43-.06.88-.09,1.36-.41,6.12-1.08,16.09,4.17,20.51Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-88"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "368.39 211.79 370.04 223.88 386.46 223.04 384.68 209.96 368.39 211.79",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.85,189.2c-1.26,1.6-5.18,6.44-5.33,7.37l3.2,2Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,177c-5.07-.54-8.36,3.05-9.83,13.85a27.79,27.79,0,0,0-1.16,2.7c-2,6.93-.9,13.53.27,15.28,2.94,2.36,6.21,3.25,10.94,2.84,3.61-.3,12.81-1.4,17.47-6.27,5.49-5.73,8.26-14.36,4.36-18.84C387.55,180.29,373.78,177.35,371,177Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.26,208.87c.65,1,4.67,3.06,8.15,3.06l-.25-1.78A30.65,30.65,0,0,1,360.26,208.87Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.12,196.32a.92.92,0,0,0,1.66.27,12,12,0,0,1,1.8-2.09,4.56,4.56,0,0,1,3.07-1c4.15.32,3.14,5.79,1.1,7.7-3.34,3.12-5.12.43-5.12.43s-2.4,5.29,1.1,8.39c0,0,6,2.61,10.77,1.14a100.94,100.94,0,0,0,8.31-9.52c5.64-7.79,6.38-17.55,2.76-19.76.2-2.76-1.29-6.91-7-9.31-5.4-2.29-9-2.06-12.93-1.84s-8.72,2-12.34-1a7.42,7.42,0,0,0,.6,6.77,2.45,2.45,0,0,0-2.12,4.42,1.94,1.94,0,0,0-.89,2.29,2.33,2.33,0,0,0,2,1.5,10.12,10.12,0,0,0,2.46-.15c1.14,3.19,4.75,4.31,6.89,4.17C369.86,191.59,369.57,194.83,370.12,196.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.75,216.68c6.1-.28,12.15,1.52,15.85,10,3.51,8,8.43,19.62,10.24,25.45.89,2.85,2.5,5.4-2.8,10.41a83.93,83.93,0,0,1-16.28,11.6l-5.33-11.42,7.39-8.49-2.73-7.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.82,254.24a14.71,14.71,0,0,0,5.89,4.66c-2.35.57-6.3-1.81-7.08-3.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.14,218.5c4.26,2.38,7.5,10.34,7.18,17-.19,4.2-1.67,15.05-2.93,24.65-.4,3,.81,8.12,1.36,14.25.42,4.55.93,13.11.93,13.11s-6.16,6.68-21.83,7.6c-20,1.17-29.42-4.15-29.42-4.15s.45-19.14.93-32c.71-19.13.75-24.73,3.74-31.24,1-1.93,2-6.22,5.29-7.06,2.58-.67,8.53-2.1,10.89-2.46,3.86,1,13.89,1.08,16.37-1l0-.56C389.91,216.5,390.52,217,393.14,218.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.08,219.19c1.58-1.83,2.43-4.17,3.55-4.56,0,0,5.32,2.45,10.59,1.64s5.87-2.18,5.87-2.18l-.17-1.2a2.51,2.51,0,0,1,1.28,1.19,17.38,17.38,0,0,0,1.91,2.74s-.28,4.09-9.09,4.71C369.2,222.22,365.08,219.19,365.08,219.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309,209.77c-.91-3.4-1.52-4.93-2.33-6s-3.24-5.49-4.36-6.93c-.7-.92-2.17.2-1.81,2.06a39.94,39.94,0,0,0,2.32,5.49c.56,1.32.64,5.2.64,5.2Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,224.57c-1.11-1.94-1.35-9.65-1.68-12-.44-3.22-1.54-3.7-2.59-4.3-3.42-1.95-4.29-2.22-5.26-2.32a1.76,1.76,0,0,0-1.54.72c-.89-.54-2.09-1.53-3.3-.32a4.44,4.44,0,0,0-.89,1,1.08,1.08,0,0,0-.77-.12c-1.29.25-2.27,3.88-2.06,5.12.16.87.85,1.51,1.92,2.14.91.54,1.19-.6,1.19-.6l1.1,1c1.09,3.73-1.55,7.33,1.13,10.7a28.16,28.16,0,0,1,3.4,4c5.57,10.52,11.54,20.47,13.6,23.21l8.84-12.89S312.66,226.51,311.54,224.57Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.47,206.66l4.21,2.13-3.74-2.57A1.65,1.65,0,0,0,300.47,206.66Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.28,207.38l4.61,2.75-4.23-3.24A2.44,2.44,0,0,0,296.28,207.38Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.66,214.9a11.13,11.13,0,0,1-.28-1.32,2.1,2.1,0,0,1,.11-1.21s-.91-.75-1.33-1.2a5.2,5.2,0,0,1-.48-.65,2.05,2.05,0,0,1-.3-.87,1.71,1.71,0,0,0,.18.94,2.94,2.94,0,0,0,.45.71l-.17.72a1,1,0,0,0-.56-.19,1.39,1.39,0,0,0-.8.26,1.56,1.56,0,0,1,.79-.12,1.09,1.09,0,0,1,.64.34,2.31,2.31,0,0,1,.65,1.61Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.39,220.6c-9.76,1-11.89,4.16-14,5.92-6.71,5.67-18.24,14.53-18.24,14.53l-8.75-9.35s-1.84-.16-4.93,2.5-3.95,7.55-3.95,7.55,5.67,10.56,6.84,12.49c5.36,8.84,9.81,7.49,12.47,6.25,8.5-4,23.77-13.45,26.16-15C358.62,242.65,362.05,228.08,358.39,220.6Z",
    style: {
      fill: "#37474f"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.fd2c7b700340b2bb3526bcf0161adfa7.svg";
export { ForwardRef as ReactComponent };